webpackJsonp([116],{

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(433);

// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(190);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/shareFunctions.js
var mapOptions = function mapOptions(data) {
    var options = [];
    options = data.map(function (d) {
        return {
            value: d.id,
            text: d.name
        };
    });
    return options;
};
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["c" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return api["e" /* REDIRECT_O365_URI */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return api["d" /* CORE_GOOGLE_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* API_MAP_KEY */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api["b" /* CLIENT_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return api["g" /* VERSION_NO */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return api["f" /* SYSTEM_NAME */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return auth["a" /* TOKEN */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return auth["b" /* USER_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["c" /* authentication */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["x" /* setO365TokenCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["z" /* setUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return auth["v" /* getUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return auth["d" /* clearToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return auth["e" /* getAllCookies */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return auth["r" /* getModules */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["s" /* getToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return auth["u" /* getUserId */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return auth["h" /* getFullName */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return auth["f" /* getCostCenterName */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return auth["g" /* getEmail */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return auth["q" /* getIsNpiAdmin */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return auth["o" /* getIsAdminTraining */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return auth["n" /* getIsAdminCarReservation */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return auth["m" /* getIsAdmin */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return auth["p" /* getIsDriver */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return auth["k" /* getIsAccessMyTracker */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return auth["l" /* getIsAccessMyTraining */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return auth["j" /* getIsAccessMyCarReservation */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return auth["i" /* getIsAccessAdminTracker */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "A", function() { return auth["w" /* setModule */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "B", function() { return auth["y" /* setUrlIncoming */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return auth["t" /* getUrlIncoming */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return mapOptions; });





/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOKEN; });
/* unused harmony export EXPIRES_ON */
/* unused harmony export EXPIRES_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_ID; });
/* unused harmony export FULL_NAME */
/* unused harmony export ROLE */
/* unused harmony export EMAIL */
/* unused harmony export O365_TOKEN */
/* unused harmony export USER_IMAGE */
/* unused harmony export IS_NPI_ADMIN */
/* unused harmony export IS_ADMIN */
/* unused harmony export SYSTEM_INFO */
/* unused harmony export IS_ADMIN_TRACKER */
/* unused harmony export IS_ADMIN_TRAINING */
/* unused harmony export IS_ADMIN_CAR_RESERVATION */
/* unused harmony export EMP_ID */
/* unused harmony export IS_ACCESS_MY_TRACKER */
/* unused harmony export IS_ACCESS_MY_TRAINING */
/* unused harmony export IS_ACCESS_MY_CAR_RESERVATION */
/* unused harmony export IS_DRIVER */
/* unused harmony export MODULES */
/* unused harmony export COST_CENTER_NAME */
/* unused harmony export MODULE_NAME */
/* unused harmony export URL_INCOMING */
/* harmony export (immutable) */ __webpack_exports__["c"] = authentication;
/* harmony export (immutable) */ __webpack_exports__["x"] = setO365TokenCookie;
/* unused harmony export getO365Token */
/* harmony export (immutable) */ __webpack_exports__["z"] = setUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["v"] = getUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAllCookies;
/* harmony export (immutable) */ __webpack_exports__["r"] = getModules;
/* harmony export (immutable) */ __webpack_exports__["s"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["u"] = getUserId;
/* harmony export (immutable) */ __webpack_exports__["h"] = getFullName;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCostCenterName;
/* harmony export (immutable) */ __webpack_exports__["g"] = getEmail;
/* unused harmony export getRole */
/* unused harmony export getExpireDate */
/* harmony export (immutable) */ __webpack_exports__["q"] = getIsNpiAdmin;
/* harmony export (immutable) */ __webpack_exports__["o"] = getIsAdminTraining;
/* harmony export (immutable) */ __webpack_exports__["n"] = getIsAdminCarReservation;
/* harmony export (immutable) */ __webpack_exports__["m"] = getIsAdmin;
/* harmony export (immutable) */ __webpack_exports__["p"] = getIsDriver;
/* harmony export (immutable) */ __webpack_exports__["k"] = getIsAccessMyTracker;
/* harmony export (immutable) */ __webpack_exports__["l"] = getIsAccessMyTraining;
/* harmony export (immutable) */ __webpack_exports__["j"] = getIsAccessMyCarReservation;
/* harmony export (immutable) */ __webpack_exports__["i"] = getIsAccessAdminTracker;
/* unused harmony export setSystemInfo */
/* unused harmony export getSystemInfo */
/* harmony export (immutable) */ __webpack_exports__["w"] = setModule;
/* unused harmony export getModule */
/* harmony export (immutable) */ __webpack_exports__["y"] = setUrlIncoming;
/* harmony export (immutable) */ __webpack_exports__["t"] = getUrlIncoming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_share_constant__ = __webpack_require__(425);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var EXPIRES_DATE = 'expires_date';
var USER_ID = 'user_id';
var FULL_NAME = "fullname";
var ROLE = "role";
var EMAIL = "email";
var O365_TOKEN = "o365_token";
var USER_IMAGE = "user_image";
var IS_NPI_ADMIN = "is_npi_admin";
var IS_ADMIN = "is_admin";
var SYSTEM_INFO = "system_info";
var IS_ADMIN_TRACKER = "is_admin_tracker";
var IS_ADMIN_TRAINING = "is_admin_training";
var IS_ADMIN_CAR_RESERVATION = "is_admin_car_reservation";
var EMP_ID = "emp_id";
var IS_ACCESS_MY_TRACKER = "is_access_my_tracker";
var IS_ACCESS_MY_TRAINING = "is_access_my_tracker";
var IS_ACCESS_MY_CAR_RESERVATION = "is_access_my_car_reservation";
var IS_DRIVER = "is_driver";
var MODULES = "modules";
var COST_CENTER_NAME = "cost_center_name";
var MODULE_NAME = "module_name";
var URL_INCOMING = "url_incoming";

function getCookie(key) {
    try {
        var value = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(key);
        var setValue = '';

        if (value && typeof value === 'string') {
            setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(value);
        }

        return setValue;
    } catch (error) {
        return null;
    }
}

function setCookie(key, value, expires) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(valueToString);
    }
    if (expires && typeof expires === "number" && expires > 0) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue, { expires: expires });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove(key);
}

function authentication(dataAuth, isRemember) {
    console.log("authentication", dataAuth);
    var _dataAuth$user = dataAuth.user,
        email = _dataAuth$user.email,
        fullName = _dataAuth$user.fullName,
        id = _dataAuth$user.id,
        isNpiAdmin = _dataAuth$user.isNpiAdmin,
        isAdmin = _dataAuth$user.isAdmin,
        isAdminTrainingCourse = _dataAuth$user.isAdminTrainingCourse,
        isAdminTracker = _dataAuth$user.isAdminTracker,
        empId = _dataAuth$user.empId,
        costCenterName = _dataAuth$user.costCenterName,
        isDriver = _dataAuth$user.isDriver,
        isAdminCarReserve = _dataAuth$user.isAdminCarReserve,
        token = dataAuth.token,
        expiresDate = dataAuth.expiresDate,
        expiresOn = dataAuth.expiresOn,
        modules = dataAuth.modules;

    clearToken();
    setCookie(FULL_NAME, fullName);
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);
    setCookie(EMP_ID, empId);
    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(IS_NPI_ADMIN, isNpiAdmin);
    setCookie(IS_ADMIN, isAdmin);
    setCookie(IS_ADMIN_TRACKER, isAdminTracker);
    setCookie(IS_ADMIN_TRAINING, isAdminTrainingCourse);
    setCookie(IS_ADMIN_CAR_RESERVATION, isAdminCarReserve);
    setCookie(MODULES, modules);
    setCookie(COST_CENTER_NAME, costCenterName ? Object(__WEBPACK_IMPORTED_MODULE_2__app_share_constant__["e" /* encodeBase64 */])(costCenterName) : "");
    setCookie(IS_DRIVER, isDriver);
}
function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data);
}
function getO365Token() {
    return getCookie(O365_TOKEN);
}
function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data);
}
function getUserImageCookie() {
    return getCookie(USER_IMAGE);
}
function clearToken() {
    removeCookie(TOKEN);
    removeCookie(EXPIRES_DATE);
    removeCookie(USER_ID);
    removeCookie(EMP_ID);
    removeCookie(FULL_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_ADMIN);
    removeCookie(IS_NPI_ADMIN);
    removeCookie(IS_ADMIN_TRACKER);
    removeCookie(IS_ADMIN_TRAINING);
    removeCookie(IS_ADMIN_CAR_RESERVATION);
    removeCookie(MODULES);
    removeCookie(COST_CENTER_NAME);
    removeCookie(IS_DRIVER);
    removeCookie(URL_INCOMING);
}
function getAllCookies() {
    var _ref;

    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, EXPIRES_DATE, getCookie(EXPIRES_DATE)), _defineProperty(_ref, USER_ID, getCookie(USER_ID)), _defineProperty(_ref, IS_NPI_ADMIN, getCookie(IS_NPI_ADMIN)), _defineProperty(_ref, IS_ADMIN, getCookie(IS_ADMIN)), _defineProperty(_ref, IS_ADMIN_TRAINING, getCookie(IS_ADMIN_TRAINING)), _defineProperty(_ref, IS_ADMIN_CAR_RESERVATION, getCookie(IS_ADMIN_CAR_RESERVATION)), _defineProperty(_ref, IS_DRIVER, getCookie(IS_DRIVER)), _defineProperty(_ref, COST_CENTER_NAME, getCookie(COST_CENTER_NAME)), _defineProperty(_ref, EMP_ID, getCookie(EMP_ID)), _defineProperty(_ref, MODULES, getCookie(MODULES)), _defineProperty(_ref, FULL_NAME, getCookie(FULL_NAME)), _defineProperty(_ref, EMAIL, getCookie(EMAIL)), _ref;
}
function getModules() {
    return getCookie(MODULES);
}
function getToken() {
    return getCookie(TOKEN);
}
function getUserId() {
    return getCookie(USER_ID);
}
function getFullName() {
    return getCookie(FULL_NAME);
}
function getCostCenterName() {
    return getCookie(COST_CENTER_NAME);
}
function getEmail() {
    return getCookie(EMAIL);
}
function getRole() {
    return getCookie(ROLE);
}
function getExpireDate() {
    return getCookie(EXPIRES_DATE);
}
function getIsNpiAdmin() {
    return getCookie(IS_NPI_ADMIN);
}
function getIsAdminTraining() {
    return getCookie(IS_ADMIN_TRAINING);
}
function getIsAdminCarReservation() {
    return getCookie(IS_ADMIN_CAR_RESERVATION);
}
function getIsAdmin() {
    return getCookie(IS_ADMIN);
}
function getIsDriver() {
    return getCookie(IS_DRIVER);
}

function getIsAccessMyTracker() {
    return getCookie(IS_ACCESS_MY_TRACKER);
}

function getIsAccessMyTraining() {
    return getCookie(IS_ACCESS_MY_TRAINING);
}

function getIsAccessMyCarReservation() {
    return getCookie(IS_ACCESS_MY_CAR_RESERVATION);
}

function getIsAccessAdminTracker() {
    return getCookie(IS_ADMIN_TRACKER);
}
function setSystemInfo(data) {
    // setCookie(SYSTEM_INFO, data)
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(SYSTEM_INFO, data);
}
function getSystemInfo() {
    return getCookie(SYSTEM_INFO);
}

function setModule(name) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(MODULE_NAME, name);
}
function getModule() {
    return getCookie(MODULE_NAME);
}

function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data);
}
function getUrlIncoming() {
    return getCookie(URL_INCOMING);
}

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorList;
/* unused harmony export getCallAPI */
/* harmony export (immutable) */ __webpack_exports__["b"] = getLoading;
function getErrorList(state) {
    return state.errorList;
}

function getCallAPI(state) {
    return state.callAPI;
}

function getLoading(state) {
    return state.isLoading;
}

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return SET_LOADING; });
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_GET_SYSTEM_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_GET_SYSTEM_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_GET_SYSTEM_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_GET_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_GET_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_GET_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_GET_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_GET_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_GET_USER_INFO_FAILURE; });
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_REQUEST */
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_SUCCESS */
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_FAILURE */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_SET_USER_APPROVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_SET_USER_APPROVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_SET_USER_APPROVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_SET_USER_SUBMIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_SET_USER_SUBMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_SET_USER_SUBMIT_FAILURE; });
/* unused harmony export CORE_AUTH_VERIFY_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_AUTH_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_AUTH_VERIFY_FAILURE; });
/* unused harmony export CORE_AUTH_VERIFY_BYPASS_REQUEST */
/* unused harmony export CORE_AUTH_VERIFY_BYPASS_SUCCESS */
/* unused harmony export CORE_AUTH_VERIFY_BYPASS_FAILURE */
/* unused harmony export CORE_GET_REQUEST_INFO_REQUEST */
/* unused harmony export CORE_GET_REQUEST_INFO_SUCCESS */
/* unused harmony export CORE_GET_REQUEST_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_GET_MASTERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_GET_MASTERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_GET_MASTERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_GET_ALL_MYTASKS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_GET_ALL_MYTASKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_GET_ALL_MYTASKS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_GET_MYTASK_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_GET_MYTASK_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_GET_MYTASK_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CREATE_MYTASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_MYTASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CREATE_MYTASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_SUBMIT_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_SUBMIT_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_SUBMIT_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_COMMENT_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_COMMENT_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_COMMENT_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_GET_ALL_MY_ASSIGN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_GET_ALL_MY_ASSIGN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_GET_ALL_MY_ASSIGN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_GET_ASSIGN_TASK_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_GET_ASSIGN_TASK_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_IN_PROGRESS_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_IN_PROGRESS_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_IN_PROGRESS_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_GET_ALL_MY_DRAFT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_GET_ALL_MY_DRAFT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_GET_ALL_MY_DRAFT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_GET_DRAFT_TASK_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_GET_DRAFT_TASK_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_GET_DRAFT_TASK_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_WAITING_TEST_ASSIGN_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_WAITING_TEST_ASSIGN_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_DONE_ASSIGN_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_DONE_ASSIGN_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_DONE_ASSIGN_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_DISCUSS_ASSIGN_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_DISCUSS_ASSIGN_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_DISCUSS_ASSIGN_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_ATTACH_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_ATTACH_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_ATTACH_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CLOSED_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CLOSED_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CLOSED_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CANCEL_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CANCEL_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CANCEL_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_REOPEN_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_REOPEN_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_REOPEN_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_GET_OIL_PRICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_GET_OIL_PRICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_GET_OIL_PRICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_GET_OIL_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_GET_OIL_PRICES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_GET_OIL_PRICES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_UPDATE_MYTASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_UPDATE_MYTASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_UPDATE_MYTASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_UPDATE_TASK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_UPDATE_TASK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_UPDATE_TASK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_GET_SETTINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_GET_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_GET_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_GET_ALL_COURSE_INCOMING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_GET_ALL_COURSE_INCOMING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_GET_ALL_COURSE_INCOMING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_GET_ALL_COURSE_HISTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_GET_ALL_COURSE_HISTORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_GET_ALL_COURSE_HISTORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_GET_COURSE_BY_ID_INCOMING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_GET_COURSE_BY_ID_INCOMING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_GET_REQUEST_TO_JOIN_COURSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_GET_REQUEST_TO_JOIN_COURSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_GET_REQUEST_TO_JOIN_COURSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_GET_ALL_CAR_RESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_GET_ALL_CAR_RESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_GET_ALL_CAR_RESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_GET_CAR_RESERVE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_GET_CAR_RESERVE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_GET_CAR_RESERVE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CREATE_CAR_RESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CREATE_CAR_RESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CREATE_CAR_RESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_UPDATE_CAR_RESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_UPDATE_CAR_RESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_UPDATE_CAR_RESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CANCEL_CAR_RESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CANCEL_CAR_RESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_CANCEL_CAR_RESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_REJECT_CAR_RESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_REJECT_CAR_RESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_REJECT_CAR_RESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_GET_ALL_MY_CAR_RESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_GET_ALL_MY_CAR_RESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_START_CAR_DRIVER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_START_CAR_DRIVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_START_CAR_DRIVER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_END_CAR_DRIVER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_END_CAR_DRIVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_END_CAR_DRIVER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return GET_LOCATION_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return GET_LOCATION_SEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return GET_LOCATION_SEARCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_GET_ALL_PROJECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_GET_ALL_PROJECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_GET_ALL_PROJECT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_GET_PROJECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_GET_PROJECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_GET_PROJECT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_PROJECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_PROJECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_PROJECT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_UPDATE_PROJECT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_UPDATE_PROJECT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_UPDATE_PROJECT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_GET_APPROVE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_GET_APPROVE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_GET_APPROVE_LIST_FAILURE; });
var REQUEST_STATE = 'REQUEST_STATE';
var SET_ERROR = 'SET_ERROR';
var SET_LOADING = 'SET_LOADING';

var LOGOUT = 'LOGOUT';
var CORE_GET_SYSTEM_INFO_REQUEST = 'CORE_GET_SYSTEM_INFO_REQUEST';
var CORE_GET_SYSTEM_INFO_SUCCESS = 'CORE_GET_SYSTEM_INFO_SUCCESS';
var CORE_GET_SYSTEM_INFO_FAILURE = 'CORE_GET_SYSTEM_INFO_FAILURE';

var CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST';
var CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS';
var CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE';

var CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST';
var CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS';
var CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE';

var CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST';
var CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS';
var CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE';

var CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST';
var CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS';
var CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE';

var CORE_SET_USER_APPROVE_REQUEST = 'CORE_SET_USER_APPROVE_REQUEST';
var CORE_SET_USER_APPROVE_SUCCESS = 'CORE_SET_USER_APPROVE_SUCCESS';
var CORE_SET_USER_APPROVE_FAILURE = 'CORE_SET_USER_APPROVE_FAILURE';

var CORE_SET_USER_SUBMIT_REQUEST = 'CORE_SET_USER_SUBMIT_REQUEST';
var CORE_SET_USER_SUBMIT_SUCCESS = 'CORE_SET_USER_SUBMIT_SUCCESS';
var CORE_SET_USER_SUBMIT_FAILURE = 'CORE_SET_USER_SUBMIT_FAILURE';

//AUTH
var CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

//AUTH BYPASS
var CORE_AUTH_VERIFY_BYPASS_REQUEST = 'CORE_AUTH_VERIFY_BYPASS_REQUEST';
var CORE_AUTH_VERIFY_BYPASS_SUCCESS = 'CORE_AUTH_VERIFY_BYPASS_SUCCESS';
var CORE_AUTH_VERIFY_BYPASS_FAILURE = 'CORE_AUTH_VERIFY_BYPASS_FAILURE';

var CORE_GET_REQUEST_INFO_REQUEST = 'CORE_GET_REQUEST_INFO_REQUEST';
var CORE_GET_REQUEST_INFO_SUCCESS = 'CORE_GET_REQUEST_INFO_SUCCESS';
var CORE_GET_REQUEST_INFO_FAILURE = 'CORE_GET_REQUEST_INFO_FAILURE';

//MASTER
var CORE_GET_MASTERS_REQUEST = 'CORE_GET_MASTERS_REQUEST';
var CORE_GET_MASTERS_SUCCESS = 'CORE_GET_MASTERS_SUCCESS';
var CORE_GET_MASTERS_FAILURE = 'CORE_GET_MASTERS_FAILURE';

// ALL MY MASTER
var CORE_GET_ALL_MYTASKS_REQUEST = 'CORE_GET_ALL_MYTASKS_REQUEST';
var CORE_GET_ALL_MYTASKS_SUCCESS = 'CORE_GET_ALL_MYTASKS_SUCCESS';
var CORE_GET_ALL_MYTASKS_FAILURE = 'CORE_GET_ALL_MYTASKS_FAILURE';

// MY TASK BY ID
var CORE_GET_MYTASK_BY_ID_REQUEST = 'CORE_GET_MYTASK_BY_ID_REQUEST';
var CORE_GET_MYTASK_BY_ID_SUCCESS = 'CORE_GET_MYTASK_BY_ID_SUCCESS';
var CORE_GET_MYTASK_BY_ID_FAILURE = 'CORE_GET_MYTASK_BY_ID_FAILURE';

// CREATE TASK
var CORE_CREATE_MYTASK_REQUEST = 'CORE_CREATE_MYTASK_REQUEST';
var CORE_CREATE_MYTASK_SUCCESS = 'CORE_CREATE_MYTASK_SUCCESS';
var CORE_CREATE_MYTASK_FAILURE = 'CORE_CREATE_MYTASK_FAILURE';

// SUBMIT TASK
var CORE_SUBMIT_TASK_REQUEST = 'CORE_SUBMIT_TASK_REQUEST';
var CORE_SUBMIT_TASK_SUCCESS = 'CORE_SUBMIT_TASK_SUCCESS';
var CORE_SUBMIT_TASK_FAILURE = 'CORE_SUBMIT_TASK_FAILURE';

// COMMENT TASK
var CORE_COMMENT_TASK_REQUEST = 'CORE_COMMENT_TASK_REQUEST';
var CORE_COMMENT_TASK_SUCCESS = 'CORE_COMMENT_TASK_SUCCESS';
var CORE_COMMENT_TASK_FAILURE = 'CORE_COMMENT_TASK_FAILURE';

// ALL TASK ASSIGN
var CORE_GET_ALL_MY_ASSIGN_REQUEST = 'CORE_GET_ALL_MY_ASSIGN_REQUEST';
var CORE_GET_ALL_MY_ASSIGN_SUCCESS = 'CORE_GET_ALL_MY_ASSIGN_SUCCESS';
var CORE_GET_ALL_MY_ASSIGN_FAILURE = 'CORE_GET_ALL_MY_ASSIGN_FAILURE';

// TASK ASSIGN BY ID
var CORE_GET_ASSIGN_TASK_BY_ID_REQUEST = 'CORE_GET_ASSIGN_TASK_BY_ID_REQUEST';
var CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS = 'CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS';
var CORE_GET_ASSIGN_TASK_BY_ID_FAILURE = 'CORE_GET_ASSIGN_TASK_BY_ID_FAILURE';

// INPROGRESS TASK
var CORE_IN_PROGRESS_TASK_REQUEST = 'CORE_IN_PROGRESS_TASK_REQUEST';
var CORE_IN_PROGRESS_TASK_SUCCESS = 'CORE_IN_PROGRESS_TASK_SUCCESS';
var CORE_IN_PROGRESS_TASK_FAILURE = 'CORE_IN_PROGRESS_TASK_FAILURE';

// ALL TASK DRAFT
var CORE_GET_ALL_MY_DRAFT_REQUEST = 'CORE_GET_ALL_MY_DRAFT_REQUEST';
var CORE_GET_ALL_MY_DRAFT_SUCCESS = 'CORE_GET_ALL_MY_DRAFT_SUCCESS';
var CORE_GET_ALL_MY_DRAFT_FAILURE = 'CORE_GET_ALL_MY_DRAFT_FAILURE';

// DRAFT TASK BY ID
var CORE_GET_DRAFT_TASK_BY_ID_REQUEST = 'CORE_GET_DRAFT_TASK_BY_ID_REQUEST';
var CORE_GET_DRAFT_TASK_BY_ID_SUCCESS = 'CORE_GET_DRAFT_TASK_BY_ID_SUCCESS';
var CORE_GET_DRAFT_TASK_BY_ID_FAILURE = 'CORE_GET_DRAFT_TASK_BY_ID_FAILURE';

// WAITING_TEST
var CORE_WAITING_TEST_ASSIGN_TASK_REQUEST = 'CORE_WAITING_TEST_ASSIGN_TASK_REQUEST';
var CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS = 'CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS';
var CORE_WAITING_TEST_ASSIGN_TASK_FAILURE = 'CORE_WAITING_TEST_ASSIGN_TASK_FAILURE';

// DONE
var CORE_DONE_ASSIGN_TASK_REQUEST = 'CORE_DONE_ASSIGN_TASK_REQUEST';
var CORE_DONE_ASSIGN_TASK_SUCCESS = 'CORE_DONE_ASSIGN_TASK_SUCCESS';
var CORE_DONE_ASSIGN_TASK_FAILURE = 'CORE_DONE_ASSIGN_TASK_FAILURE';

// DISCUSS
var CORE_DISCUSS_ASSIGN_TASK_REQUEST = 'CORE_DISCUSS_ASSIGN_TASK_REQUEST';
var CORE_DISCUSS_ASSIGN_TASK_SUCCESS = 'CORE_DISCUSS_ASSIGN_TASK_SUCCESS';
var CORE_DISCUSS_ASSIGN_TASK_FAILURE = 'CORE_DISCUSS_ASSIGN_TASK_FAILURE';

// ATTACH
var CORE_ATTACH_TASK_REQUEST = 'CORE_ATTACH_TASK_REQUEST';
var CORE_ATTACH_TASK_SUCCESS = 'CORE_ATTACH_TASK_SUCCESS';
var CORE_ATTACH_TASK_FAILURE = 'CORE_ATTACH_TASK_FAILURE';

// CLOSED_TASK
var CORE_CLOSED_TASK_REQUEST = 'CORE_CLOSED_TASK_REQUEST';
var CORE_CLOSED_TASK_SUCCESS = 'CORE_CLOSED_TASK_SUCCESS';
var CORE_CLOSED_TASK_FAILURE = 'CORE_CLOSED_TASK_FAILURE';

// CANCEL_TASK
var CORE_CANCEL_TASK_REQUEST = 'CORE_CANCEL_TASK_REQUEST';
var CORE_CANCEL_TASK_SUCCESS = 'CORE_CANCEL_TASK_SUCCESS';
var CORE_CANCEL_TASK_FAILURE = 'CORE_CANCEL_TASK_FAILURE';

// REOPEN
var CORE_REOPEN_TASK_REQUEST = 'CORE_REOPEN_TASK_REQUEST';
var CORE_REOPEN_TASK_SUCCESS = 'CORE_REOPEN_TASK_SUCCESS';
var CORE_REOPEN_TASK_FAILURE = 'CORE_REOPEN_TASK_FAILURE';

// DOWNLOAD_ONEDIRVE_FILE
var CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST = 'CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST';
var CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS = 'CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS';
var CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE = 'CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE';

var CORE_GET_OIL_PRICE_REQUEST = 'CORE_GET_OIL_PRICE_REQUEST';
var CORE_GET_OIL_PRICE_SUCCESS = 'CORE_GET_OIL_PRICE_SUCCESS';
var CORE_GET_OIL_PRICE_FAILURE = 'CORE_GET_OIL_PRICE_FAILURE';

var CORE_GET_OIL_PRICES_REQUEST = 'CORE_GET_OIL_PRICES_REQUEST';
var CORE_GET_OIL_PRICES_SUCCESS = 'CORE_GET_OIL_PRICES_SUCCESS';
var CORE_GET_OIL_PRICES_FAILURE = 'CORE_GET_OIL_PRICES_FAILURE';

// UPDATE MY TASK
var CORE_UPDATE_MYTASK_REQUEST = 'CORE_UPDATE_MYTASK_REQUEST';
var CORE_UPDATE_MYTASK_SUCCESS = 'CORE_UPDATE_MYTASK_SUCCESS';
var CORE_UPDATE_MYTASK_FAILURE = 'CORE_UPDATE_MYTASK_FAILURE';

var CORE_UPDATE_TASK_REQUEST = 'CORE_UPDATE_TASK_REQUEST';
var CORE_UPDATE_TASK_SUCCESS = 'CORE_UPDATE_TASK_SUCCESS';
var CORE_UPDATE_TASK_FAILURE = 'CORE_UPDATE_TASK_FAILURE';

var CORE_GET_SETTINGS_REQUEST = 'CORE_GET_SETTINGS_REQUEST';
var CORE_GET_SETTINGS_SUCCESS = 'CORE_GET_SETTINGS_SUCCESS';
var CORE_GET_SETTINGS_FAILURE = 'CORE_GET_SETTINGS_FAILURE';

// COURSE
var CORE_GET_ALL_COURSE_INCOMING_REQUEST = 'CORE_GET_ALL_COURSE_INCOMING_REQUEST';
var CORE_GET_ALL_COURSE_INCOMING_SUCCESS = 'CORE_GET_ALL_COURSE_INCOMING_SUCCESS';
var CORE_GET_ALL_COURSE_INCOMING_FAILURE = 'CORE_GET_ALL_COURSE_INCOMING_FAILURE';

var CORE_GET_ALL_COURSE_HISTORY_REQUEST = 'CORE_GET_ALL_COURSE_HISTORY_REQUEST';
var CORE_GET_ALL_COURSE_HISTORY_SUCCESS = 'CORE_GET_ALL_COURSE_HISTORY_SUCCESS';
var CORE_GET_ALL_COURSE_HISTORY_FAILURE = 'CORE_GET_ALL_COURSE_HISTORY_FAILURE';

var CORE_GET_COURSE_BY_ID_INCOMING_REQUEST = 'CORE_GET_COURSE_BY_ID_INCOMING_REQUEST';
var CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS = 'CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS';
var CORE_GET_COURSE_BY_ID_INCOMING_FAILURE = 'CORE_GET_COURSE_BY_ID_INCOMING_FAILURE';

var CORE_GET_REQUEST_TO_JOIN_COURSE_REQUEST = 'CORE_GET_REQUEST_TO_JOIN_COURSE_REQUEST';
var CORE_GET_REQUEST_TO_JOIN_COURSE_SUCCESS = 'CORE_GET_REQUEST_TO_JOIN_COURSE_SUCCESS';
var CORE_GET_REQUEST_TO_JOIN_COURSE_FAILURE = 'CORE_GET_REQUEST_TO_JOIN_COURSE_FAILURE';

var CORE_GET_ALL_CAR_RESERVE_REQUEST = 'CORE_GET_ALL_CAR_RESERVE_REQUEST';
var CORE_GET_ALL_CAR_RESERVE_SUCCESS = 'CORE_GET_ALL_CAR_RESERVE_SUCCESS';
var CORE_GET_ALL_CAR_RESERVE_FAILURE = 'CORE_GET_ALL_CAR_RESERVE_FAILURE';

var CORE_GET_CAR_RESERVE_BY_ID_REQUEST = 'CORE_GET_CAR_RESERVE_BY_ID_REQUEST';
var CORE_GET_CAR_RESERVE_BY_ID_SUCCESS = 'CORE_GET_CAR_RESERVE_BY_ID_SUCCESS';
var CORE_GET_CAR_RESERVE_BY_ID_FAILURE = 'CORE_GET_CAR_RESERVE_BY_ID_FAILURE';

var CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST = 'CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST';
var CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS = 'CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS';
var CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE = 'CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE';

var CORE_CREATE_CAR_RESERVE_REQUEST = 'CORE_CREATE_CAR_RESERVE_REQUEST';
var CORE_CREATE_CAR_RESERVE_SUCCESS = 'CORE_CREATE_CAR_RESERVE_SUCCESS';
var CORE_CREATE_CAR_RESERVE_FAILURE = 'CORE_CREATE_CAR_RESERVE_FAILURE';

var CORE_UPDATE_CAR_RESERVE_REQUEST = 'CORE_UPDATE_CAR_RESERVE_REQUEST';
var CORE_UPDATE_CAR_RESERVE_SUCCESS = 'CORE_UPDATE_CAR_RESERVE_SUCCESS';
var CORE_UPDATE_CAR_RESERVE_FAILURE = 'CORE_UPDATE_CAR_RESERVE_FAILURE';

var CORE_CANCEL_CAR_RESERVE_REQUEST = 'CORE_CANCEL_CAR_RESERVE_REQUEST';
var CORE_CANCEL_CAR_RESERVE_SUCCESS = 'CORE_CANCEL_CAR_RESERVE_SUCCESS';
var CORE_CANCEL_CAR_RESERVE_FAILURE = 'CORE_CANCEL_CAR_RESERVE_FAILURE';

var CORE_REJECT_CAR_RESERVE_REQUEST = 'CORE_REJECT_CAR_RESERVE_REQUEST';
var CORE_REJECT_CAR_RESERVE_SUCCESS = 'CORE_REJECT_CAR_RESERVE_SUCCESS';
var CORE_REJECT_CAR_RESERVE_FAILURE = 'CORE_REJECT_CAR_RESERVE_FAILURE';

var CORE_GET_ALL_MY_CAR_RESERVE_REQUEST = 'CORE_GET_ALL_MY_CAR_RESERVE_REQUEST';
var CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS = 'CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS';
var CORE_GET_ALL_MY_CAR_RESERVE_FAILURE = 'CORE_GET_ALL_MY_CAR_RESERVE_FAILURE';

var CORE_START_CAR_DRIVER_REQUEST = 'CORE_START_CAR_DRIVER_REQUEST';
var CORE_START_CAR_DRIVER_SUCCESS = 'CORE_START_CAR_DRIVER_SUCCESS';
var CORE_START_CAR_DRIVER_FAILURE = 'CORE_START_CAR_DRIVER_FAILURE';

var CORE_END_CAR_DRIVER_REQUEST = 'CORE_END_CAR_DRIVER_REQUEST';
var CORE_END_CAR_DRIVER_SUCCESS = 'CORE_END_CAR_DRIVER_SUCCESS';
var CORE_END_CAR_DRIVER_FAILURE = 'CORE_END_CAR_DRIVER_FAILURE';

var GET_LOCATION_SEARCH_REQUEST = 'GET_LOCATION_SEARCH_REQUEST';
var GET_LOCATION_SEARCH_SUCCESS = 'GET_LOCATION_SEARCH_SUCCESS';
var GET_LOCATION_SEARCH_FAILURE = 'GET_LOCATION_SEARCH_FAILURE';

var CORE_GET_ALL_PROJECT_REQUEST = 'CORE_GET_ALL_PROJECT_REQUEST';
var CORE_GET_ALL_PROJECT_SUCCESS = 'CORE_GET_ALL_PROJECT_SUCCESS';
var CORE_GET_ALL_PROJECT_FAILURE = 'CORE_GET_ALL_PROJECT_FAILURE';

var CORE_GET_PROJECT_REQUEST = 'CORE_GET_PROJECT_REQUEST';
var CORE_GET_PROJECT_SUCCESS = 'CORE_GET_PROJECT_SUCCESS';
var CORE_GET_PROJECT_FAILURE = 'CORE_GET_PROJECT_FAILURE';

var CORE_CREATE_PROJECT_REQUEST = 'CORE_CREATE_PROJECT_REQUEST';
var CORE_CREATE_PROJECT_SUCCESS = 'CORE_CREATE_PROJECT_SUCCESS';
var CORE_CREATE_PROJECT_FAILURE = 'CORE_CREATE_PROJECT_FAILURE';

var CORE_UPDATE_PROJECT_REQUEST = 'CORE_UPDATE_PROJECT_REQUEST';
var CORE_UPDATE_PROJECT_SUCCESS = 'CORE_UPDATE_PROJECT_SUCCESS';
var CORE_UPDATE_PROJECT_FAILURE = 'CORE_UPDATE_PROJECT_FAILURE';

var CORE_GET_APPROVE_LIST_REQUEST = 'CORE_GET_APPROVE_LIST_REQUEST';
var CORE_GET_APPROVE_LIST_SUCCESS = 'CORE_GET_APPROVE_LIST_SUCCESS';
var CORE_GET_APPROVE_LIST_FAILURE = 'CORE_GET_APPROVE_LIST_FAILURE';

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* unused harmony export collections */
/* unused harmony export makeSelectOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return makeSelectOption2; });
/* unused harmony export zeroPadStart */
/* unused harmony export zeroPadEnd */
/* unused harmony export itemStatus */
/* unused harmony export makeSelectPipeTypePatternOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return makeSelectIdOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return encodeBase64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return decodeBase64; });
/* unused harmony export sellOrderStatus */
/* unused harmony export measurement */
/* unused harmony export customerType */
/* unused harmony export typeOfRequest */
/* unused harmony export makeSelectIdCheckboxOption */
/* unused harmony export tubeTypeOptions */
/* unused harmony export finTypeOptions */
/* unused harmony export plateTypeOptions */
/* unused harmony export headerOptions */
/* unused harmony export coatingOptions */
/* unused harmony export convertUnitMoney */
/* unused harmony export statusTransfer */
/* unused harmony export makeSelectWarehouseIdOption */
/* unused harmony export eventKeyHandle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fullDateTimeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateTimeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fullDateTimeTrackerFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return makeSelectOnlyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return makeSelectUserOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return makeSelectUserGroupOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return taskMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateTimeFm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return renderDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return makeSelectOilTypeOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return reseveCarMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return locationGoogleMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var collections = {
    drawing: 'drawing',
    coatings: 'coatings',
    coilTypes: 'coilTypes',
    finEdges: 'finEdges',
    finMaterials: 'finMaterials',
    finPatterns: 'finPatterns',
    finSurfaces: 'finSurfaces',
    hairPins: 'hairPins',
    tubeDimentions: 'tubeDimentions',
    tubeInsideShapes: 'tubeInsideShapes',
    tubeTypes: 'tubeTypes',
    tubeMaterials: 'tubeMaterials',
    setting: 'setting',
    transferById: 'transferById'
};

var tubeTypeOptions = [{ key: 'P', value: 'P', text: 'P=Plain' }, { key: 'G', value: 'G', text: 'G=Groove' }];
var finTypeOptions = [{ key: 'AL', value: 'AL', text: 'Bare Fin' }, { key: 'PC', value: 'PC', text: 'Pre-Coated' }, { key: 'CU', value: 'CU', text: 'Copper' }];
var plateTypeOptions = [{ key: 'ST', value: 'ST', text: 'Steel' }, { key: 'SS', value: 'SS', text: 'Stainless' }, { key: 'SS316', value: 'SS316', text: 'Stainless 316' }, { key: 'AL', value: 'AL', text: 'Aluminum' }];
var headerOptions = [{ key: 'CU', value: 'CU', text: 'Copper' }, { key: 'ST', value: 'ST', text: 'Steel' }];
var coatingOptions = [{ key: 'EP', value: 'EP', text: 'Epoxy' }, { key: 'DC', value: 'DC', text: 'D-Coat' }];

var makeSelectOption = function makeSelectOption(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e.code, value: e.code, text: e.fullName ? e.fullName : e.name, valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};
var makeSelectOption2 = function makeSelectOption2(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];

                for (var _index = 0; _index < e.length; _index++) {
                    var d = e[_index];
                    result.push({ key: d.id, value: d.id, text: d.fullname, valuedata: hasValue ? e.value : null });
                }
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectIdOption = function makeSelectIdOption(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.name, valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectOilTypeOption = function makeSelectOilTypeOption(datas, lang) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e.id, value: e.id, text: lang ? e.nameEn : e.nameTh });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};
var makeSelectUserOption = function makeSelectUserOption(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                var fullname = e.fullName ? e.fullName : e.fullname ? e.fullname : '';
                result.push({ key: e.id, value: e.id, text: fullname.toUpperCase(), valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectUserGroupOption = function makeSelectUserGroupOption(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                var fullname = e.name ? e.name : e.name ? e.name : '';
                result.push({ key: e.id, value: e.id, text: fullname, valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectPipeTypePatternOption = function makeSelectPipeTypePatternOption(datas) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.nameIMS, patternId: e.patternId, typeId: e.typeId });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectIdCheckboxOption = function makeSelectIdCheckboxOption(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];

            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.name, valuedata: hasValue ? e.value : null, isChecked: false });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectWarehouseIdOption = function makeSelectWarehouseIdOption(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];
            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.warehouse, valuedata: hasValue ? e.warehouse : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var makeSelectOnlyName = function makeSelectOnlyName(datas, hasValue) {
    try {
        if (Array.isArray(datas)) {
            var result = [];
            for (var index = 0; index < datas.length; index++) {
                var e = datas[index];
                result.push({ key: e, value: e, text: e, valuedata: hasValue ? e : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

var locationGoogleMap = function locationGoogleMap(startLat, startLng, endLat, endLng) {
    return 'https://www.google.co.th/maps/dir/' + startLat + ',' + startLng + '/' + endLat + ',' + endLng;
};

var eventKeyHandle = {
    enter: 13,
    back: 111,
    del: 110,
    help: 106,
    up: 109, //Up Keycode: 109 Arrow Up: 38
    down: 107, //Down Keycode: 107 Arrow Down: 40
    arrowUp: 38,
    arrowDown: 40

    //numlock: 12,
    //
    //message: 91
    //tab: 9
};

var zeroPadStart = function zeroPadStart(str, count) {
    return String(str).padStart(count, '0');
};
var zeroPadEnd = function zeroPadEnd(str, count) {
    return String(str).padEnd(count, '0');
};

var encodeBase64 = function encodeBase64(value) {
    var buff = new Buffer(value);
    var base64data = buff.toString('base64');
    return base64data;
};

var decodeBase64 = function decodeBase64(value) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascii';

    var buff = new Buffer(value, 'base64');
    var base64data = buff.toString(type);
    // let base64data = buff.toString('ascii');
    return base64data;
};

var convertUnitMoney = function convertUnitMoney(type, value) {
    switch (type) {
        case 'money':
            var valueConvert = 0;
            if (value) {
                valueConvert = parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
            return valueConvert;

        default:
            return value;
    }
};

var renderDateTime = function renderDateTime(row) {
    var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.startDateTime).format(dateTimeFm.dateAxFormat);
    var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.endDateTime).format(dateTimeFm.dateAxFormat);
    var isSame = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate));
    console.log('isSame', isSame);
    if (isSame) {
        return startDate + ' ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.startDateTime).format('HH:mm') + '-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.endDateTime).format('HH:mm') + ' ';
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.startDateTime).format(dateTimeFm.dateTimeAxFormat) + ' - ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(row.endDateTime).format(dateTimeFm.dateTimeAxFormat) + ' ';
    }
};

var statusTransfer = {
    created: 'CREATED',
    transfered: 'TRANFERED',
    received: 'RECEIVED',
    transferedCompleted: 'Transferred – Completed',
    receiveCompleted: 'Receive – Completed',
    completed: 'COMPLETED'
};

var taskMode = {
    myTask: 'mytask',
    draftTask: 'drafttask',
    assignTask: 'assigntask'
};

var reseveCarMode = {
    map: 'map',
    form: 'form',
    userSelect: 'userSelect'
};

var itemStatus = ['WAITING', 'APPROVE', 'GENCODE', 'DELETE'];
var sellOrderStatus = ['SUBMIT', 'PRE-APPROVE', 'APPROVE', 'CUSROMER-APPROVE'];
var measurement = ['Inches', 'mm.'];
var customerType = ['LOCAL', 'INTERNATIONAL'];
var typeOfRequest = ['NEW', 'REV', 'REP'];
var fullDateTimeFormat = 'DD MMM YYYY HH:mm';
var fullDateTimeTrackerFormat = 'DD/MM/YYYY HH:mm';
var dateTimeFormat = 'DD/MM/YYYY HH:mm';
var defaultImage = '/assets/images/tracker/user.png';
var dateTimeFm = {
    dateWithTime: 'YYYY-MM-DDThh:mm',
    dateWithTimeInput: 'YYYY-MM-DDTHH:mm',
    dateTime: 'YYYY-MM-DD HH:mm',
    dateTimeNoDash: 'YYYYMMDD HH:mm',
    dateLimit: 'YYYY-MM-DD', //20220331,
    dateAPI: 'YYYYMMDD', //20220331,
    dateTimeAxFormat: 'DD-MM-YYYY HH:mm',
    dateAxFormat: 'DD-MM-YYYY',
    timeAxFormat: 'HH:mm A',
    dateTimeFormatNew: ' DD/MM/YYYY  (HH:mm A)',
    dateFormat: 'DD/MM/YYYY'
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(432).Buffer))

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });
        if (resStatusError.includes(res.status)) {
            return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (res && res.status === 204) {
                    var body = {
                        result: res.ok
                    };
                    return resolve({ type: type.type, payload: _extends({}, body) });
                }
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();
            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                var url = { endpoint: endpoint, method: method };
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true, url: url });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            next(action);
        };
    };
});
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(190);

// CONCATENATED MODULE: ./src/middlewares/setToken.js
var setToken__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {

            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = null;
            var entryType = entry.types[0];

            if (entryType.startsWith("CORE")) {
                token = Object(auth["s" /* getToken */])();
            }

            if (!token) return next(action);
            //  return false
            entry.headers = setToken__extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
            }
            entry.headers["Access-Control-Allow-Origin"] = "*";
            entry.headers["Access-Control-Allow-Methods"] = "*";
            entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With";

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(63);



// const LoaderExampleInlineCentered = () => <Loader active inline='centered' size='large' >Loading</Loader>
var LoaderExampleInlineCentered = function LoaderExampleInlineCentered() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'w-full h-full bg-slate-100 rounded-2xl' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cube-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cube-folding' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf1' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf3' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf4' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'loading', 'data-name': 'Loading' },
                    'Loading'
                )
            )
        )
    );
};
/* harmony default export */ __webpack_exports__["a"] = (LoaderExampleInlineCentered);

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDIRECT_O365_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_GOOGLE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_MAP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_ID; });
/* unused harmony export ACTIVE_ITEM_TAB */
/* unused harmony export ACTIVE_ITEM2_TAB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VERSION_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SYSTEM_NAME; });
// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"
//
// // Localhost
// export const CORE_API_ENDPOINT = "http://localhost:2800"
// export const REDIRECT_O365_URI = 'http://localhost:8080/login';
// export const AX_URL = "http://localhost:8080"

// tracker UAT Server
// export const CORE_API_ENDPOINT = "https://mytrackertest.cigblusolutions.com/api"
var CORE_API_ENDPOINT = 'https://mytrackerdev.cigblusolutions.com/api';
var REDIRECT_O365_URI = 'https://mytrackerdev.cigblusolutions.com/login';
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// trainee UAT Server
//export const CORE_API_ENDPOINT = "https://traineetest.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://traineetest.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// tracker Prod Server
// export const CORE_API_ENDPOINT = "https://mytracker.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://mytracker.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

// export const CORE_API_ENDPOINT = "/api"
// export const REDIRECT_O365_URI = "/login"
var CORE_GOOGLE_ENDPOINT = 'https://mytrackertest.cigblusolutions.com/google';
var API_MAP_KEY = 'AIzaSyAr0_xNXVux88WH3bK9cyke7J23SlXMRZ0';
//"AIzaSyAdX0Lh7dCs1tV6fVbMMMdSq5UXA6NzCdM"

var CLIENT_ID = '0b1bf20d-a148-44d2-8932-027dbaf66a46';
var ACTIVE_ITEM_TAB = 6; //6
var ACTIVE_ITEM2_TAB = 2; //6
var VERSION_NO = '1.1.0';
// export const SYSTEM_NAME = `${(CORE_API_ENDPOINT.search("localhost") > -1) || (CORE_API_ENDPOINT.search("test") > -1) ? "trackerUAT" : "trackerPROD"}`
var SYSTEM_NAME = 'tracker';

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export imagePageLogin */
/* unused harmony export image_header */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iconCloseModalError; });
/* unused harmony export iconLogoModalError */
/* unused harmony export iconCloseOnBG */
/* unused harmony export iconArrowLeft */
/* unused harmony export iconArrowRight */
var imagePageLogin = '/assets/images/logo-page-login.png';
var image_header = '/assets/images/logo-mene.png';

var iconCloseModalError = '/assets/images/tracker/close.png';
// export const iconLogoModalError = '/assets/images/icon-deleteCircle-fff.png'
var iconLogoModalError = '/assets/images/warning.png';
var iconCloseOnBG = '/assets/images/icon-delete-fff.png';

//Image Next Prev
var iconArrowLeft = '/assets/images/icon-arrow-left.png';
var iconArrowRight = '/assets/images/icon-arrow-right.png';

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(63);



// const LoaderExampleInlineCentered = () => <Loader active inline='centered' size='large' >Loading</Loader>
var LoaderExampleInlineCentered = function LoaderExampleInlineCentered() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'w-full h-full bg-slate-100 rounded-2xl' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cube-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cube-folding' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf1' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf3' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'leaf4' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'loading', 'data-name': 'Loading' },
                    'Loading'
                )
            )
        )
    );
};
/* harmony default export */ __webpack_exports__["a"] = (LoaderExampleInlineCentered);

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(441);


/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(138);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(446);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 5 modules
var react_router_dom = __webpack_require__(64);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(35);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(463);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(464);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(431);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/app/components/features/share/loadingInContent.js
var loadingInContent = __webpack_require__(430);

// CONCATENATED MODULE: ./src/app/components/features/share/loadable/loadableRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var loadableRoute_Loading = function Loading() {
    return react_default.a.createElement(
        'div',
        { className: 'module loadableRouteFull !rounded-md' },
        react_default.a.createElement(loadingInContent["a" /* default */], null)
    );
};

/* harmony default export */ var loadableRoute = (function (opts) {
    return lib_default()(_extends({
        loading: loadableRoute_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 2 modules
var src_lib = __webpack_require__(180);

// CONCATENATED MODULE: ./src/app/routes/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var parseJwt = function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};
var Auth = {
    isAuthenticated: function isAuthenticated() {
        var cookies = Object(src_lib["j" /* getAllCookies */])();
        var isAuth = false;

        if (cookies && cookies[src_lib["f" /* TOKEN */]] && cookies[src_lib["g" /* USER_ID */]]) {
            var decodedJwt = parseJwt(cookies[src_lib["f" /* TOKEN */]]);
            if (decodedJwt.exp < Date.now()) {
                isAuth = true;
            } else {
                isAuth = false;
            }
        }
        return isAuth;
    },
    isNpiAdmin: function isNpiAdmin() {
        var isAdmin = Object(src_lib["v" /* getIsNpiAdmin */])();
        return isAdmin.toString() === 'true';
    },
    isDriver: function isDriver() {
        var isDriver = Object(src_lib["u" /* getIsDriver */])();
        console.log('isDriver', isDriver);
        return isDriver.toString() === 'true';
    },
    isAdmin: function isAdmin() {
        var isAdmin = Object(src_lib["r" /* getIsAdmin */])();
        return isAdmin.toString() === 'true';
    },
    isAdminTraining: function isAdminTraining() {
        var isAdminTraining = Object(src_lib["t" /* getIsAdminTraining */])();
        return isAdminTraining.toString() === 'true';
    },
    isAdminCarReservation: function isAdminCarReservation() {
        var isAdminCarReservation = Object(src_lib["s" /* getIsAdminCarReservation */])();
        // console.log("isAdminCarReservation", isAdminCarReservation)
        return isAdminCarReservation.toString() === 'true';
        // return true
    },
    isAccessMyTracker: function isAccessMyTracker() {
        var isAdminTraining = Object(src_lib["p" /* getIsAccessMyTracker */])();
        return isAdminTraining.toString() === 'true';
        // return true
    },
    isAccessMyTraining: function isAccessMyTraining() {
        var isAccessMyTraining = Object(src_lib["q" /* getIsAccessMyTraining */])();
        return isAccessMyTraining.toString() === 'true';
        // return true
    },
    isAccessMyCarReservation: function isAccessMyCarReservation() {
        var isAccessMyCarReservation = Object(src_lib["o" /* getIsAccessMyCarReservation */])();
        return isAccessMyCarReservation.toString() === 'true';
        // return true
    },
    isAccessAdminTracker: function isAccessAdminTracker() {
        var isAccessAdminTracker = Object(src_lib["n" /* getIsAccessAdminTracker */])();
        return isAccessAdminTracker.toString() === 'true';
    }
};

var routePermission_MyTrackerPrivateRoute = function MyTrackerPrivateRoute(_ref) {
    var Component = _ref.component,
        Layout = _ref.layout,
        staticContext = _ref.staticContext,
        rest = _objectWithoutProperties(_ref, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAccessMyTracker === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_MyTrainingPrivateRoute = function MyTrainingPrivateRoute(_ref2) {
    var Component = _ref2.component,
        Layout = _ref2.layout,
        staticContext = _ref2.staticContext,
        rest = _objectWithoutProperties(_ref2, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAccessMyTraining === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_MyCarReservationPrivateRoute = function MyCarReservationPrivateRoute(_ref3) {
    var Component = _ref3.component,
        Layout = _ref3.layout,
        staticContext = _ref3.staticContext,
        rest = _objectWithoutProperties(_ref3, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAccessMyCarReservation === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_AdminCarReservationPrivateRoute = function AdminCarReservationPrivateRoute(_ref4) {
    var Component = _ref4.component,
        Layout = _ref4.layout,
        staticContext = _ref4.staticContext,
        rest = _objectWithoutProperties(_ref4, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAdminCarReservation() === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_AdminTrainingPrivateRoute = function AdminTrainingPrivateRoute(_ref5) {
    var Component = _ref5.component,
        Layout = _ref5.layout,
        staticContext = _ref5.staticContext,
        rest = _objectWithoutProperties(_ref5, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAdminTraining() === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_AdminTrackerPrivateRoute = function AdminTrackerPrivateRoute(_ref6) {
    var Component = _ref6.component,
        Layout = _ref6.layout,
        staticContext = _ref6.staticContext,
        rest = _objectWithoutProperties(_ref6, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAccessAdminTracker() === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_DriverPrivateRoute = function DriverPrivateRoute(_ref7) {
    var Component = _ref7.component,
        Layout = _ref7.layout,
        staticContext = _ref7.staticContext,
        rest = _objectWithoutProperties(_ref7, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isDriver() === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_AdminPrivateRoute = function AdminPrivateRoute(_ref8) {
    var Component = _ref8.component,
        Layout = _ref8.layout,
        staticContext = _ref8.staticContext,
        rest = _objectWithoutProperties(_ref8, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isAdmin() === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_NPIPrivateRoute = function NPIPrivateRoute(_ref9) {
    var Component = _ref9.component,
        Layout = _ref9.layout,
        staticContext = _ref9.staticContext,
        rest = _objectWithoutProperties(_ref9, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Auth.isNpiAdmin() === false) {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_PrivateRoute = function PrivateRoute(_ref10) {
    var Component = _ref10.component,
        Layout = _ref10.layout,
        staticContext = _ref10.staticContext,
        rest = _objectWithoutProperties(_ref10, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                var urlIncoming = props.match.url;
                routePermission_setUrlIncome(urlIncoming);
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_PublicRoute = function PublicRoute(_ref11) {
    var Component = _ref11.component,
        Layout = _ref11.layout,
        staticContext = _ref11.staticContext,
        rest = _objectWithoutProperties(_ref11, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && props.match.url === '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return null;
                }
            }
        }
    }));
};

var routePermission_setUrlIncome = function setUrlIncome(url) {
    Object(src_lib["B" /* setUrlIncoming */])(url);
};


// CONCATENATED MODULE: ./src/app/routes/Routes.js





//Layout
var LayoutMaster = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 1101));
    }
});
var layoutLogin = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1102));
    }
});
var LayoutBlank = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1103));
    }
});
var LayoutWithMenu = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1104));
    }
});
var LayoutTracker = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1105));
    }
});
var LayoutCar = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1106));
    }
});

//Features

// const TrackerController = LoadableRoute({
//     loader: () => import('../components/features/tracker/home/controllers/trackerController'),
// })
//Auth
var Login = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1107));
    }
});
var bypassLoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 1108));
    }
});

var NotFoundController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 1109));
    }
});
var UnAuthenController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 1110));
    }
});
var LogoutController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1111));
    }
});

// Home
var HomeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 1112));
    }
});
var TrackerHomeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1113));
    }
});

// Info
var InfoController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 1114));
    }
});

// Task List
var TaskListController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1115));
    }
});

var MyTaskListController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1116));
    }
});
var MyTaskListNewController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1117));
    }
});

var MyDraftListController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1118));
    }
});

// Create Task
var CreateTaskController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1119));
    }
});

// View Draft Task
var ViewDraftTaskController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1120));
    }
});

// View My Task
var ViewMyTaskController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1121));
    }
});
// const ViewMyTaskController = LoadableRoute({
//     loader: () => import('../components/features/trackerTailwind/trakerNew/tracker/taskList/view/controllers/viewMyTaskController')
// });

// View Assign Task
var ViewAssignTaskController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1122));
    }
});

// Comment Controller
var CommentController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1123));
    }
});

// User Info
var UserInfoController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1124));
    }
});
var UserInfoNewController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1125));
    }
});

// Update OilPrice
var UpdateOilPRiceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 1126));
    }
});

// UpdateTask Controller
var UpdateTaskController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1127));
    }
});

var PrompayQRController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1128));
    }
});

//Settings

var MasterDataController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1129));
    }
});
var TrainingMasterDataController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 1130));
    }
});
var Calendar = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1131));
    }
    // loader: () => import('../components/features/carReserveTailwind/reserve/controllers/listCarReserveController')
});
var CarReserve = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1132));
    }
});
var TrackerCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1133));
    }
});
var TrackerList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1134));
    }
});
var TrackerListHistory = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1135));
    }
});
var TrackerHistory = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1136));
    }
});
var DriverReserve = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1137));
    }
});
var CarReserveMasterDataController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 1138));
    }
});
var ReportController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1139));
    }
});
// User Group
var ListUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1140));
    }
});

var CreateUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1141));
    }
});

var UpdateUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1142));
    }
});

var ViewUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1143));
    }
});

// Admin User Group
var ListAdminUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1144));
    }
});
// const NewListUserGroupController = LoadableRoute({
//     loader: () => import('../components/features/settings/admin/userGroup/controllers/NewlistUserGroupController')
// });
var NewListUserGroupController2 = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1145));
    }
});

var CreateAdminUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1146));
    }
});

var UpdateAdminUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1147));
    }
});

var ViewAdminUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1148));
    }
});

// Flow
var ListFlowController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1149));
    }
});

var CreateFlowController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1150));
    }
});

var UpdateFlowController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1151));
    }
});

var ViewFlowController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1152));
    }
});

// Course Type
var ListCourseTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1153));
    }
});

var CreateCourseTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1154));
    }
});

var UpdateCourseTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1155));
    }
});

var ViewCourseTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1156));
    }
});

// Course

var ListCourseWaitingApproveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1081));
    }
});

var DetailCourseWaitingApproveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1082));
    }
});

var ListCourseWaitingRequestController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1157));
    }
});

var DetailCourseWaitingRequestController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1158));
    }
});

var ScoreCertCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1083));
    }
});

var ListCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1084));
    }
});

var CreateCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1085));
    }
});

var UpdateCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1086));
    }
});

var ViewCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1087));
    }
});

// Course History

var ListCourseHistoryWaitingApproveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1159));
    }
});

var DetailCourseHistoryWaitingApproveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1160));
    }
});

var ScoreCertCourseHistoryController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1161));
    }
});

var ListCourseHistoryController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1162));
    }
});

var CreateCourseHistoryController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1163));
    }
});

var UpdateCourseHistoryController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1164));
    }
});

var ViewCourseHistoryController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1165));
    }
});

// Landing Page for Hr Module
var HrModuleHome = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 1166));
    }
});

var MyCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1167));
    }
});

var MyCertController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1168));
    }
});

//Report
var ReportCourseController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1169));
    }
});

//Report
var ReportCarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1170));
    }
});

// Car Reservervation
// Car Type
var ListCarTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1171));
    }
});

var CreateCarTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1172));
    }
});

var UpdateCarTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1173));
    }
});

var ViewCarTypeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1174));
    }
});
// User Group
var ListCarRUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1175));
    }
});

var CreateCarRUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1176));
    }
});

var UpdateCarRUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1177));
    }
});

var ViewCarRUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1178));
    }
});
// Car
var ListRCarController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1179));
    }
});

var CreateRCarController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1180));
    }
});

var UpdateRCarController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1181));
    }
});

var ViewRCarController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1182));
    }
});
// Car Driver
var GetCarDriverController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1183));
    }
});
var UpdateCarDriverController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1184));
    }
});

// Car Reserve
var CarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1185));
    }
});

var CarReserveHistoryController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1186));
    }
});

var CreateCarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1187));
    }
});

var UpdateCarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1188));
    }
});

var ViewCarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1189));
    }
});

var HistoryApproveCarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1190));
    }
});
var ApproveCarReserveController = loadableRoute({
    // loader: () => import('../components/features/carReserve/reserveApprove/controllers/reserveApproveControllers')
    loader: function loader() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1191));
    }
});
var ApproveCarReserveControllerVOld = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1192));
    }
    // loader: () => import('../components/features/ManageReserve/Controllers/ManageReserveController')
});

var DetailApproveCarReserveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1193));
    }
});

var DriverJobListController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1080));
    }
});

var DetailDriverJobListController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1194));
    }
});

var CalendarTest = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1195));
    }
});

var CalendarTest2 = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1196));
    }
});

var ProjectManagementController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 1197));
    }
});
var MyProjectController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 1198));
    }
});
var CreateProjectController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1199));
    }
});

var ViewProjectController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 1200));
    }
});
var UpdateProjectController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1201));
    }
});

var AddTimeSheetProjectController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1202));
    }
});

//Backend

var ListCustomerController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1203));
    }
});

var CreateCustomerController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1204));
    }
});

var UpdateCustomerController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1205));
    }
});

var ViewCustomerController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 1206));
    }
});
var Projects = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1207));
    }
});
var ProjectDetail = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1208));
    }
});
/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/view/:id/:active',
            component: ViewCourseHistoryController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/view/:id',
            component: ViewCourseHistoryController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/update/:id',
            component: UpdateCourseHistoryController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/scoreCert/:id',
            component: ScoreCertCourseHistoryController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/waitingapprove/:id',
            component: DetailCourseHistoryWaitingApproveController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course/view/:id/:active', component: ViewCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/car/view/:id', component: ViewRCarController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/car/update/:id', component: UpdateRCarController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, {
            path: '/carReserve/masterdata/userGroup/view/:id',
            component: ViewCarRUserGroupController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, {
            path: '/carReserve/masterdata/userGroup/update/:id',
            component: UpdateCarRUserGroupController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/carType/view/:id', component: ViewCarTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/carType/update/:id', component: UpdateCarTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course/update/:id', component: UpdateCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course/view/:id', component: ViewCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course/scoreCert/:id', component: ScoreCertCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/waitingrequest/:id',
            component: DetailCourseWaitingRequestController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/waitingapprove/:id',
            component: DetailCourseWaitingApproveController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/waitingapprove',
            component: ListCourseHistoryWaitingApproveController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/history/create',
            component: CreateCourseHistoryController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/coursetype/update/:id', component: UpdateCourseTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/coursetype/view/:id', component: ViewCourseTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/flow/update/:id', component: UpdateFlowController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/flow/view/:id', component: ViewFlowController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/project/setting/customers/view/:id', component: ViewCustomerController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/project/setting/customers/update/:id', component: UpdateCustomerController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/car/reserve/approve/history', component: HistoryApproveCarReserveController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve/approve/:id', component: DetailApproveCarReserveController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve/view/:id', component: ViewCarReserveController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve/update/:id', component: UpdateCarReserveController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, {
            path: '/carReserve/masterdata/carDriver/update',
            component: UpdateCarDriverController,
            layout: LayoutWithMenu
        }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/car/create', component: CreateRCarController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, {
            path: '/carReserve/masterdata/userGroup/create',
            component: CreateCarRUserGroupController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/carType/create', component: CreateCarTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course/create', component: CreateCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/waitingrequest',
            component: ListCourseWaitingRequestController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, {
            path: '/training/masterdata/course/waitingapprove',
            component: ListCourseWaitingApproveController,
            layout: LayoutMaster
        }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/coursetype/create', component: CreateCourseTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/flow/create', component: CreateFlowController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/masterdata/usergroupsadmin/update/:id', component: UpdateAdminUserGroupController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminTrackerPrivateRoute, { path: '/masterdata/usergroups/update/:id', component: UpdateUserGroupController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/masterdata/usergroupsadmin/view/:id', component: ViewAdminUserGroupController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminTrackerPrivateRoute, { path: '/masterdata/usergroups/view/:id', component: ViewUserGroupController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course/history', component: ListCourseHistoryController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/project/setting/customers/create', component: CreateCustomerController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve/history', component: CarReserveHistoryController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/carDriver', component: GetCarDriverController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/Car', component: ListRCarController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/userGroup', component: ListCarRUserGroupController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminCarReservationPrivateRoute, { path: '/carReserve/masterdata/carType', component: ListCarTypeController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_DriverPrivateRoute, { path: '/car/driver/:id', component: DetailDriverJobListController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve/approve', component: ApproveCarReserveController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve/create', component: CreateCarReserveController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/course', component: ListCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/coursetype', component: ListCourseTypeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminTrainingPrivateRoute, { path: '/training/masterdata/flow', component: ListFlowController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/comment/:taskM/:id', component: CommentController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/draft/view/:id', component: ViewDraftTaskController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/mytask/view/:id', component: ViewMyTaskController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/assingtask/view/:id', component: ViewAssignTaskController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/pm/view/:id', component: ViewProjectController, layout: layoutLogin }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/pm/timesheet/:id', component: AddTimeSheetProjectController, layout: layoutLogin }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/pm/update/:id', component: UpdateProjectController, layout: layoutLogin }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/masterdata/usergroupsadmin/create', component: CreateAdminUserGroupController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminTrackerPrivateRoute, { path: '/masterdata/usergroups/create', component: CreateUserGroupController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/project/setting/customers', component: ListCustomerController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_DriverPrivateRoute, { path: '/car/driver', component: DriverJobListController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/car/reserve', component: CarReserveController, layout: LayoutCar }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/masterdata/usergroupsadmin', component: NewListUserGroupController2, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_AdminTrackerPrivateRoute, { path: '/masterdata/usergroups', component: ListUserGroupController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/task/create', component: CreateTaskController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/update/:id', component: UpdateTaskController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/crshome/myCourse', component: MyCourseController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/crshome/history', component: MyCertController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report/carReserve', component: ReportCarReserveController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report/course', component: ReportCourseController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/carReserve/masterdata', component: CarReserveMasterDataController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/training/masterdata', component: TrainingMasterDataController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/pm/myProject', component: MyProjectController, layout: layoutLogin }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/carReserves/calendar', component: Calendar, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/pm/create', component: CreateProjectController, layout: layoutLogin }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/project/:id', component: ProjectDetail, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/logout', component: LogoutController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report', component: ReportController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/masterdata', component: MasterDataController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/info', component: InfoController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/userinfo', component: UserInfoController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/draft', component: MyDraftListController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/mytask', component: MyTaskListController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/tasklist', component: TaskListController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/oil', component: UpdateOilPRiceController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/projects', component: Projects, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/trackernew', component: TrackerCreate, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/trackerlist', component: TrackerList, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/listHistory', component: TrackerListHistory, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/trackerHistory', component: TrackerHistory, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/profile', component: UserInfoNewController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/carReserves', component: CarReserve, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/formydriver', component: DriverReserve, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/calendar2', component: CalendarTest2, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/calendar', component: CalendarTest, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/crshome', component: HrModuleHome, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/prompayqr', component: PrompayQRController, layout: LayoutTracker }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/pm', component: ProjectManagementController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/tracker', component: HomeController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/home', component: HomeController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/', component: HomeController, layout: LayoutWithMenu }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/unauthen', component: UnAuthenController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login', component: Login, layout: layoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/bypass/:base64', component: bypassLoginController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { component: NotFoundController })
    );
});
// CONCATENATED MODULE: ./src/app/routes/App.js



/* harmony default export */ var App = (function () {
    return react_default.a.createElement(Routes, null);
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(182);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 262 modules
var dist_es = __webpack_require__(63);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(20);

// CONCATENATED MODULE: ./src/app/redux/actions/actionsCallAPI.js
var actionsCallAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// import { CALL_API } from 'Middlewares'


function actionsCallAPI_setError(errorList, newError, isShow) {
	var mapError = [];
	if (errorList && Array.isArray(errorList)) {
		if (isShow === true) {
			errorList.forEach(function (e) {
				mapError.push(actionsCallAPI__extends({}, e, { isShow: true }));
			});
		} else {
			mapError = mapError.concat(errorList);
		}
	}
	if (newError) {
		mapError.push(actionsCallAPI__extends({}, newError, { isShow: false }));
	}
	return {
		type: types["_98" /* SET_ERROR */],
		error: mapError
	};
}

function actionsCallAPI_setLoading(isLoading) {
	return {
		type: types["_99" /* SET_LOADING */],
		isLoading: isLoading
	};
}
// EXTERNAL MODULE: ./src/app/redux/selectors/selectorCallAPI.js
var selectorCallAPI = __webpack_require__(194);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(137);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./src/app/components/features/config.js
var config = __webpack_require__(434);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/actionModal.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var actionModal_ActionModal = function (_React$Component) {
	_inherits(ActionModal, _React$Component);

	function ActionModal(props) {
		_classCallCheck(this, ActionModal);

		var _this = _possibleConstructorReturn(this, (ActionModal.__proto__ || Object.getPrototypeOf(ActionModal)).call(this, props));

		_this.state = {
			open: false
		};
		return _this;
	}

	_createClass(ActionModal, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    open = _props.open,
			    type = _props.type,
			    header = _props.header,
			    detail = _props.detail,
			    typeAction = _props.typeAction,
			    close = _props.close,
			    submit = _props.submit,
			    cancelButtonName = _props.cancelButtonName,
			    isAxError = _props.isAxError;


			var _type = 'question',
			    _header = '',
			    _detail = '',
			    classModal = '';

			if (type) {
				_type = type;
			}

			_header = header;
			_detail = detail;

			switch (_type) {
				case 'question':
					classModal = 'question';
					break;
				case 'warning':
					classModal = 'warning';
					break;
				case 'danger':
					classModal = 'danger' + (isAxError ? ' axError' : ''); //'danger'
					break;
				case 'detail':
					classModal = 'detail';
					break;
				case 'errorModal':
					classModal = 'errorModal';
					break;
				default:
					break;
			}

			return react_default.a.createElement(
				react_default.a.Fragment,
				null,
				react_default.a.createElement(
					dist_es["p" /* Modal */],
					{ open: open, onClose: close, size: classModal !== "detail" ? "tiny" : "large",
						className: 'module actionModal' },
					react_default.a.createElement(
						dist_es["p" /* Modal */].Header,
						{ className: 'headerBG ' + classModal },
						react_default.a.createElement(
							dist_es["h" /* Grid */],
							null,
							react_default.a.createElement(
								dist_es["h" /* Grid */].Row,
								null,
								react_default.a.createElement(
									dist_es["h" /* Grid */].Column,
									{ width: 16, className: 'inlineFlex' },
									react_default.a.createElement(
										'div',
										{ className: 'boxHeaderContent' },
										react_default.a.createElement(
											'div',
											{ className: 'boxImageClose', onClick: this.props.close },
											react_default.a.createElement('img', { src: config["a" /* iconCloseModalError */], alt: '' })
										)
									)
								)
							)
						)
					),
					react_default.a.createElement(
						dist_es["p" /* Modal */].Content,
						{ className: 'bodyBg ' + classModal },
						react_default.a.createElement(
							dist_es["p" /* Modal */].Description,
							null,
							react_default.a.createElement(
								dist_es["h" /* Grid */],
								null,
								react_default.a.createElement(
									dist_es["h" /* Grid */].Row,
									{ columns: 1 },
									react_default.a.createElement(
										dist_es["h" /* Grid */].Column,
										null,
										react_default.a.createElement(
											'div',
											{ className: 'boxTextHeader ' + classModal },
											react_default.a.createElement(
												'p',
												{ className: 'dialogHeader ' + classModal },
												_header
											)
										)
									)
								),
								react_default.a.createElement(
									dist_es["h" /* Grid */].Row,
									null,
									react_default.a.createElement(
										dist_es["h" /* Grid */].Column,
										{ width: 16 },
										react_default.a.createElement(
											'div',
											{ className: 'boxTextDetail' },
											react_default.a.createElement(
												'p',
												null,
												_detail
											),
											react_default.a.createElement('div', { className: 'boxAction' })
										)
									)
								),
								react_default.a.createElement(
									dist_es["h" /* Grid */].Row,
									null,
									react_default.a.createElement(
										dist_es["h" /* Grid */].Column,
										{ textAlign: 'center' },
										react_default.a.createElement(
											dist_es["a" /* Button */],
											{ className: 'btn btaBaseColor', onClick: close },
											cancelButtonName ? cancelButtonName : "Cancel"
										),
										typeAction === 'delete' && react_default.a.createElement(
											dist_es["a" /* Button */],
											{ className: 'btn delete', onClick: submit },
											'Delete'
										)
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return ActionModal;
}(react_default.a.Component);

/* harmony default export */ var actionModal = (actionModal_ActionModal);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(427);
var ReactToastify_default = /*#__PURE__*/__webpack_require__.n(ReactToastify);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/errorModal.js
var errorModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var errorModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function errorModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function errorModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function errorModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// import { toast, ToastContainer } from 'react-toastify'


var errorModal_ErrorModal = function (_React$Component) {
	errorModal__inherits(ErrorModal, _React$Component);

	function ErrorModal(props) {
		errorModal__classCallCheck(this, ErrorModal);

		var _this = errorModal__possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).call(this, props));

		_this.state = {};
		return _this;
	}

	errorModal__createClass(ErrorModal, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    errorList = _props.errorList,
			    t = _props.t;

			var axData = errorList.find(function (b) {
				return b.isAxError;
			});
			return (
				// <React.Fragment>
				// 	<ToastContainer
				// 		position="top-right"
				// 		autoClose={5000}
				// 		hideProgressBar={false}
				// 		newestOnTop={false}
				// 		closeOnClick
				// 		rtl={false}
				// 		pauseOnFocusLoss
				// 		draggable
				// 		pauseOnHover
				// 	/>

				// 	{
				// 		errorList.length > 0 &&
				// 		toast.error(<React.Fragment>
				// 			<p style={{ fontWeight: 'bold', color: 'white', fontSize: '1em' }}>{t('common.somethingWrong')}</p>
				// 			{
				// 				errorList.map((e, i) => {
				// 					const { message, path, code } = e
				// 					const data = { statusText: message, statusCode: path, code: code }
				// 					return <ItemErrorObj key={i} data={data} />

				// 				})
				// 			}
				// 		</React.Fragment>, {
				// 			position: "top-right",
				// 			autoClose: 5000,
				// 			hideProgressBar: false,
				// 			closeOnClick: true,
				// 			pauseOnHover: true,
				// 			draggable: true,
				// 			progress: undefined,
				// 		})
				// 	}
				// </React.Fragment>
				react_default.a.createElement(actionModal, errorModal__extends({
					isAxError: axData,
					typeAction: 'danger',
					type: 'danger',
					header: t('common.somethingWrong'),
					detail: react_default.a.createElement(
						dist_es["h" /* Grid */],
						null,
						react_default.a.createElement(
							dist_es["h" /* Grid */].Row,
							null,
							react_default.a.createElement(
								dist_es["h" /* Grid */].Column,
								null,
								react_default.a.createElement(
									dist_es["n" /* List */],
									{ divided: true, verticalAlign: 'middle', className: 'listCenter' },
									errorList.map(function (e, i) {
										var message = e.message,
										    path = e.path,
										    code = e.code;

										var data = { statusText: message, statusCode: path, code: code };
										return react_default.a.createElement(errorModal_ItemErrorObj, { key: i, data: data });
									})
								)
							)
						)
					)
				}, { open: errorList.length > 0, close: function close() {
						return _this2.props.setError(null, null, true);
					}, cancelButtonName: 'OK' }))
			);
		}
	}]);

	return ErrorModal;
}(react_default.a.Component);

var errorModal_ItemErrorObj = function ItemErrorObj(props) {
	var data = props.data;


	return react_default.a.createElement(
		dist_es["n" /* List */].Item,
		{ className: 'itemError' },
		react_default.a.createElement(
			dist_es["n" /* List */].Content,
			null,
			data.code && react_default.a.createElement(
				'p',
				{ style: { color: '#000', fontSize: '0.9em' } },
				data.code
			),
			react_default.a.createElement(
				'p',
				{ style: { color: '#000', fontSize: '0.9em' }, className: 'detailError header' },
				data.statusText
			)
		)
	);
};

/* harmony default export */ var errorModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
	return {
		errorList: Object(selectorCallAPI["a" /* getErrorList */])(state)
	};
}, function (dispatch, _ref) {
	var history = _ref.history;
	return {
		setError: function setError(errorList, newError, isShow) {
			dispatch(actionsCallAPI_setError(errorList, newError, isShow));
		}
	};
}), Object(Recompose["b" /* lifecycle */])({}))(errorModal_ErrorModal));
// EXTERNAL MODULE: ./src/app/components/features/share/loadingInline.js
var loadingInline = __webpack_require__(439);

// CONCATENATED MODULE: ./src/app/components/features/share/loading.js




var loading_Loading = function Loading(props) {
    var active = props && props.isActive ? props.isActive : false;

    return react_default.a.createElement(
        dist_es["c" /* Dimmer */],
        { style: { position: 'fixed', zIndex: '2100 !important' }, active: active },
        react_default.a.createElement(loadingInline["a" /* default */], null)
    );
};

/* harmony default export */ var share_loading = (loading_Loading);
// CONCATENATED MODULE: ./src/app/components/features/share/modal/loadingModal.js
var loadingModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function loadingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loadingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function loadingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var loadingModal_LoadingModal = function (_React$Component) {
	loadingModal__inherits(LoadingModal, _React$Component);

	function LoadingModal(props) {
		loadingModal__classCallCheck(this, LoadingModal);

		var _this = loadingModal__possibleConstructorReturn(this, (LoadingModal.__proto__ || Object.getPrototypeOf(LoadingModal)).call(this, props));

		_this.state = {
			isLoading: false
		};
		return _this;
	}

	loadingModal__createClass(LoadingModal, [{
		key: 'render',
		value: function render() {
			var loading = this.props.loading;


			return react_default.a.createElement(share_loading, { style: { zIndex: '2101 !important' }, isActive: loading });
		}
	}]);

	return LoadingModal;
}(react_default.a.Component);

/* harmony default export */ var loadingModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
	return {
		loading: Object(selectorCallAPI["b" /* getLoading */])(state)
	};
}, function (dispatch, _ref) {
	var history = _ref.history;
	return {
		setLoading: function setLoading(isLoading) {
			dispatch(actionsCallAPI_setLoading(isLoading));
		}
	};
}), Object(Recompose["b" /* lifecycle */])({}))(loadingModal_LoadingModal));
// EXTERNAL MODULE: ./src/app/components/scss/index.scss
var scss = __webpack_require__(721);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/app/routes/Root.js







// import ErrorBoundary from '../components/features/share/ErrorBoundary'

// import Loading from '../components/features/share/loading'


var store = configureStore_default()();

/* harmony default export */ var Root = (function () {
    return react_default.a.createElement(
        es["a" /* Provider */],
        { store: store },
        react_default.a.createElement(
            react_router_dom["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(App, null),
                react_default.a.createElement(errorModal, null),
                react_default.a.createElement(loadingModal, null)
            )
        )
    );
});
// EXTERNAL MODULE: ./src/wording/language/en/common.json
var common = __webpack_require__(724);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/wording/language/en/login.json
var login = __webpack_require__(725);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/wording/language/en/search.json
var search = __webpack_require__(726);
var search_default = /*#__PURE__*/__webpack_require__.n(search);

// EXTERNAL MODULE: ./src/wording/language/en/button.json
var en_button = __webpack_require__(727);
var button_default = /*#__PURE__*/__webpack_require__.n(en_button);

// EXTERNAL MODULE: ./src/wording/language/en/home.json
var home = __webpack_require__(728);
var home_default = /*#__PURE__*/__webpack_require__.n(home);

// EXTERNAL MODULE: ./src/wording/language/en/menu.json
var menu = __webpack_require__(729);
var menu_default = /*#__PURE__*/__webpack_require__.n(menu);

// EXTERNAL MODULE: ./src/wording/language/en/share.json
var share = __webpack_require__(730);
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/wording/language/en/user.json
var user = __webpack_require__(731);
var user_default = /*#__PURE__*/__webpack_require__.n(user);

// EXTERNAL MODULE: ./src/wording/language/en/master.json
var master = __webpack_require__(732);
var master_default = /*#__PURE__*/__webpack_require__.n(master);

// EXTERNAL MODULE: ./src/wording/language/en/systemInfo.json
var systemInfo = __webpack_require__(733);
var systemInfo_default = /*#__PURE__*/__webpack_require__.n(systemInfo);

// EXTERNAL MODULE: ./src/wording/language/en/tracker.json
var tracker = __webpack_require__(734);
var tracker_default = /*#__PURE__*/__webpack_require__.n(tracker);

// EXTERNAL MODULE: ./src/wording/language/en/settings.json
var settings = __webpack_require__(735);
var settings_default = /*#__PURE__*/__webpack_require__.n(settings);

// EXTERNAL MODULE: ./src/wording/language/en/training.json
var training = __webpack_require__(736);
var training_default = /*#__PURE__*/__webpack_require__.n(training);

// EXTERNAL MODULE: ./src/wording/language/en/settingsCarReservation.json
var settingsCarReservation = __webpack_require__(737);
var settingsCarReservation_default = /*#__PURE__*/__webpack_require__.n(settingsCarReservation);

// EXTERNAL MODULE: ./src/wording/language/en/car.json
var car = __webpack_require__(738);
var car_default = /*#__PURE__*/__webpack_require__.n(car);

// EXTERNAL MODULE: ./src/wording/language/en/driverJob.json
var driverJob = __webpack_require__(739);
var driverJob_default = /*#__PURE__*/__webpack_require__.n(driverJob);

// EXTERNAL MODULE: ./src/wording/language/en/project.json
var project = __webpack_require__(740);
var project_default = /*#__PURE__*/__webpack_require__.n(project);

// CONCATENATED MODULE: ./src/wording/language/en.js
var en__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















/* harmony default export */ var en = (en__extends({}, common_default.a, login_default.a, search_default.a, button_default.a, home_default.a, menu_default.a, share_default.a, user_default.a, master_default.a, systemInfo_default.a, tracker_default.a, settings_default.a, training_default.a, settingsCarReservation_default.a, car_default.a, driverJob_default.a, project_default.a));
// EXTERNAL MODULE: ./src/wording/language/th/common.json
var th_common = __webpack_require__(741);
var th_common_default = /*#__PURE__*/__webpack_require__.n(th_common);

// EXTERNAL MODULE: ./src/wording/language/th/login.json
var th_login = __webpack_require__(742);
var th_login_default = /*#__PURE__*/__webpack_require__.n(th_login);

// EXTERNAL MODULE: ./src/wording/language/th/search.json
var th_search = __webpack_require__(743);
var th_search_default = /*#__PURE__*/__webpack_require__.n(th_search);

// EXTERNAL MODULE: ./src/wording/language/th/button.json
var th_button = __webpack_require__(744);
var th_button_default = /*#__PURE__*/__webpack_require__.n(th_button);

// EXTERNAL MODULE: ./src/wording/language/th/home.json
var th_home = __webpack_require__(745);
var th_home_default = /*#__PURE__*/__webpack_require__.n(th_home);

// EXTERNAL MODULE: ./src/wording/language/th/menu.json
var th_menu = __webpack_require__(746);
var th_menu_default = /*#__PURE__*/__webpack_require__.n(th_menu);

// EXTERNAL MODULE: ./src/wording/language/th/share.json
var th_share = __webpack_require__(747);
var th_share_default = /*#__PURE__*/__webpack_require__.n(th_share);

// EXTERNAL MODULE: ./src/wording/language/th/user.json
var th_user = __webpack_require__(748);
var th_user_default = /*#__PURE__*/__webpack_require__.n(th_user);

// EXTERNAL MODULE: ./src/wording/language/th/master.json
var th_master = __webpack_require__(749);
var th_master_default = /*#__PURE__*/__webpack_require__.n(th_master);

// EXTERNAL MODULE: ./src/wording/language/th/systemInfo.json
var th_systemInfo = __webpack_require__(750);
var th_systemInfo_default = /*#__PURE__*/__webpack_require__.n(th_systemInfo);

// EXTERNAL MODULE: ./src/wording/language/th/tracker.json
var th_tracker = __webpack_require__(751);
var th_tracker_default = /*#__PURE__*/__webpack_require__.n(th_tracker);

// EXTERNAL MODULE: ./src/wording/language/th/settings.json
var th_settings = __webpack_require__(752);
var th_settings_default = /*#__PURE__*/__webpack_require__.n(th_settings);

// EXTERNAL MODULE: ./src/wording/language/th/training.json
var th_training = __webpack_require__(753);
var th_training_default = /*#__PURE__*/__webpack_require__.n(th_training);

// EXTERNAL MODULE: ./src/wording/language/th/car.json
var th_car = __webpack_require__(754);
var th_car_default = /*#__PURE__*/__webpack_require__.n(th_car);

// EXTERNAL MODULE: ./src/wording/language/th/driverJob.json
var th_driverJob = __webpack_require__(755);
var th_driverJob_default = /*#__PURE__*/__webpack_require__.n(th_driverJob);

// EXTERNAL MODULE: ./src/wording/language/th/settingsCarReservation.json
var th_settingsCarReservation = __webpack_require__(756);
var th_settingsCarReservation_default = /*#__PURE__*/__webpack_require__.n(th_settingsCarReservation);

// EXTERNAL MODULE: ./src/wording/language/th/project.json
var th_project = __webpack_require__(757);
var th_project_default = /*#__PURE__*/__webpack_require__.n(th_project);

// CONCATENATED MODULE: ./src/wording/language/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















/* harmony default export */ var th = (th__extends({}, th_common_default.a, th_login_default.a, th_search_default.a, th_button_default.a, th_home_default.a, th_menu_default.a, th_share_default.a, th_user_default.a, th_master_default.a, th_systemInfo_default.a, th_tracker_default.a, th_settings_default.a, th_training_default.a, th_car_default.a, th_driverJob_default.a, th_settingsCarReservation_default.a, th_project_default.a));
// CONCATENATED MODULE: ./src/index.js










Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('en');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root);

if (false) {
    module.hot.accept('./app/routes/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(465);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(71);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(466);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(426);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 95 modules
var redux_form_es = __webpack_require__(473);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerAuth.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var reducerAuth_initialState = {
    user: null
};

/* harmony default export */ var reducerAuth = ({
    authen: function authen() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialState;
        var action = arguments[1];

        switch (action.type) {
            default:
                return _extends({}, state);
        }
    }
});
// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(20);

// EXTERNAL MODULE: ./src/app/redux/settingsType.js
var settingsType = __webpack_require__(56);

// EXTERNAL MODULE: ./src/app/redux/carReservationType.js
var carReservationType = __webpack_require__(97);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCallAPI.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







var initialStateCallAPI = {
    isLoading: false,

    hasError: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
},
    initialStateArray = [];

/* harmony default export */ var reducerCallAPI = ({
    errorList: function errorList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateArray;
        var action = arguments[1];

        switch (action.type) {
            case types["_98" /* SET_ERROR */]:
                var newError = [];
                if (action && Array.isArray(action.error)) {
                    newError = action.error;
                }
                return newError;
            case types["e" /* CORE_AUTH_VERIFY_SUCCESS */]:
            case types["_30" /* CORE_GET_MASTERS_SUCCESS */]:
            case types["X" /* CORE_GET_ALL_MYTASKS_SUCCESS */]:
            case types["_33" /* CORE_GET_MYTASK_BY_ID_SUCCESS */]:
            case types["w" /* CORE_CREATE_MYTASK_SUCCESS */]:
            case types["_78" /* CORE_SUBMIT_TASK_SUCCESS */]:
            case types["q" /* CORE_COMMENT_TASK_SUCCESS */]:
            case types["_0" /* CORE_GET_ALL_MY_ASSIGN_SUCCESS */]:
            case types["_15" /* CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS */]:
            case types["_60" /* CORE_IN_PROGRESS_TASK_SUCCESS */]:
            case types["_6" /* CORE_GET_ALL_MY_DRAFT_SUCCESS */]:
            case types["_27" /* CORE_GET_DRAFT_TASK_BY_ID_SUCCESS */]:
            case types["_90" /* CORE_UPDATE_TASK_SUCCESS */]:
            case types["_93" /* CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS */]:
            case types["F" /* CORE_DONE_ASSIGN_TASK_SUCCESS */]:
            case types["C" /* CORE_DISCUSS_ASSIGN_TASK_SUCCESS */]:
            case types["c" /* CORE_ATTACH_TASK_SUCCESS */]:
            case types["n" /* CORE_CLOSED_TASK_SUCCESS */]:
            case types["k" /* CORE_CANCEL_TASK_SUCCESS */]:
            case types["_66" /* CORE_REOPEN_TASK_SUCCESS */]:
            case types["I" /* CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS */]:
            case types["_36" /* CORE_GET_OIL_PRICES_SUCCESS */]:
            case settingsType["_1" /* CORE_GET_ALL_FLOW_SUCCESS */]:
            case settingsType["_28" /* CORE_GET_FLOW_BY_ID_SUCCESS */]:
            case settingsType["A" /* CORE_CREATE_FLOW_SUCCESS */]:
            case settingsType["_43" /* CORE_UPDATE_FLOW_SUCCESS */]:
            case settingsType["_4" /* CORE_GET_ALL_USER_GROUP_SUCCESS */]:
            case settingsType["_31" /* CORE_GET_USER_GROUP_BY_ID_SUCCESS */]:
            case settingsType["D" /* CORE_CREATE_USER_GROUP_SUCCESS */]:
            case settingsType["_46" /* CORE_UPDATE_USER_GROUP_SUCCESS */]:
            case settingsType["G" /* CORE_DELETE_USER_GROUP_SUCCESS */]:
            case settingsType["P" /* CORE_GET_ALL_COURSE_SUCCESS */]:
            case settingsType["_7" /* CORE_GET_COURSE_BY_ID_SUCCESS */]:
            case settingsType["r" /* CORE_CREATE_COURSE_SUCCESS */]:
            case settingsType["_34" /* CORE_UPDATE_COURSE_SUCCESS */]:
            case settingsType["_10" /* CORE_GET_COURSE_IMAGE_SUCCESS */]:
            case settingsType["V" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS */]:
            case settingsType["l" /* CORE_APPROVE_COURSE_SUCCESS */]:
            case types["U" /* CORE_GET_ALL_COURSE_INCOMING_SUCCESS */]:
            case settingsType["_13" /* CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS */]:
            case settingsType["_19" /* CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS */]:
            case settingsType["_16" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS */]:
            case settingsType["i" /* CORE_ADD_POINT_BY_USER_SUCCESS */]:
            case settingsType["f" /* CORE_ADD_CERT_BY_USER_SUCCESS */]:
            case settingsType["S" /* CORE_GET_ALL_COURSE_TYPE_SUCCESS */]:
            case settingsType["_22" /* CORE_GET_COURSE_TYPE_BY_ID_SUCCESS */]:
            case settingsType["u" /* CORE_CREATE_COURSE_TYPE_SUCCESS */]:
            case settingsType["_37" /* CORE_UPDATE_COURSE_TYPE_SUCCESS */]:
            case types["R" /* CORE_GET_ALL_COURSE_HISTORY_SUCCESS */]:
            case settingsType["c" /* CORE_ADD_ATTACH_FILE_SUCCESS */]:
            case settingsType["o" /* CORE_CANCEL_COURSE_SUCCESS */]:
            case carReservationType["u" /* CORE_GET_ALL_CAR_TYPE_SUCCESS */]:
            case carReservationType["M" /* CORE_GET_MASTER_CAR_TYPE_SUCCESS */]:
            case carReservationType["f" /* CORE_CREATE_CAR_TYPE_SUCCESS */]:
            case carReservationType["Y" /* CORE_UPDATE_CAR_TYPE_SUCCESS */]:
            case carReservationType["c" /* CORE_CREATE_CAR_SUCCESS */]:
            case carReservationType["o" /* CORE_GET_ALL_CAR_DRIVER_SUCCESS */]:
            case carReservationType["S" /* CORE_UPDATE_CAR_DRIVER_SUCCESS */]:
            case types["t" /* CORE_CREATE_CAR_RESERVE_SUCCESS */]:
            case types["_81" /* CORE_UPDATE_CAR_RESERVE_SUCCESS */]:
            case types["h" /* CORE_CANCEL_CAR_RESERVE_SUCCESS */]:
            case types["_63" /* CORE_REJECT_CAR_RESERVE_SUCCESS */]:
            case types["_75" /* CORE_START_CAR_DRIVER_SUCCESS */]:
            case types["L" /* CORE_END_CAR_DRIVER_SUCCESS */]:
            case carReservationType["P" /* CORE_UPDATE_ACTIVE_CAR_SUCCESS */]:
            case types["z" /* CORE_CREATE_PROJECT_SUCCESS */]:
            case types["_87" /* CORE_UPDATE_PROJECT_SUCCESS */]:
            case types["_42" /* CORE_GET_PROJECT_SUCCESS */]:
                // if (action && typeof action.payload === 'object') {
                // 	let newError = []
                // 	newError.push({ code: "404", message: "test", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ระบบเป็นอะไรไม่รู้ บ้า เล่นอะไรไม่เอาไม่ดี", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
                // 	newError.push({ code: "404", message: "ลองดูอีกทีได้ไหม เริ่มต้นอีกทีได้ไหม แล้วฉันจะเป็นอย่างไร ใครจะรู้", isShow: true, isFromAction: true })
                // 	return newError
                // }
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        errors = _action$payload.errors,
                        result = _action$payload.result;
                    var url = action.url;

                    var _newError = [];
                    if (!result) {
                        if (Array.isArray(errors)) {
                            errors.map(function (e) {
                                var path = e.path,
                                    code = e.code,
                                    message = e.message;

                                return _newError.push({
                                    code: code,
                                    message: message,
                                    isShow: true,
                                    path: path,
                                    url: url,
                                    isFromAction: true
                                });
                            });
                        } else if (errors && errors.axError) {
                            if (Array.isArray(errors.errors)) {
                                errors.errors.map(function (e) {
                                    var path = e.path,
                                        message = e.message;

                                    return _newError.push({
                                        code: 'Please Contact AX Admin',
                                        message: message,
                                        isShow: true,
                                        isAxError: true,
                                        path: path,
                                        url: url,
                                        isFromAction: true
                                    });
                                });
                            } else _newError.push({
                                code: 'Please Contact AX Admin',
                                message: errors.errors,
                                isShow: true,
                                isAxError: true,
                                path: '',
                                url: url,
                                isFromAction: true
                            });
                        } else _newError.push({
                            code: 'unknow',
                            message: 'Some thing went wrong',
                            isShow: true,
                            path: '',
                            url: url,
                            isFromAction: true
                        });
                    }
                    console.log('newErroo', _newError);
                    return _newError;
                }
                return state;
            case types["d" /* CORE_AUTH_VERIFY_FAILURE */]:
            case types["_28" /* CORE_GET_MASTERS_FAILURE */]:
            case types["V" /* CORE_GET_ALL_MYTASKS_FAILURE */]:
            case types["_31" /* CORE_GET_MYTASK_BY_ID_FAILURE */]:
            case types["u" /* CORE_CREATE_MYTASK_FAILURE */]:
            case types["_76" /* CORE_SUBMIT_TASK_FAILURE */]:
            case types["o" /* CORE_COMMENT_TASK_FAILURE */]:
            case types["Y" /* CORE_GET_ALL_MY_ASSIGN_FAILURE */]:
            case types["_13" /* CORE_GET_ASSIGN_TASK_BY_ID_FAILURE */]:
            case types["_58" /* CORE_IN_PROGRESS_TASK_FAILURE */]:
            case types["_4" /* CORE_GET_ALL_MY_DRAFT_FAILURE */]:
            case types["_25" /* CORE_GET_DRAFT_TASK_BY_ID_FAILURE */]:
            case types["_88" /* CORE_UPDATE_TASK_FAILURE */]:
            case types["_91" /* CORE_WAITING_TEST_ASSIGN_TASK_FAILURE */]:
            case types["D" /* CORE_DONE_ASSIGN_TASK_FAILURE */]:
            case types["A" /* CORE_DISCUSS_ASSIGN_TASK_FAILURE */]:
            case types["a" /* CORE_ATTACH_TASK_FAILURE */]:
            case types["l" /* CORE_CLOSED_TASK_FAILURE */]:
            case types["i" /* CORE_CANCEL_TASK_FAILURE */]:
            case types["_64" /* CORE_REOPEN_TASK_FAILURE */]:
            case types["G" /* CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE */]:
            case types["_34" /* CORE_GET_OIL_PRICES_FAILURE */]:
            case settingsType["Z" /* CORE_GET_ALL_FLOW_FAILURE */]:
            case settingsType["_26" /* CORE_GET_FLOW_BY_ID_FAILURE */]:
            case settingsType["y" /* CORE_CREATE_FLOW_FAILURE */]:
            case settingsType["_41" /* CORE_UPDATE_FLOW_FAILURE */]:
            case settingsType["_2" /* CORE_GET_ALL_USER_GROUP_FAILURE */]:
            case settingsType["_29" /* CORE_GET_USER_GROUP_BY_ID_FAILURE */]:
            case settingsType["B" /* CORE_CREATE_USER_GROUP_FAILURE */]:
            case settingsType["_44" /* CORE_UPDATE_USER_GROUP_FAILURE */]:
            case settingsType["E" /* CORE_DELETE_USER_GROUP_FAILURE */]:
            case settingsType["K" /* CORE_GET_ALL_COURSE_FAILURE */]:
            case settingsType["_5" /* CORE_GET_COURSE_BY_ID_FAILURE */]:
            case settingsType["p" /* CORE_CREATE_COURSE_FAILURE */]:
            case settingsType["_32" /* CORE_UPDATE_COURSE_FAILURE */]:
            case settingsType["_8" /* CORE_GET_COURSE_IMAGE_FAILURE */]:
            case settingsType["T" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE */]:
            case settingsType["j" /* CORE_APPROVE_COURSE_FAILURE */]:
            case types["S" /* CORE_GET_ALL_COURSE_INCOMING_FAILURE */]:
            case settingsType["_11" /* CORE_GET_COURSE_INCOMING_BY_ID_FAILURE */]:
            case settingsType["_17" /* CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE */]:
            case settingsType["_14" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE */]:
            case settingsType["g" /* CORE_ADD_POINT_BY_USER_FAILURE */]:
            case settingsType["d" /* CORE_ADD_CERT_BY_USER_FAILURE */]:
            case settingsType["Q" /* CORE_GET_ALL_COURSE_TYPE_FAILURE */]:
            case settingsType["_20" /* CORE_GET_COURSE_TYPE_BY_ID_FAILURE */]:
            case settingsType["s" /* CORE_CREATE_COURSE_TYPE_FAILURE */]:
            case settingsType["_35" /* CORE_UPDATE_COURSE_TYPE_FAILURE */]:
            case types["P" /* CORE_GET_ALL_COURSE_HISTORY_FAILURE */]:
            case settingsType["a" /* CORE_ADD_ATTACH_FILE_FAILURE */]:
            case settingsType["m" /* CORE_CANCEL_COURSE_FAILURE */]:
            case carReservationType["s" /* CORE_GET_ALL_CAR_TYPE_FAILURE */]:
            case carReservationType["K" /* CORE_GET_MASTER_CAR_TYPE_FAILURE */]:
            case carReservationType["d" /* CORE_CREATE_CAR_TYPE_FAILURE */]:
            case carReservationType["W" /* CORE_UPDATE_CAR_TYPE_FAILURE */]:
            case carReservationType["a" /* CORE_CREATE_CAR_FAILURE */]:
            case carReservationType["j" /* CORE_GET_ALL_CAR_DRIVER_FAILURE */]:
            case carReservationType["Q" /* CORE_UPDATE_CAR_DRIVER_FAILURE */]:
            case types["r" /* CORE_CREATE_CAR_RESERVE_FAILURE */]:
            case types["_79" /* CORE_UPDATE_CAR_RESERVE_FAILURE */]:
            case types["f" /* CORE_CANCEL_CAR_RESERVE_FAILURE */]:
            case types["_61" /* CORE_REJECT_CAR_RESERVE_FAILURE */]:
            case types["_73" /* CORE_START_CAR_DRIVER_FAILURE */]:
            case types["J" /* CORE_END_CAR_DRIVER_FAILURE */]:
            case carReservationType["N" /* CORE_UPDATE_ACTIVE_CAR_FAILURE */]:
            case types["x" /* CORE_CREATE_PROJECT_FAILURE */]:
            case types["_85" /* CORE_UPDATE_PROJECT_FAILURE */]:
            case types["_40" /* CORE_GET_PROJECT_FAILURE */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        code = _action$payload2.code,
                        message = _action$payload2.message,
                        statusText = _action$payload2.statusText,
                        statusCode = _action$payload2.statusCode;

                    console.log(action);
                    var _url = action.url;

                    var _newError2 = [];

                    _newError2.push({
                        code: code ? code : statusCode ? statusCode : '404',
                        message: message ? message : statusText ? statusText : 'unknow',
                        isShow: false,
                        statusText: statusText,
                        statusCode: statusCode,
                        url: _url
                    });

                    return _newError2;
                }
                return state;
            default:
                return state;
        }
    },
    isLoading: function isLoading() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            // 	case CORE_GET_ALL_TRANSFERS_REQUEST:
            case types["_29" /* CORE_GET_MASTERS_REQUEST */]:
            case types["W" /* CORE_GET_ALL_MYTASKS_REQUEST */]:
            case types["_32" /* CORE_GET_MYTASK_BY_ID_REQUEST */]:
            case types["v" /* CORE_CREATE_MYTASK_REQUEST */]:
            case types["_77" /* CORE_SUBMIT_TASK_REQUEST */]:
            case types["p" /* CORE_COMMENT_TASK_REQUEST */]:
            case types["Z" /* CORE_GET_ALL_MY_ASSIGN_REQUEST */]:
            case types["_14" /* CORE_GET_ASSIGN_TASK_BY_ID_REQUEST */]:
            case types["_59" /* CORE_IN_PROGRESS_TASK_REQUEST */]:
            case types["_5" /* CORE_GET_ALL_MY_DRAFT_REQUEST */]:
            case types["_26" /* CORE_GET_DRAFT_TASK_BY_ID_REQUEST */]:
            case types["_89" /* CORE_UPDATE_TASK_REQUEST */]:
            case types["_92" /* CORE_WAITING_TEST_ASSIGN_TASK_REQUEST */]:
            case types["E" /* CORE_DONE_ASSIGN_TASK_REQUEST */]:
            case types["B" /* CORE_DISCUSS_ASSIGN_TASK_REQUEST */]:
            case types["b" /* CORE_ATTACH_TASK_REQUEST */]:
            case types["m" /* CORE_CLOSED_TASK_REQUEST */]:
            case types["j" /* CORE_CANCEL_TASK_REQUEST */]:
            case types["_65" /* CORE_REOPEN_TASK_REQUEST */]:
            case types["H" /* CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST */]:
            case types["_35" /* CORE_GET_OIL_PRICES_REQUEST */]:
            case types["_53" /* CORE_GET_USERS_REQUEST */]:
            case settingsType["_0" /* CORE_GET_ALL_FLOW_REQUEST */]:
            case settingsType["_27" /* CORE_GET_FLOW_BY_ID_REQUEST */]:
            case settingsType["z" /* CORE_CREATE_FLOW_REQUEST */]:
            case settingsType["_42" /* CORE_UPDATE_FLOW_REQUEST */]:
            case settingsType["_3" /* CORE_GET_ALL_USER_GROUP_REQUEST */]:
            case settingsType["_30" /* CORE_GET_USER_GROUP_BY_ID_REQUEST */]:
            case settingsType["C" /* CORE_CREATE_USER_GROUP_REQUEST */]:
            case settingsType["_45" /* CORE_UPDATE_USER_GROUP_REQUEST */]:
            case settingsType["F" /* CORE_DELETE_USER_GROUP_REQUEST */]:
            case settingsType["O" /* CORE_GET_ALL_COURSE_REQUEST */]:
            case settingsType["_6" /* CORE_GET_COURSE_BY_ID_REQUEST */]:
            case settingsType["q" /* CORE_CREATE_COURSE_REQUEST */]:
            case settingsType["_33" /* CORE_UPDATE_COURSE_REQUEST */]:
            case settingsType["_9" /* CORE_GET_COURSE_IMAGE_REQUEST */]:
            case settingsType["U" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST */]:
            case settingsType["k" /* CORE_APPROVE_COURSE_REQUEST */]:
            case types["T" /* CORE_GET_ALL_COURSE_INCOMING_REQUEST */]:
            case settingsType["_12" /* CORE_GET_COURSE_INCOMING_BY_ID_REQUEST */]:
            case settingsType["_18" /* CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST */]:
            case settingsType["_15" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST */]:
            case settingsType["h" /* CORE_ADD_POINT_BY_USER_REQUEST */]:
            case settingsType["e" /* CORE_ADD_CERT_BY_USER_REQUEST */]:
            case settingsType["R" /* CORE_GET_ALL_COURSE_TYPE_REQUEST */]:
            case settingsType["_21" /* CORE_GET_COURSE_TYPE_BY_ID_REQUEST */]:
            case settingsType["t" /* CORE_CREATE_COURSE_TYPE_REQUEST */]:
            case settingsType["_36" /* CORE_UPDATE_COURSE_TYPE_REQUEST */]:
            case carReservationType["t" /* CORE_GET_ALL_CAR_TYPE_REQUEST */]:
            case carReservationType["L" /* CORE_GET_MASTER_CAR_TYPE_REQUEST */]:
            case carReservationType["e" /* CORE_CREATE_CAR_TYPE_REQUEST */]:
            case carReservationType["X" /* CORE_UPDATE_CAR_TYPE_REQUEST */]:
            case carReservationType["b" /* CORE_CREATE_CAR_REQUEST */]:
            case carReservationType["n" /* CORE_GET_ALL_CAR_DRIVER_REQUEST */]:
            case carReservationType["R" /* CORE_UPDATE_CAR_DRIVER_REQUEST */]:
            case types["Q" /* CORE_GET_ALL_COURSE_HISTORY_REQUEST */]:
            case types["_23" /* CORE_GET_COURSE_BY_ID_INCOMING_REQUEST */]:
            case types["s" /* CORE_CREATE_CAR_RESERVE_REQUEST */]:
            case types["_80" /* CORE_UPDATE_CAR_RESERVE_REQUEST */]:
            case types["g" /* CORE_CANCEL_CAR_RESERVE_REQUEST */]:
            case types["_62" /* CORE_REJECT_CAR_RESERVE_REQUEST */]:
            case types["_74" /* CORE_START_CAR_DRIVER_REQUEST */]:
            case types["K" /* CORE_END_CAR_DRIVER_REQUEST */]:
            case settingsType["b" /* CORE_ADD_ATTACH_FILE_REQUEST */]:
            case settingsType["n" /* CORE_CANCEL_COURSE_REQUEST */]:
            case carReservationType["O" /* CORE_UPDATE_ACTIVE_CAR_REQUEST */]:
            case types["_2" /* CORE_GET_ALL_MY_CAR_RESERVE_REQUEST */]:
            case settingsType["X" /* CORE_GET_ALL_CUSTOMER_REQUEST */]:
            case settingsType["_24" /* CORE_GET_CUSTOMER_BY_ID_REQUEST */]:
            case settingsType["w" /* CORE_CREATE_CUSTOMER_REQUEST */]:
            case settingsType["_39" /* CORE_UPDATE_CUSTOMER_REQUEST */]:
            case carReservationType["U" /* CORE_UPDATE_CAR_REQUEST */]:
            case types["W" /* CORE_GET_ALL_MYTASKS_REQUEST */]:
            case carReservationType["z" /* CORE_GET_ALL_MY_JOB_DRIVER_REQUEST */]:
                return true;
            // 	case CORE_GET_ALL_TRANSFERS_SUCCESS:
            case types["_30" /* CORE_GET_MASTERS_SUCCESS */]:
            case types["X" /* CORE_GET_ALL_MYTASKS_SUCCESS */]:
            case types["_33" /* CORE_GET_MYTASK_BY_ID_SUCCESS */]:
            case types["w" /* CORE_CREATE_MYTASK_SUCCESS */]:
            case types["_78" /* CORE_SUBMIT_TASK_SUCCESS */]:
            case types["q" /* CORE_COMMENT_TASK_SUCCESS */]:
            case types["_0" /* CORE_GET_ALL_MY_ASSIGN_SUCCESS */]:
            case types["_15" /* CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS */]:
            case types["_60" /* CORE_IN_PROGRESS_TASK_SUCCESS */]:
            case types["_6" /* CORE_GET_ALL_MY_DRAFT_SUCCESS */]:
            case types["_27" /* CORE_GET_DRAFT_TASK_BY_ID_SUCCESS */]:
            case types["_90" /* CORE_UPDATE_TASK_SUCCESS */]:
            case types["_93" /* CORE_WAITING_TEST_ASSIGN_TASK_SUCCESS */]:
            case types["F" /* CORE_DONE_ASSIGN_TASK_SUCCESS */]:
            case types["C" /* CORE_DISCUSS_ASSIGN_TASK_SUCCESS */]:
            case types["c" /* CORE_ATTACH_TASK_SUCCESS */]:
            case types["n" /* CORE_CLOSED_TASK_SUCCESS */]:
            case types["k" /* CORE_CANCEL_TASK_SUCCESS */]:
            case types["_66" /* CORE_REOPEN_TASK_SUCCESS */]:
            case types["I" /* CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS */]:
            case types["_36" /* CORE_GET_OIL_PRICES_SUCCESS */]:
            case types["_54" /* CORE_GET_USERS_SUCCESS */]:
            case settingsType["_1" /* CORE_GET_ALL_FLOW_SUCCESS */]:
            case settingsType["_28" /* CORE_GET_FLOW_BY_ID_SUCCESS */]:
            case settingsType["A" /* CORE_CREATE_FLOW_SUCCESS */]:
            case settingsType["_43" /* CORE_UPDATE_FLOW_SUCCESS */]:
            case settingsType["_4" /* CORE_GET_ALL_USER_GROUP_SUCCESS */]:
            case settingsType["_31" /* CORE_GET_USER_GROUP_BY_ID_SUCCESS */]:
            case settingsType["D" /* CORE_CREATE_USER_GROUP_SUCCESS */]:
            case settingsType["_46" /* CORE_UPDATE_USER_GROUP_SUCCESS */]:
            case settingsType["G" /* CORE_DELETE_USER_GROUP_SUCCESS */]:
            case settingsType["P" /* CORE_GET_ALL_COURSE_SUCCESS */]:
            case settingsType["_7" /* CORE_GET_COURSE_BY_ID_SUCCESS */]:
            case settingsType["r" /* CORE_CREATE_COURSE_SUCCESS */]:
            case settingsType["_34" /* CORE_UPDATE_COURSE_SUCCESS */]:
            case settingsType["_10" /* CORE_GET_COURSE_IMAGE_SUCCESS */]:
            case settingsType["V" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS */]:
            case settingsType["l" /* CORE_APPROVE_COURSE_SUCCESS */]:
            case types["U" /* CORE_GET_ALL_COURSE_INCOMING_SUCCESS */]:
            case settingsType["_13" /* CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS */]:
            case settingsType["_19" /* CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS */]:
            case settingsType["_16" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS */]:
            case settingsType["i" /* CORE_ADD_POINT_BY_USER_SUCCESS */]:
            case settingsType["f" /* CORE_ADD_CERT_BY_USER_SUCCESS */]:
            case settingsType["S" /* CORE_GET_ALL_COURSE_TYPE_SUCCESS */]:
            case settingsType["_22" /* CORE_GET_COURSE_TYPE_BY_ID_SUCCESS */]:
            case settingsType["u" /* CORE_CREATE_COURSE_TYPE_SUCCESS */]:
            case settingsType["_37" /* CORE_UPDATE_COURSE_TYPE_SUCCESS */]:
            case carReservationType["u" /* CORE_GET_ALL_CAR_TYPE_SUCCESS */]:
            case carReservationType["M" /* CORE_GET_MASTER_CAR_TYPE_SUCCESS */]:
            case carReservationType["f" /* CORE_CREATE_CAR_TYPE_SUCCESS */]:
            case carReservationType["Y" /* CORE_UPDATE_CAR_TYPE_SUCCESS */]:
            case carReservationType["c" /* CORE_CREATE_CAR_SUCCESS */]:
            case carReservationType["o" /* CORE_GET_ALL_CAR_DRIVER_SUCCESS */]:
            case carReservationType["S" /* CORE_UPDATE_CAR_DRIVER_SUCCESS */]:
            case types["R" /* CORE_GET_ALL_COURSE_HISTORY_SUCCESS */]:
            case types["_24" /* CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS */]:
            case types["t" /* CORE_CREATE_CAR_RESERVE_SUCCESS */]:
            case types["_81" /* CORE_UPDATE_CAR_RESERVE_SUCCESS */]:
            case types["h" /* CORE_CANCEL_CAR_RESERVE_SUCCESS */]:
            case types["_63" /* CORE_REJECT_CAR_RESERVE_SUCCESS */]:
            case types["_75" /* CORE_START_CAR_DRIVER_SUCCESS */]:
            case types["L" /* CORE_END_CAR_DRIVER_SUCCESS */]:
            case settingsType["c" /* CORE_ADD_ATTACH_FILE_SUCCESS */]:
            case settingsType["o" /* CORE_CANCEL_COURSE_SUCCESS */]:
            case carReservationType["P" /* CORE_UPDATE_ACTIVE_CAR_SUCCESS */]:
            case types["_3" /* CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS */]:
            case settingsType["Y" /* CORE_GET_ALL_CUSTOMER_SUCCESS */]:
            case settingsType["_25" /* CORE_GET_CUSTOMER_BY_ID_SUCCESS */]:
            case settingsType["x" /* CORE_CREATE_CUSTOMER_SUCCESS */]:
            case settingsType["_40" /* CORE_UPDATE_CUSTOMER_SUCCESS */]:
            case carReservationType["V" /* CORE_UPDATE_CAR_SUCCESS */]:
            case carReservationType["A" /* CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS */]:
                return false;
            // 	case CORE_GET_ALL_TRANSFERS_FAILURE:
            case types["_28" /* CORE_GET_MASTERS_FAILURE */]:
            case types["V" /* CORE_GET_ALL_MYTASKS_FAILURE */]:
            case types["_31" /* CORE_GET_MYTASK_BY_ID_FAILURE */]:
            case types["u" /* CORE_CREATE_MYTASK_FAILURE */]:
            case types["_76" /* CORE_SUBMIT_TASK_FAILURE */]:
            case types["o" /* CORE_COMMENT_TASK_FAILURE */]:
            case types["Y" /* CORE_GET_ALL_MY_ASSIGN_FAILURE */]:
            case types["_13" /* CORE_GET_ASSIGN_TASK_BY_ID_FAILURE */]:
            case types["_58" /* CORE_IN_PROGRESS_TASK_FAILURE */]:
            case types["_4" /* CORE_GET_ALL_MY_DRAFT_FAILURE */]:
            case types["_25" /* CORE_GET_DRAFT_TASK_BY_ID_FAILURE */]:
            case types["_88" /* CORE_UPDATE_TASK_FAILURE */]:
            case types["_91" /* CORE_WAITING_TEST_ASSIGN_TASK_FAILURE */]:
            case types["D" /* CORE_DONE_ASSIGN_TASK_FAILURE */]:
            case types["A" /* CORE_DISCUSS_ASSIGN_TASK_FAILURE */]:
            case types["a" /* CORE_ATTACH_TASK_FAILURE */]:
            case types["l" /* CORE_CLOSED_TASK_FAILURE */]:
            case types["i" /* CORE_CANCEL_TASK_FAILURE */]:
            case types["_64" /* CORE_REOPEN_TASK_FAILURE */]:
            case types["G" /* CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE */]:
            case types["_34" /* CORE_GET_OIL_PRICES_FAILURE */]:
            case types["_52" /* CORE_GET_USERS_FAILURE */]:
            case settingsType["Z" /* CORE_GET_ALL_FLOW_FAILURE */]:
            case settingsType["_26" /* CORE_GET_FLOW_BY_ID_FAILURE */]:
            case settingsType["y" /* CORE_CREATE_FLOW_FAILURE */]:
            case settingsType["_41" /* CORE_UPDATE_FLOW_FAILURE */]:
            case settingsType["_2" /* CORE_GET_ALL_USER_GROUP_FAILURE */]:
            case settingsType["_29" /* CORE_GET_USER_GROUP_BY_ID_FAILURE */]:
            case settingsType["B" /* CORE_CREATE_USER_GROUP_FAILURE */]:
            case settingsType["_44" /* CORE_UPDATE_USER_GROUP_FAILURE */]:
            case settingsType["E" /* CORE_DELETE_USER_GROUP_FAILURE */]:

            case settingsType["K" /* CORE_GET_ALL_COURSE_FAILURE */]:
            case settingsType["_5" /* CORE_GET_COURSE_BY_ID_FAILURE */]:
            case settingsType["p" /* CORE_CREATE_COURSE_FAILURE */]:
            case settingsType["_32" /* CORE_UPDATE_COURSE_FAILURE */]:
            case settingsType["_8" /* CORE_GET_COURSE_IMAGE_FAILURE */]:
            case settingsType["T" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE */]:
            case settingsType["j" /* CORE_APPROVE_COURSE_FAILURE */]:
            case types["S" /* CORE_GET_ALL_COURSE_INCOMING_FAILURE */]:
            case settingsType["_11" /* CORE_GET_COURSE_INCOMING_BY_ID_FAILURE */]:
            case settingsType["_17" /* CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE */]:
            case settingsType["_14" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE */]:
            case settingsType["g" /* CORE_ADD_POINT_BY_USER_FAILURE */]:
            case settingsType["d" /* CORE_ADD_CERT_BY_USER_FAILURE */]:
            case settingsType["Q" /* CORE_GET_ALL_COURSE_TYPE_FAILURE */]:
            case settingsType["_20" /* CORE_GET_COURSE_TYPE_BY_ID_FAILURE */]:
            case settingsType["s" /* CORE_CREATE_COURSE_TYPE_FAILURE */]:
            case settingsType["_35" /* CORE_UPDATE_COURSE_TYPE_FAILURE */]:
            case carReservationType["s" /* CORE_GET_ALL_CAR_TYPE_FAILURE */]:
            case carReservationType["K" /* CORE_GET_MASTER_CAR_TYPE_FAILURE */]:
            case carReservationType["d" /* CORE_CREATE_CAR_TYPE_FAILURE */]:
            case carReservationType["W" /* CORE_UPDATE_CAR_TYPE_FAILURE */]:
            case carReservationType["a" /* CORE_CREATE_CAR_FAILURE */]:
            case carReservationType["j" /* CORE_GET_ALL_CAR_DRIVER_FAILURE */]:
            case carReservationType["Q" /* CORE_UPDATE_CAR_DRIVER_FAILURE */]:
            case types["P" /* CORE_GET_ALL_COURSE_HISTORY_FAILURE */]:
            case types["_22" /* CORE_GET_COURSE_BY_ID_INCOMING_FAILURE */]:
            case types["r" /* CORE_CREATE_CAR_RESERVE_FAILURE */]:
            case types["_79" /* CORE_UPDATE_CAR_RESERVE_FAILURE */]:
            case types["f" /* CORE_CANCEL_CAR_RESERVE_FAILURE */]:
            case types["_61" /* CORE_REJECT_CAR_RESERVE_FAILURE */]:
            case types["_73" /* CORE_START_CAR_DRIVER_FAILURE */]:
            case types["J" /* CORE_END_CAR_DRIVER_FAILURE */]:
            case settingsType["a" /* CORE_ADD_ATTACH_FILE_FAILURE */]:
            case settingsType["m" /* CORE_CANCEL_COURSE_FAILURE */]:
            case carReservationType["N" /* CORE_UPDATE_ACTIVE_CAR_FAILURE */]:
            case types["_1" /* CORE_GET_ALL_MY_CAR_RESERVE_FAILURE */]:
            case settingsType["W" /* CORE_GET_ALL_CUSTOMER_FAILURE */]:
            case settingsType["_23" /* CORE_GET_CUSTOMER_BY_ID_FAILURE */]:
            case settingsType["v" /* CORE_CREATE_CUSTOMER_FAILURE */]:
            case types["_41" /* CORE_GET_PROJECT_REQUEST */]:
            case settingsType["_38" /* CORE_UPDATE_CUSTOMER_FAILURE */]:
            case carReservationType["T" /* CORE_UPDATE_CAR_FAILURE */]:
            case carReservationType["y" /* CORE_GET_ALL_MY_JOB_DRIVER_FAILURE */]:
                return false;
            default:
                return state;
        }
    },
    reducerCallAPI: function reducerCallAPI() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateCallAPI;
        var action = arguments[1];

        switch (action.type) {
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/user.js
var user__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var reducers_user = ({
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_56" /* CORE_GET_USER_INFO_REQUEST */]:
                return state;
            case types["_57" /* CORE_GET_USER_INFO_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && user__typeof(action.payload) === "object") {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_55" /* CORE_GET_USER_INFO_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    users: function users() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_53" /* CORE_GET_USERS_REQUEST */]:
                return state;
            case types["_54" /* CORE_GET_USERS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_52" /* CORE_GET_USERS_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/setting.js


var setting_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var reducers_setting = ({
    setting: function setting() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setting_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_47" /* CORE_GET_SETTINGS_REQUEST */]:
                return state;
            case types["_48" /* CORE_GET_SETTINGS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_46" /* CORE_GET_SETTINGS_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/info.js


var info_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var reducers_info = ({
    info: function info() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : info_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_50" /* CORE_GET_SYSTEM_INFO_REQUEST */]:
                return state;
            case types["_51" /* CORE_GET_SYSTEM_INFO_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["_49" /* CORE_GET_SYSTEM_INFO_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/mytracker.js


var mytracker_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var mytracker = ({
    master: function master() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mytracker_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_29" /* CORE_GET_MASTERS_REQUEST */]:
                return state;
            case types["_30" /* CORE_GET_MASTERS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_28" /* CORE_GET_MASTERS_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    tasks: function tasks() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mytracker_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["W" /* CORE_GET_ALL_MYTASKS_REQUEST */]:
            case types["Z" /* CORE_GET_ALL_MY_ASSIGN_REQUEST */]:
            case types["_5" /* CORE_GET_ALL_MY_DRAFT_REQUEST */]:
                return state;
            case types["X" /* CORE_GET_ALL_MYTASKS_SUCCESS */]:
            case types["_0" /* CORE_GET_ALL_MY_ASSIGN_SUCCESS */]:
            case types["_6" /* CORE_GET_ALL_MY_DRAFT_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["V" /* CORE_GET_ALL_MYTASKS_FAILURE */]:
            case types["Y" /* CORE_GET_ALL_MY_ASSIGN_FAILURE */]:
            case types["_4" /* CORE_GET_ALL_MY_DRAFT_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    task: function task() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mytracker_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_32" /* CORE_GET_MYTASK_BY_ID_REQUEST */]:
            case types["_14" /* CORE_GET_ASSIGN_TASK_BY_ID_REQUEST */]:
            case types["_26" /* CORE_GET_DRAFT_TASK_BY_ID_REQUEST */]:
                return state;
            case types["_33" /* CORE_GET_MYTASK_BY_ID_SUCCESS */]:
            case types["_15" /* CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS */]:
            case types["_27" /* CORE_GET_DRAFT_TASK_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_31" /* CORE_GET_MYTASK_BY_ID_FAILURE */]:
            case types["_13" /* CORE_GET_ASSIGN_TASK_BY_ID_FAILURE */]:
            case types["_25" /* CORE_GET_DRAFT_TASK_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/oilPrice.js


var oilPrice_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var reducers_oilPrice = ({
    oilPrice: function oilPrice() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : oilPrice_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_38" /* CORE_GET_OIL_PRICE_REQUEST */]:
                return state;
            case types["_39" /* CORE_GET_OIL_PRICE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_37" /* CORE_GET_OIL_PRICE_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/testOilPrice.js


var testOilPrice_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var testOilPrice = ({
    oilPrices: function oilPrices() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : testOilPrice_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_35" /* CORE_GET_OIL_PRICES_REQUEST */]:
                return state;
            case types["_36" /* CORE_GET_OIL_PRICES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_34" /* CORE_GET_OIL_PRICES_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/settings/userGroup.js



var userGroup_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var userGroup = ({
    usergroups: function usergroups() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userGroup_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_3" /* CORE_GET_ALL_USER_GROUP_REQUEST */]:
                return state;
            case settingsType["_4" /* CORE_GET_ALL_USER_GROUP_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case settingsType["_2" /* CORE_GET_ALL_USER_GROUP_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    usergroup: function usergroup() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userGroup_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_30" /* CORE_GET_USER_GROUP_BY_ID_REQUEST */]:
                return state;
            case settingsType["_31" /* CORE_GET_USER_GROUP_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case settingsType["_29" /* CORE_GET_USER_GROUP_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/settings/flow.js



var flow_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var settings_flow = ({
    flows: function flows() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flow_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_0" /* CORE_GET_ALL_FLOW_REQUEST */]:
                return state;
            case settingsType["_1" /* CORE_GET_ALL_FLOW_SUCCESS */]:
                if (action.payload) {
                    console.log(action.payload);
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case settingsType["Z" /* CORE_GET_ALL_FLOW_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    flow: function flow() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flow_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_27" /* CORE_GET_FLOW_BY_ID_REQUEST */]:
                return state;
            case settingsType["_28" /* CORE_GET_FLOW_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case settingsType["_26" /* CORE_GET_FLOW_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/settings/courseType.js



var courseType_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var settings_courseType = ({
    courseTypes: function courseTypes() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : courseType_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["R" /* CORE_GET_ALL_COURSE_TYPE_REQUEST */]:
                return state;
            case settingsType["S" /* CORE_GET_ALL_COURSE_TYPE_SUCCESS */]:
                if (action.payload) {
                    console.log(action.payload);
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case settingsType["Q" /* CORE_GET_ALL_COURSE_TYPE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    courseType: function courseType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : courseType_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_21" /* CORE_GET_COURSE_TYPE_BY_ID_REQUEST */]:
                return state;
            case settingsType["_22" /* CORE_GET_COURSE_TYPE_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case settingsType["_20" /* CORE_GET_COURSE_TYPE_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/settings/course.js



var course_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var settings_course = ({
    courses: function courses() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : course_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["O" /* CORE_GET_ALL_COURSE_REQUEST */]:
            case settingsType["U" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST */]:
            case settingsType["_18" /* CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST */]:
                return state;
            case settingsType["P" /* CORE_GET_ALL_COURSE_SUCCESS */]:
            case settingsType["V" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS */]:
            case settingsType["_19" /* CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS */]:
                if (action.payload) {
                    console.log(action.payload);
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case settingsType["K" /* CORE_GET_ALL_COURSE_FAILURE */]:
            case settingsType["T" /* CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE */]:
            case settingsType["_17" /* CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    course: function course() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : course_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_6" /* CORE_GET_COURSE_BY_ID_REQUEST */]:
            case settingsType["_15" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST */]:
            case settingsType["_12" /* CORE_GET_COURSE_INCOMING_BY_ID_REQUEST */]:
                return state;
            case settingsType["_7" /* CORE_GET_COURSE_BY_ID_SUCCESS */]:
            case settingsType["_16" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS */]:
            case settingsType["_13" /* CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case settingsType["_5" /* CORE_GET_COURSE_BY_ID_FAILURE */]:
            case settingsType["_14" /* CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE */]:
            case settingsType["_11" /* CORE_GET_COURSE_INCOMING_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/settings/customer.js



var customer_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var settings_customer = ({
    customers: function customers() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : customer_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["X" /* CORE_GET_ALL_CUSTOMER_REQUEST */]:
                return state;
            case settingsType["Y" /* CORE_GET_ALL_CUSTOMER_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case settingsType["W" /* CORE_GET_ALL_CUSTOMER_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    customer: function customer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : customer_requestState;
        var action = arguments[1];

        switch (action.type) {
            case settingsType["_24" /* CORE_GET_CUSTOMER_BY_ID_REQUEST */]:
                return state;
            case settingsType["_25" /* CORE_GET_CUSTOMER_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case settingsType["_23" /* CORE_GET_CUSTOMER_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/course.js


var reducers_course_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var reducers_course = ({
    courseToJoins: function courseToJoins() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_course_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["T" /* CORE_GET_ALL_COURSE_INCOMING_REQUEST */]:
            case types["Q" /* CORE_GET_ALL_COURSE_HISTORY_REQUEST */]:
                return state;
            case types["U" /* CORE_GET_ALL_COURSE_INCOMING_SUCCESS */]:
            case types["R" /* CORE_GET_ALL_COURSE_HISTORY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["S" /* CORE_GET_ALL_COURSE_INCOMING_FAILURE */]:
            case types["P" /* CORE_GET_ALL_COURSE_HISTORY_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    courseToJoin: function courseToJoin() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_course_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_23" /* CORE_GET_COURSE_BY_ID_INCOMING_REQUEST */]:
                return state;
            case types["_24" /* CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_22" /* CORE_GET_COURSE_BY_ID_INCOMING_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/carReserve/carType.js



var carType_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var carReserve_carType = ({
    carTypes: function carTypes() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : carType_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["t" /* CORE_GET_ALL_CAR_TYPE_REQUEST */]:
                return state;
            case carReservationType["u" /* CORE_GET_ALL_CAR_TYPE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case carReservationType["s" /* CORE_GET_ALL_CAR_TYPE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    carType: function carType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : carType_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["I" /* CORE_GET_CAR_TYPE_BY_ID_REQUEST */]:
                return state;
            case carReservationType["J" /* CORE_GET_CAR_TYPE_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case carReservationType["H" /* CORE_GET_CAR_TYPE_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    masterCarType: function masterCarType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : carType_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["L" /* CORE_GET_MASTER_CAR_TYPE_REQUEST */]:
                return state;
            case carReservationType["M" /* CORE_GET_MASTER_CAR_TYPE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case carReservationType["K" /* CORE_GET_MASTER_CAR_TYPE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/carReserve/car.js



var car_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var carReserve_car = ({
    cars: function cars() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["q" /* CORE_GET_ALL_CAR_REQUEST */]:
                return state;
            case carReservationType["r" /* CORE_GET_ALL_CAR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case carReservationType["p" /* CORE_GET_ALL_CAR_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    car: function car() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["C" /* CORE_GET_CAR_BY_ID_REQUEST */]:
                return state;
            case carReservationType["D" /* CORE_GET_CAR_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case carReservationType["B" /* CORE_GET_CAR_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    oilType: function oilType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["w" /* CORE_GET_ALL_FUEL_REQUEST */]:
                return state;
            case carReservationType["x" /* CORE_GET_ALL_FUEL_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        datas = _action$payload3.datas;

                    console.log('789', action.payload);
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case carReservationType["v" /* CORE_GET_ALL_FUEL_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    carById: function carById() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["F" /* CORE_GET_CAR_RESERVE_BY_ID_REQUEST */]:
                return state;
            case carReservationType["G" /* CORE_GET_CAR_RESERVE_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        data = _action$payload4.data;

                    if (result && data) {
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case carReservationType["E" /* CORE_GET_CAR_RESERVE_BY_ID_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    requestLists: function requestLists() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_11" /* CORE_GET_APPROVE_LIST_REQUEST */]:
                return state;
            case types["_12" /* CORE_GET_APPROVE_LIST_SUCCESS */]:
                if (action.payload) {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        datas = _action$payload5.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_10" /* CORE_GET_APPROVE_LIST_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/carReserve/carDriver.js



var carDriver_requestState = types["_97" /* REQUEST_STATE */];
/* harmony default export */ var carReserve_carDriver = ({
    carDriver: function carDriver() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : carDriver_requestState;
        var action = arguments[1];

        switch (action.type) {
            case carReservationType["n" /* CORE_GET_ALL_CAR_DRIVER_REQUEST */]:
            case carReservationType["l" /* CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST */]:
            case carReservationType["z" /* CORE_GET_ALL_MY_JOB_DRIVER_REQUEST */]:
                return state;
            case carReservationType["o" /* CORE_GET_ALL_CAR_DRIVER_SUCCESS */]:
            case carReservationType["m" /* CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS */]:
            case carReservationType["A" /* CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data,
                        datas = _action$payload.datas;

                    if (result) {
                        return data ? data : datas;
                    } else return {};
                } else {
                    return {};
                }
            case carReservationType["j" /* CORE_GET_ALL_CAR_DRIVER_FAILURE */]:
            case carReservationType["k" /* CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE */]:
            case carReservationType["y" /* CORE_GET_ALL_MY_JOB_DRIVER_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/car.js


var reducers_car_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var reducers_car = ({
    carReserves: function carReserves() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["N" /* CORE_GET_ALL_CAR_RESERVE_REQUEST */]:
            case types["_17" /* CORE_GET_CAR_RESERVE_BY_BETWEEN_REQUEST */]:
            case types["_2" /* CORE_GET_ALL_MY_CAR_RESERVE_REQUEST */]:
                return state;
            case types["O" /* CORE_GET_ALL_CAR_RESERVE_SUCCESS */]:
            case types["_18" /* CORE_GET_CAR_RESERVE_BY_BETWEEN_SUCCESS */]:
            case types["_3" /* CORE_GET_ALL_MY_CAR_RESERVE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["M" /* CORE_GET_ALL_CAR_RESERVE_FAILURE */]:
            case types["_16" /* CORE_GET_CAR_RESERVE_BY_BETWEEN_FAILURE */]:
            case types["_1" /* CORE_GET_ALL_MY_CAR_RESERVE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    carReserve: function carReserve() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_car_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_20" /* CORE_GET_CAR_RESERVE_BY_ID_REQUEST */]:
                return state;
            case types["_21" /* CORE_GET_CAR_RESERVE_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas,
                        data = _action$payload2.data;

                    if (result && datas) {
                        return datas;
                    } else if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_19" /* CORE_GET_CAR_RESERVE_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/projectManagement.js


var projectManagement_requestState = types["_97" /* REQUEST_STATE */];

/* harmony default export */ var projectManagement = ({
    allProject: function allProject() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : projectManagement_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_8" /* CORE_GET_ALL_PROJECT_REQUEST */]:
                return state;
            case types["_9" /* CORE_GET_ALL_PROJECT_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_7" /* CORE_GET_ALL_PROJECT_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    project: function project() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : projectManagement_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_41" /* CORE_GET_PROJECT_REQUEST */]:
                return state;
            case types["_42" /* CORE_GET_PROJECT_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas,
                        data = _action$payload2.data;

                    if (result && datas) {
                        return datas;
                    } else if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_40" /* CORE_GET_PROJECT_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers.js


// import { reducer as notificationsReducer } from 'reapop'



























/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: reducers_user.users,
    user: reducers_user.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    info: reducers_info.info,
    settings: reducers_setting.setting,

    master: mytracker.master,
    task: mytracker.task,
    tasks: mytracker.tasks,
    oilprice: reducers_oilPrice.oilPrice,

    oilPrices: testOilPrice.oilPrices,

    usergroups: userGroup.usergroups,
    usergroup: userGroup.usergroup,

    flows: settings_flow.flows,
    flow: settings_flow.flow,

    courseTypes: settings_courseType.courseTypes,
    courseType: settings_courseType.courseType,
    courses: settings_course.courses,
    course: settings_course.course,

    courseToJoins: reducers_course.courseToJoins,
    courseToJoin: reducers_course.courseToJoin,

    carTypes: carReserve_carType.carTypes,
    carType: carReserve_carType.carType,
    masterCarType: carReserve_carType.masterCarType,

    cars: carReserve_car.cars,
    car: carReserve_car.car,
    oilType: carReserve_car.oilType,
    carDriver: carReserve_carDriver.carDriver,

    carReserves: reducers_car.carReserves,
    carReserve: reducers_car.carReserve,

    project: projectManagement.project,
    allProject: projectManagement.allProject,
    customers: settings_customer.customers,
    customer: settings_customer.customer,

    carById: carReserve_car.carById,
    requestLists: carReserve_car.requestLists
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_GET_ALL_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_GET_ALL_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_GET_ALL_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_GET_USER_GROUP_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_GET_USER_GROUP_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_GET_USER_GROUP_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CREATE_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_UPDATE_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_UPDATE_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_UPDATE_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_GET_ALL_FLOW_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_GET_ALL_FLOW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_GET_ALL_FLOW_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_GET_FLOW_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_GET_FLOW_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_GET_FLOW_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_FLOW_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_FLOW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_FLOW_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_UPDATE_FLOW_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_UPDATE_FLOW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_UPDATE_FLOW_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_GET_ALL_COURSE_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_GET_ALL_COURSE_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_GET_ALL_COURSE_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_GET_COURSE_TYPE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_GET_COURSE_TYPE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_GET_COURSE_TYPE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CREATE_COURSE_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CREATE_COURSE_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CREATE_COURSE_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_UPDATE_COURSE_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_UPDATE_COURSE_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_UPDATE_COURSE_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_GET_ALL_COURSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_GET_ALL_COURSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_GET_ALL_COURSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_GET_COURSE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_GET_COURSE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_GET_COURSE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CREATE_COURSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CREATE_COURSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CREATE_COURSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_UPDATE_COURSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_UPDATE_COURSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_UPDATE_COURSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_GET_COURSE_IMAGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_GET_COURSE_IMAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_GET_COURSE_IMAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_APPROVE_COURSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_APPROVE_COURSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_APPROVE_COURSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_GET_ALL_COURSE_INCOMING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_GET_ALL_COURSE_INCOMING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_GET_ALL_COURSE_INCOMING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_GET_COURSE_INCOMING_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_GET_COURSE_INCOMING_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_ADD_POINT_BY_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_ADD_POINT_BY_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_ADD_POINT_BY_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_ADD_CERT_BY_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_ADD_CERT_BY_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_ADD_CERT_BY_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_ADD_ATTACH_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_ADD_ATTACH_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_ADD_ATTACH_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CANCEL_COURSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CANCEL_COURSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CANCEL_COURSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_GET_ALL_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_GET_ALL_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_GET_ALL_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_GET_CUSTOMER_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_GET_CUSTOMER_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_GET_CUSTOMER_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CREATE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CREATE_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_UPDATE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_UPDATE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_UPDATE_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_DELETE_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_DELETE_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_DELETE_USER_GROUP_FAILURE; });
var CORE_GET_ALL_USER_GROUP_REQUEST = 'CORE_GET_ALL_USER_GROUP_REQUEST';
var CORE_GET_ALL_USER_GROUP_SUCCESS = 'CORE_GET_ALL_USER_GROUP_SUCCESS';
var CORE_GET_ALL_USER_GROUP_FAILURE = 'CORE_GET_ALL_USER_GROUP_FAILURE';

var CORE_GET_USER_GROUP_BY_ID_REQUEST = 'CORE_GET_USER_GROUP_BY_ID_REQUEST';
var CORE_GET_USER_GROUP_BY_ID_SUCCESS = 'CORE_GET_USER_GROUP_BY_ID_SUCCESS';
var CORE_GET_USER_GROUP_BY_ID_FAILURE = 'CORE_GET_USER_GROUP_BY_ID_FAILURE';

var CORE_CREATE_USER_GROUP_REQUEST = 'CORE_CREATE_USER_GROUP_REQUEST';
var CORE_CREATE_USER_GROUP_SUCCESS = 'CORE_CREATE_USER_GROUP_SUCCESS';
var CORE_CREATE_USER_GROUP_FAILURE = 'CORE_CREATE_USER_GROUP_FAILURE';

var CORE_UPDATE_USER_GROUP_REQUEST = 'CORE_UPDATE_USER_GROUP_REQUEST';
var CORE_UPDATE_USER_GROUP_SUCCESS = 'CORE_UPDATE_USER_GROUP_SUCCESS';
var CORE_UPDATE_USER_GROUP_FAILURE = 'CORE_UPDATE_USER_GROUP_FAILURE';

var CORE_GET_ALL_FLOW_REQUEST = 'CORE_GET_ALL_FLOW_REQUEST';
var CORE_GET_ALL_FLOW_SUCCESS = 'CORE_GET_ALL_FLOW_SUCCESS';
var CORE_GET_ALL_FLOW_FAILURE = 'CORE_GET_ALL_FLOW_FAILURE';

var CORE_GET_FLOW_BY_ID_REQUEST = 'CORE_GET_FLOW_BY_ID_REQUEST';
var CORE_GET_FLOW_BY_ID_SUCCESS = 'CORE_GET_FLOW_BY_ID_SUCCESS';
var CORE_GET_FLOW_BY_ID_FAILURE = 'CORE_GET_FLOW_BY_ID_FAILURE';

var CORE_CREATE_FLOW_REQUEST = 'CORE_CREATE_FLOW_REQUEST';
var CORE_CREATE_FLOW_SUCCESS = 'CORE_CREATE_FLOW_SUCCESS';
var CORE_CREATE_FLOW_FAILURE = 'CORE_CREATE_FLOW_FAILURE';

var CORE_UPDATE_FLOW_REQUEST = 'CORE_UPDATE_FLOW_REQUEST';
var CORE_UPDATE_FLOW_SUCCESS = 'CORE_UPDATE_FLOW_SUCCESS';
var CORE_UPDATE_FLOW_FAILURE = 'CORE_UPDATE_FLOW_FAILURE';

var CORE_GET_ALL_COURSE_TYPE_REQUEST = 'CORE_GET_ALL_COURSE_TYPE_REQUEST';
var CORE_GET_ALL_COURSE_TYPE_SUCCESS = 'CORE_GET_ALL_COURSE_TYPE_SUCCESS';
var CORE_GET_ALL_COURSE_TYPE_FAILURE = 'CORE_GET_ALL_COURSE_TYPE_FAILURE';

var CORE_GET_COURSE_TYPE_BY_ID_REQUEST = 'CORE_GET_COURSE_TYPE_BY_ID_REQUEST';
var CORE_GET_COURSE_TYPE_BY_ID_SUCCESS = 'CORE_GET_COURSE_TYPE_BY_ID_SUCCESS';
var CORE_GET_COURSE_TYPE_BY_ID_FAILURE = 'CORE_GET_COURSE_TYPE_BY_ID_FAILURE';

var CORE_CREATE_COURSE_TYPE_REQUEST = 'CORE_CREATE_COURSE_TYPE_REQUEST';
var CORE_CREATE_COURSE_TYPE_SUCCESS = 'CORE_CREATE_COURSE_TYPE_SUCCESS';
var CORE_CREATE_COURSE_TYPE_FAILURE = 'CORE_CREATE_COURSE_TYPE_FAILURE';

var CORE_UPDATE_COURSE_TYPE_REQUEST = 'CORE_UPDATE_COURSE_TYPE_REQUEST';
var CORE_UPDATE_COURSE_TYPE_SUCCESS = 'CORE_UPDATE_COURSE_TYPE_SUCCESS';
var CORE_UPDATE_COURSE_TYPE_FAILURE = 'CORE_UPDATE_COURSE_TYPE_FAILURE';

var CORE_GET_ALL_COURSE_REQUEST = 'CORE_GET_ALL_COURSE_REQUEST';
var CORE_GET_ALL_COURSE_SUCCESS = 'CORE_GET_ALL_COURSE_SUCCESS';
var CORE_GET_ALL_COURSE_FAILURE = 'CORE_GET_ALL_COURSE_FAILURE';

var CORE_GET_COURSE_BY_ID_REQUEST = 'CORE_GET_COURSE_BY_ID_REQUEST';
var CORE_GET_COURSE_BY_ID_SUCCESS = 'CORE_GET_COURSE_BY_ID_SUCCESS';
var CORE_GET_COURSE_BY_ID_FAILURE = 'CORE_GET_COURSE_BY_ID_FAILURE';

var CORE_CREATE_COURSE_REQUEST = 'CORE_CREATE_COURSE_REQUEST';
var CORE_CREATE_COURSE_SUCCESS = 'CORE_CREATE_COURSE_SUCCESS';
var CORE_CREATE_COURSE_FAILURE = 'CORE_CREATE_COURSE_FAILURE';

var CORE_UPDATE_COURSE_REQUEST = 'CORE_UPDATE_COURSE_REQUEST';
var CORE_UPDATE_COURSE_SUCCESS = 'CORE_UPDATE_COURSE_SUCCESS';
var CORE_UPDATE_COURSE_FAILURE = 'CORE_UPDATE_COURSE_FAILURE';

var CORE_GET_COURSE_IMAGE_REQUEST = 'CORE_GET_COURSE_IMAGE_REQUEST';
var CORE_GET_COURSE_IMAGE_SUCCESS = 'CORE_GET_COURSE_IMAGE_SUCCESS';
var CORE_GET_COURSE_IMAGE_FAILURE = 'CORE_GET_COURSE_IMAGE_FAILURE';

var CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST = 'CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST';
var CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS = 'CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS';
var CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE = 'CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE';

var CORE_APPROVE_COURSE_REQUEST = 'CORE_APPROVE_COURSE_REQUEST';
var CORE_APPROVE_COURSE_SUCCESS = 'CORE_APPROVE_COURSE_SUCCESS';
var CORE_APPROVE_COURSE_FAILURE = 'CORE_APPROVE_COURSE_FAILURE';

var CORE_GET_ALL_COURSE_INCOMING_REQUEST = 'CORE_GET_ALL_COURSE_INCOMING_REQUEST';
var CORE_GET_ALL_COURSE_INCOMING_SUCCESS = 'CORE_GET_ALL_COURSE_INCOMING_SUCCESS';
var CORE_GET_ALL_COURSE_INCOMING_FAILURE = 'CORE_GET_ALL_COURSE_INCOMING_FAILURE';

var CORE_GET_COURSE_INCOMING_BY_ID_REQUEST = 'CORE_GET_COURSE_INCOMING_BY_ID_REQUEST';
var CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS = 'CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS';
var CORE_GET_COURSE_INCOMING_BY_ID_FAILURE = 'CORE_GET_COURSE_INCOMING_BY_ID_FAILURE';

var CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST = 'CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST';
var CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS = 'CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS';
var CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE = 'CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE';

var CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST = 'CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST';
var CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS = 'CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS';
var CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE = 'CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE';

var CORE_ADD_POINT_BY_USER_REQUEST = 'CORE_ADD_POINT_BY_USER_REQUEST';
var CORE_ADD_POINT_BY_USER_SUCCESS = 'CORE_ADD_POINT_BY_USER_SUCCESS';
var CORE_ADD_POINT_BY_USER_FAILURE = 'CORE_ADD_POINT_BY_USER_FAILURE';

var CORE_ADD_CERT_BY_USER_REQUEST = 'CORE_ADD_CERT_BY_USER_REQUEST';
var CORE_ADD_CERT_BY_USER_SUCCESS = 'CORE_ADD_CERT_BY_USER_SUCCESS';
var CORE_ADD_CERT_BY_USER_FAILURE = 'CORE_ADD_CERT_BY_USER_FAILURE';

var CORE_ADD_ATTACH_FILE_REQUEST = 'CORE_ADD_ATTACH_FILE_REQUEST';
var CORE_ADD_ATTACH_FILE_SUCCESS = 'CORE_ADD_ATTACH_FILE_SUCCESS';
var CORE_ADD_ATTACH_FILE_FAILURE = 'CORE_ADD_ATTACH_FILE_FAILURE';

var CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST = 'CORE_DOWNLOAD_ONEDIRVE_FILE_REQUEST';
var CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS = 'CORE_DOWNLOAD_ONEDIRVE_FILE_SUCCESS';
var CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE = 'CORE_DOWNLOAD_ONEDIRVE_FILE_FAILURE';

var CORE_CANCEL_COURSE_REQUEST = 'CORE_CANCEL_COURSE_REQUEST';
var CORE_CANCEL_COURSE_SUCCESS = 'CORE_CANCEL_COURSE_SUCCESS';
var CORE_CANCEL_COURSE_FAILURE = 'CORE_CANCEL_COURSE_FAILURE';

var CORE_GET_ALL_CUSTOMER_REQUEST = 'CORE_GET_ALL_CUSTOMER_REQUEST';
var CORE_GET_ALL_CUSTOMER_SUCCESS = 'CORE_GET_ALL_CUSTOMER_SUCCESS';
var CORE_GET_ALL_CUSTOMER_FAILURE = 'CORE_GET_ALL_CUSTOMER_FAILURE';

var CORE_GET_CUSTOMER_BY_ID_REQUEST = 'CORE_GET_CUSTOMER_BY_ID_REQUEST';
var CORE_GET_CUSTOMER_BY_ID_SUCCESS = 'CORE_GET_CUSTOMER_BY_ID_SUCCESS';
var CORE_GET_CUSTOMER_BY_ID_FAILURE = 'CORE_GET_CUSTOMER_BY_ID_FAILURE';

var CORE_CREATE_CUSTOMER_REQUEST = 'CORE_CREATE_CUSTOMER_REQUEST';
var CORE_CREATE_CUSTOMER_SUCCESS = 'CORE_CREATE_CUSTOMER_SUCCESS';
var CORE_CREATE_CUSTOMER_FAILURE = 'CORE_CREATE_CUSTOMER_FAILURE';

var CORE_UPDATE_CUSTOMER_REQUEST = 'CORE_UPDATE_CUSTOMER_REQUEST';
var CORE_UPDATE_CUSTOMER_SUCCESS = 'CORE_UPDATE_CUSTOMER_SUCCESS';
var CORE_UPDATE_CUSTOMER_FAILURE = 'CORE_UPDATE_CUSTOMER_FAILURE';

var CORE_DELETE_USER_GROUP_REQUEST = 'CORE_DELETE_USER_GROUP_REQUEST';
var CORE_DELETE_USER_GROUP_SUCCESS = 'CORE_DELETE_USER_GROUP_SUCCESS';
var CORE_DELETE_USER_GROUP_FAILURE = 'CORE_DELETE_USER_GROUP_FAILURE';

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(722);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(189)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(68)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap);", ""]);
exports.i(__webpack_require__(435), "");
exports.i(__webpack_require__(438), "");
exports.i(__webpack_require__(723), "");

// module
exports.push([module.i, "@tailwind base;@tailwind components;@tailwind utilities;.fontMini,.module.errorModal .detailError{font-size:16px;font-size:1.6rem}.fontBody,.module.errorModal .detailError.detail,.module.inputForm .boxViewValue p,.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject,.module.layoutWithSidebar .menuSidebar,.module.layoutWithSidebar .sidebarBox .actionBox .userBox p,.module.layoutWithSidebar .sidebarBox .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .email,.ui.button,p{font-size:18px;font-size:1.8rem}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.form,.ui.input{font-size:18px!important;font-size:1.8rem!important}.fontHeader,.module.customTable .boxNoData p,.module.errorModal .detailError.header,.module.header .menu-item.text,.module.header .menuMobile,.module.inputForm .headerBoxHeaderTap,.module.itemSettingBox .boxTextHeaderSetting p,.module.menuData .boxMenu .itemMenu p,.module.popupUser .userContent .contentDetail .detailUser .name{font-size:20px!important;font-size:2rem!important}.boxHeaderPage p,.fontHeaderBody,.fontHeaderPage,.module.loginForm .text-box p{font-size:32px;font-size:3.2rem}.fontSettingValueView,.module.itemSettingBox .boxTextValueSetting p{font-size:24px;font-size:2.4rem}.fontStep,.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{font-size:16px!important;font-size:1.6rem!important}*{font-size:16px}.ui.button{font-family:unset!important}.outline{outline-style:none!important}.btn{border-radius:6px!important;min-height:40px!important;font-size:12px!important}.btn,.btnBase{min-width:96px!important;transition:all .2s ease-in-out 0s!important;font-weight:unset!important;margin:0 4px!important}.btnBase{border-radius:6px!important;color:#fff!important;border:1px solid #334454!important;background:#334454!important;height:36px!important}.btnGroup,.btnGroupView{background:transparent!important;margin:0!important;height:36px!important;font-size:12px!important;width:100px!important}.btnBaseGroup{border:1px solid #334454!important;display:flex;align-items:center;border-radius:4px!important}.btnBaseGroup,.displayy{min-width:100px!important;font-size:12px!important;height:36px!important}.btnBaseGroupview,.displayy{border:1px solid #334454!important}.btnBaseGroupview{min-height:45px;align-items:center;border-radius:4px!important}.btaBaseColor{background-color:#334454!important;color:#fff!important;border-radius:6px!important;min-width:96px!important;min-height:40px!important;transition:all .2s ease-in-out 0s!important;font-weight:unset!important;font-size:12px!important;margin:0 4px!important}.btaBaseColorview{margin-right:.1px!important;display:flex!important;justify-content:center!important;background:#fff!important;color:#334454!important}.btaBaseColorview:focus,.btnBaseGroupActive{background:#334454!important;color:#fff!important}.btnBaseGroupActive{transition:all .2s ease-in-out 0s!important;font-weight:unset!important}.btnBasic{background:#4299e1!important;border:1px solid #4299e1!important}.btnSuccess{background:#2f855a!important;border:1px solid #2f855a!important}.btnWarning{background:#ed8936!important;border:1px solid #ed8936!important}.btnError,.btnErrorSmall{background:#e53e3e!important;border:1px solid #e53e3e!important;color:#fff!important}.btnErrorSmall{max-width:60px!important;max-height:25px!important;font-size:10px!important}.btnInfo{background:#fff!important;color:#718096!important;border:1px solid #cbcbcb!important}.btnHardBlue{background:#2a4365!important;border:1px solid #2a4365!important}.btnLogin{background:#fff!important;box-shadow:0 1px 2px rgba(0,0,0,.15)!important;transition:all .2s ease-in-out 0s!important}.btnLogin:hover{box-shadow:0 4px 12px rgba(0,0,0,.3)!important;transform:translateY(-3px)!important}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui.steps .step .title,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,span{font-family:roboto}p{font-size:unset!important}.ui.modal{border-radius:15px}.menu-overwrite{height:unset!important}.hover-menu:hover{background:#303a4a!important}body{background-color:#fff}p{margin:0;color:#7c7c7c}.ui.checkbox,.ui.checkbox label,.ui.dropdown,.ui.form,.ui.form textarea,.ui.input,.ui.input input{color:#7c7c7c!important}.gridNogMargin,.gridNoPaddingMargin,.gridNoPaddingMargin>.column,.gridNoPaddingMargin>.row,.gridNoPaddingMargin>.row>.column{padding:0!important;margin:0!important}.gridColumnNoPaddingTB{padding-top:0!important;padding-bottom:0!important}.contentHeightMax{height:100%}.scrollListFormBox{height:140px;overflow-y:scroll;padding:1rem;background-color:#419bc4}.boxDatePicker{width:200px}.boxDatePicker.fluid{width:100%}.listSelectAll{padding-bottom:.42857143em;padding-top:.42857143em;background-color:#fff}.iWAAXb{padding:0 25px 0 10px!important}.ui.dimmer{z-index:2000!important;position:fixed!important}.iconMenuRowTable{cursor:pointer}.boxHeaderPage p{font-weight:700}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.customCarHeaderContent,.module.ViewReserveList{padding-top:215px}.customCarDriverHeaderContent,.module.ViewDriverList{padding-top:150px}.customCarDriverHeaderContentData,.module.ViewDriverList.data{padding-top:293px}.customHeaderContent,.customHeaderContentList,.customMasterHome,.module.user,.module.viewComment,.module.ViewCreateTask,.module.ViewTask,.module.ViewTaskList{padding-top:0}.customHeaderHrContent,.module.listCourse,.module.ViewReserveCreate{padding-top:55px}.customHeaderHrContentHistory,.module.listCourse.history{padding-top:165px}.customHeaderHrContentList{padding-top:18px}@media only screen and (max-width:767px){.customTContainer .boxHeader.desktop,.module.LayoutTracker .boxHeader.desktop{display:none}.customTContainer .boxBody .boxContent,.module.LayoutTracker .boxBody .boxContent{padding-top:50px}.customTContainer .stHeader,.module.LayoutTracker .stHeader{width:100%}.customTContainer .footer.clearBg,.module.LayoutTracker .footer.clearBg{width:99%}}@media only screen and (min-width:768px) and (max-width:991px){.customTContainer,.module.LayoutTracker{padding-left:20%;padding-right:20%}.customTContainer .footer.clearBg,.module.LayoutTracker .footer.clearBg{width:60%;margin-right:20%}.customTContainer .stHeader,.module.LayoutTracker .stHeader{width:60%;margin-left:20%}}@media only screen and (min-width:992px) and (max-width:1199px){.customTContainer,.module.LayoutTracker{padding-left:25%;padding-right:25%}.customTContainer .footer.clearBg,.module.LayoutTracker .footer.clearBg{width:50%;margin-right:25%}.customTContainer .stHeader,.module.LayoutTracker .stHeader{width:50%;margin-left:25%}}@media only screen and (min-width:1200px) and (max-width:1919px){.customTContainer,.module.LayoutTracker{padding-left:30%;padding-right:30%}.customTContainer .footer.clearBg,.module.LayoutTracker .footer.clearBg{width:39.5%;margin-right:30.5%}.customTContainer .stHeader,.module.LayoutTracker .stHeader{width:40%;margin-left:30%!important}}@media only screen and (min-width:1920px){.customTContainer,.module.LayoutTracker{padding-left:30%;padding-right:30%}.customTContainer .footer.clearBg,.module.LayoutTracker .footer.clearBg{width:39.5%;margin-right:30.5%}.customTContainer .stHeader,.module.LayoutTracker .stHeader{width:40%;margin-left:30%!important}}@media only screen and (max-width:767px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox,.module.LayoutTracker .stBody .stContent .contentSt{padding-left:10px;padding-right:10px}.customContainer .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop,.module.LayoutTracker .stBody .stContent .contentSt .boxHeader.desktop{display:none}.customContainer .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent .contentBox .boxBody .boxContent,.module.LayoutTracker .stBody .stContent .contentSt .boxBody .boxContent{padding-top:50px}.customContainer .module.transfer .desktop,.module.layoutMaster .module.transfer .desktop,.module.LayoutTracker .stBody .stContent .contentSt .module.transfer .desktop{display:none}}@media only screen and (min-width:768px) and (max-width:991px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox,.module.LayoutTracker .stBody .stContent .contentSt{padding-left:30px;padding-right:30px}.customContainer .boxHeader.desktop,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop,.module.layoutMaster .module.transfer .mobileSize,.module.LayoutTracker .stBody .stContent .contentSt .boxHeader.desktop,.module.LayoutTracker .stBody .stContent .contentSt .module.transfer .mobileSize{display:none}}@media only screen and (min-width:992px) and (max-width:1199px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox,.module.LayoutTracker .stBody .stContent .contentSt{padding-left:60px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize,.module.LayoutTracker .stBody .stContent .contentSt .boxHeader.mobile,.module.LayoutTracker .stBody .stContent .contentSt .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1200px) and (max-width:1919px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox,.module.LayoutTracker .stBody .stContent .contentSt{padding-left:60px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize,.module.LayoutTracker .stBody .stContent .contentSt .boxHeader.mobile,.module.LayoutTracker .stBody .stContent .contentSt .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1920px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox,.module.LayoutTracker .stBody .stContent .contentSt{padding-left:150px;padding-right:150px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize,.module.LayoutTracker .stBody .stContent .contentSt .boxHeader.mobile,.module.LayoutTracker .stBody .stContent .contentSt .module.transfer .mobileSize{display:none}}.scrollListFormBox{height:200px;overflow-y:auto;overflow-x:hidden;border:1px solid #e6e7e8;border-radius:.285714rem;background-color:#fff;padding:10px}.cursor-pointer{cursor:pointer}.div-flex{display:flex}p.white-space{white-space:normal}p.textDetailModal,p.white-space{color:rgba(0,0,0,.87);font-size:16px}b.textSubjectModal{font-size:16px;color:#2c75b7}.tooltip{position:relative;display:inline-block}.tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;z-index:1}.tooltip:hover .tooltiptext{visibility:visible}.MuiTypography-body1{font-size:1.5rem!important}.MuiTypography-body2{font-size:1.25rem!important}.MuiTypography-caption{font-size:1.2rem!important}.MuiTypography-subtitle1{font-size:2rem!important}.MuiButton-root{font-size:1.25rem!important}.MuiPickersModal-dialogRoot{width:370px!important}.MuiPickersBasePicker-pickerView{min-width:370px!important;width:370px}.flagMenu.active{width:30px;opacity:1;cursor:pointer}.flagMenu{opacity:.5;width:30px;cursor:pointer}.paddingLeft5{padding-left:5px}.padding10{padding:10px}.padding15{padding:15px}.padding20{padding:20px}.marginLeft5{margin-left:5px}.marginLeft10{margin-left:10px}.margin10{margin:10px}.ui.steps{border:none}.sc-gqjmRU{justify-content:center}.iBMnVw{cursor:pointer}.eRFaRs{overflow-y:unset!important}.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{border-radius:5px;min-width:100px;background-color:#e0e0e0;color:#7c7c7c}.ui.steps .step:after{display:none!important}.ui.steps .step.active,.ui.steps .step.active:hover{background-color:#419bc4!important}.ui.steps .step.active .title,.ui.steps .step.active .title:hover{color:#e0e0e0!important}.ui.steps a.step:hover{background-color:#e0e0e0!important}.ui.form .disabled.field,.ui.form .disabled.fields .field,.ui.form .field.disabled>label,.ui.form .field :disabled,.ui.form .fields.disabled>label{opacity:1}.ui.form .field>label{min-height:20px}.module.itemSettingBox .boxTextHeaderSetting p,.module.itemSettingBox .boxTextValueSetting p,.textOverflow{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ui.menu{background-color:#fff}.ui.form .field>.selection.dropdown{min-width:auto}.ui.selection.active.dropdown .menu{width:150px}.ui.input.error>input{background-color:#fff6f6;border-color:#e0b4b4;color:#9f3a38;-webkit-box-shadow:none;box-shadow:none}.ui.form .field .ui.input input,.ui.form .fields .field .ui.input input{padding:5px!important;font-weight:200}.MuiTableSortLabel-root{padding:5px 0!important;font-weight:800}.MuiTableRow-head,.MuiTableRow-hover,.MuiTableRow-root{padding:15px}.MuiTableCell-paddingNone{padding:inherit!important}.MuiTableCell-root,.MuiTablePagination-select{font-weight:300!important}.footer{position:fixed;bottom:0;right:0;padding:20px 10px;text-align:right;background-color:#fff}.footer.clearBg{z-index:4;padding:12px 10px;background-color:#fff}.footer.center,.footer.clearBg.center{text-align:center}.footer.mobile{padding:10px}.ui.form .field .ui.input,.ui.form .fields .field .ui.input,.ui.form .wide.field .ui.input{height:40px}.ui.disabled.input,.ui.input:not(.disabled) input[disabled]{opacity:.7}.ui.disabled.dropdown,.ui.disabled.dropdown .ui.dropdown>.text,.ui.disabled.input>input,.ui.disabled.input>input .ui.dropdown>.text,.ui.input:not(.disabled) input[disabled],.ui.input:not(.disabled) input[disabled] .ui.dropdown>.text{background-color:#dadada;color:#5a5a5a!important}.ui.form .inline.fields{margin:0}.ui.table thead{width:100%}.ui.sortable.table thead th{text-align:center;font-weight:700;background-color:#e4e4e4}.ui.celled.table tr td,.ui.celled.table tr th{overflow-wrap:anywhere}table tbody tr:nth-child(2n){background:#f7f5f5}.ui.sortable.table thead th.noSort:hover{background:#f7f7f7;color:inherit;cursor:inherit}.cursorPointer{cursor:pointer}.marginBottom10{margin-bottom:10px!important}.width100{width:100%!important}.homePage{width:100%;display:flex!important;justify-content:center;align-items:center!important;margin-top:35vh!important;text-align:center}.pageNotFound img.ui.image{display:inline-flex;width:250px}.pageNotFound .char404{font-size:36px;color:#ff2d2d}:root{--toastify-color-warning:#bc0ff1!important}:root .Toastify__toast--warning{background:#bc0ff1!important}@media{.page-break{display:none}}@media print{body,html{-webkit-print-color-adjust:exact}}@media print{.page-break{page-break-before:always}}.modalConfirm .textModal{color:#000}.modalConfirm .actionRow{text-align:center!important}.modalConfirm .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:5px;opacity:.3;cursor:pointer}.modalConfirm .boxImageClose img{display:block!important;width:100%;height:100%}.modalConfirm .boxImageClose:hover{opacity:unset}.modalConfirm .hdModal{padding:10 0}.modalConfirm .hdModal .ui.massive.rating{font-size:3rem}.modalConfirm .contentModal{margin-top:25px}.modalConfirm .ftBar{margin-top:10px;margin-bottom:20px}.modalConfirm .module.inputForm .labelInput .subject{font-weight:unset}.buttonAnimate .ui.button{padding:15px 40px!important;border-radius:25px}.component-class{height:calc(100vh - 100px);border-radius:1.5rem}.cube-folding{width:50px;height:50px;display:inline-block;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);transform:rotate(45deg);font-size:0}.cube-folding span{position:relative;width:25px;height:25px;-webkit-transform:scale(1.1);-moz-transform:scale(1.1);transform:scale(1.1);display:inline-block}.cube-folding span:before{content:\"\";background-color:#334155;position:absolute;left:0;top:0;display:block;width:25px;height:25px;-moz-transform-origin:100% 100%;-ms-transform-origin:100% 100%;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;-webkit-animation:folding 2.5s infinite linear both;-moz-animation:folding 2.5s infinite linear both;animation:folding 2.5s infinite linear both}.cube-folding .leaf2{-webkit-transform:rotate(90deg) scale(1.1);-moz-transform:rotate(90deg) scale(1.1);transform:rotate(90deg) scale(1.1)}.cube-folding .leaf2:before{-webkit-animation-delay:.3s;animation-delay:.3s;background-color:#293545}.cube-folding .leaf3{-webkit-transform:rotate(270deg) scale(1.1);-moz-transform:rotate(270deg) scale(1.1);transform:rotate(270deg) scale(1.1)}.cube-folding .leaf3:before{-webkit-animation-delay:.9s;animation-delay:.9s;background-color:#293545}.cube-folding .leaf4{-webkit-transform:rotate(180deg) scale(1.1);-moz-transform:rotate(180deg) scale(1.1);transform:rotate(180deg) scale(1.1)}.cube-folding .leaf4:before{-webkit-animation-delay:.6s;animation-delay:.6s;background-color:#202935}@-webkit-keyframes folding{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);-moz-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0deg);-moz-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg);-webkit-opacity:1;-moz-opacity:1;opacity:1}90%,to{-webkit-transform:perspective(140px) rotateY(180deg);-moz-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}}@-moz-keyframes folding{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);-moz-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0deg);-moz-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg);-webkit-opacity:1;-moz-opacity:1;opacity:1}90%,to{-webkit-transform:perspective(140px) rotateY(180deg);-moz-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}}@-ms-keyframes folding{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);-moz-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0deg);-moz-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg);-webkit-opacity:1;-moz-opacity:1;opacity:1}90%,to{-webkit-transform:perspective(140px) rotateY(180deg);-moz-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}}@keyframes folding{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);-moz-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0deg);-moz-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg);-webkit-opacity:1;-moz-opacity:1;opacity:1}90%,to{-webkit-transform:perspective(140px) rotateY(180deg);-moz-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);-webkit-opacity:0;-moz-opacity:0;opacity:0}}.cube-wrapper{position:absolute;left:50%;top:50%;margin-top:-50px;margin-left:-50px;width:100px;height:100px;text-align:center}.cube-wrapper:after{content:\"\";position:absolute;left:0;right:0;bottom:-20px;margin:auto;width:90px;height:6px;z-index:1;background-color:rgba(0,0,0,.1);-webkit-filter:blur(2px);filter:blur(2px);-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;-webkit-animation:shadow .5s ease infinite alternate;-moz-animation:shadow .5s ease infinite alternate;animation:shadow .5s ease infinite alternate}.cube-wrapper .loading{font-size:12px;letter-spacing:.1em;display:block;color:#334155;position:relative;top:25px;z-index:2;-webkit-animation:text .5s ease infinite alternate;-moz-animation:text .5s ease infinite alternate;animation:text .5s ease infinite alternate}@-webkit-keyframes text{to{top:35px}}@-moz-keyframes text{to{top:35px}}@-ms-keyframes text{to{top:35px}}@keyframes text{to{top:35px}}@-webkit-keyframes shadow{to{bottom:-18px;width:100px}}@-moz-keyframes shadow{to{bottom:-18px;width:100px}}@-ms-keyframes shadow{to{bottom:-18px;width:100px}}@keyframes shadow{to{bottom:-18px;width:100px}}.menu-height{height:100%;max-height:calc(100vh - 200px)}.fc .fc-view-harness-active>.fc-view{position:inherit!important}.DivManageReserveMainPage .DivHeadPage{font-size:25px;font-weight:700}.DivManageReserveMainPage .DivHeadPage .ButtonHeadPage{position:absolute;right:5%}.DivManageReserveMainPage .DivHeadPage .ButtonHeadPage .FallButtonType,.DivManageReserveMainPage .DivHeadPage .ButtonHeadPage .SuccessButtonType{background-color:#fff}.Divmainpage{width:100%;height:calc(100vh - 185px);overflow-x:auto}.TextInput{width:100%}.textDropdown{width:90%}.textlong{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.container-card-projects .wrapper-card .card{border:1px solid #94a3b8}.container-card-driver{width:100%;height:calc(100vh - 310px);overflow-x:auto}.container-card-radio{width:100%;height:calc(50vh - 428px);overflow-x:auto}.container-card-driver-view{width:100%;height:calc(70vh - 290px);overflow-x:auto}.container-card-user{width:100%;height:calc(100vh - 290px);overflow-x:auto}@media only screen and (min-width:989px) and (max-width:1440px){.container-card-driver{width:100%;height:calc(100vh - 375px);overflow-x:auto}}body,body>div{margin:0;padding:0;height:100%}.module.loadableRoute{height:100vh;display:flex;justify-content:center;align-items:center;height:calc(100vh - 110px)}.module.loadableRoute .ui.dimmer{position:relative!important;background-color:#bfc6cdfa!important}.module.loadableRouteFull{height:100vh;display:flex;justify-content:center;align-items:center}.module.loadableRouteFull .ui.dimmer{position:relative!important;background-color:#bfc6cdfa!important}.module.loadableController{height:100vh;display:flex;position:fixed;overflow:auto;justify-content:center;align-items:center}.module.switchLanguage{display:flex}.module.switchLanguage .language-item.select{background-color:#ccc}.module.errorBoundary .grid-header{padding-top:50px}.module.header{margin:0;box-shadow:0 4px 12px 0 rgba(0,0,0,.05)!important;background-color:#419bc4!important;position:absolute;width:100%;margin:0!important;top:0;z-index:2000}.module.header .logo-box{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.module.header .logo-box img{display:inline-block;max-width:100%;max-height:100%}.module.header .menu-item.logoUser{padding-top:0;padding-bottom:0}.module.header .menu-item.logo{padding:0;width:150px;height:50px}.module.header .menu-item.text p{color:#419bc4!important;font-weight:700}.module.header .menuBoxDesktop{width:100%}.module.header .menuBoxDesktop .menuRight{width:100%;height:100%;justify-content:flex-end}.module.header .menuBoxMobile{width:100%;display:flex}.module.header .menuMobile{padding:0!important}.module.header .menuMobile>i{display:none!important}.module.header .imageMenuMobile>i{margin:0!important}.module.header .itemMenuDropdown,.module.header .subMenuDropdown{width:180px}.module.header .userImage{width:40px;height:40px;border-radius:50%;overflow:hidden;cursor:pointer}.module.header .userImage img{width:100%;height:100%}.module.errorModal>.header{background-color:red}.module.errorModal>.actions,.module.errorModal>.header{border:none!important;padding:15px!important}.module.errorModal .boxHeaderContent{height:100px;display:flex;justify-content:center;align-items:center}.module.errorModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:15px;opacity:.3;cursor:pointer}.module.errorModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.errorModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.errorModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.errorModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.errorModal .itemError::-webkit-scrollbar{display:none}.module.errorModal .itemError{padding:10px 0!important}.module.errorModal .detailError{margin:0}.module.errorModal .detailError.header{font-weight:700}.module.errorModal .boxErrorParam{padding-left:15px}.module.actionModal{border-radius:10px}.module.actionModal .warning p{color:#419bc4}.module.actionModal .danger p{color:#000;text-align:center}.module.actionModal .danger .boxImageClose{margin-top:15px}.module.actionModal .headerBG{height:40px}.module.actionModal .headerBG.warning{background-color:#e6e7e8}.module.actionModal .headerBG.danger{background-color:#f59e8c}.module.actionModal .headerBG.danger.axError{background-color:#642395}.module.actionModal .headerBG.danger.axError .dialogHeader.padLeft20{color:#fff}.module.actionModal .headerBG.detail{background-color:#e6e7e8}.module.actionModal>.actions,.module.actionModal>.header{border:none!important;padding:15px!important}.module.actionModal .bodyBg{background-color:#f59e8c}.module.actionModal .boxHeaderContent{display:flex;justify-content:center;align-items:center;flex-direction:column}.module.actionModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:-5px;opacity:.3;cursor:pointer}.module.actionModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.actionModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.actionModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxTextHeader p{font-size:16px;font-weight:700}.module.actionModal .boxTextDetail{min-height:9vh;max-height:60vh;overflow-y:scroll;overflow-x:hidden}.module.actionModal .boxAction{margin-top:1.5rem;position:absolute;z-index:999;text-align:center;width:100%;margin-bottom:5px}.module.actionModal .ui.buttonDefault{font-size:16px;padding:5px;margin:0!important;background-color:#2e64ac;color:#fff;font-weight:unset;font-size:1.3rem;border-radius:50px;min-width:100px;height:35px}.module.actionModal .listCenter{text-align:center;max-height:100px}.module.inputForm{width:100%}.module.inputForm .formField{margin:0!important}.module.inputForm .formField.pickerType{position:relative}.module.inputForm .disabledInput{opacity:.45}.module.inputForm .boxViewValue{background-color:#fff;padding:1rem}.module.inputForm .boxViewValue p{margin:0!important}.module.inputForm .boxViewValue.mini{width:20%}.module.inputForm .boxViewValue.small{width:50%}.module.inputForm .labelInput p{margin:0!important}.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject{font-weight:700;display:inline-block}.module.inputForm .labelInput .required{color:red}.module.inputForm .boxDatePicker>.MuiFormControl-root{display:none!important}.module.inputForm .textValid{color:red}.module.inputForm .hidePicker{display:none}.module.inputForm .inputFile,.module.inputForm .inputFile input,.module.inputForm .inputPicker,.module.inputForm .inputPicker input{opacity:unset!important}.module.inputForm .btnPicker,.module.inputForm .btnUploadFile{position:absolute;top:50%;right:0;transform:translateY(-50%)}.module.inputForm .btnPicker button,.module.inputForm .btnUploadFile button{transform:translateX(-30%)}.module.inputForm .boxColumSubjectTop{padding-top:1rem!important}.module.inputForm .headerBoxHeaderTap{font-weight:700}.module.inputForm .editorInputHtml{max-height:275px!important;border:1px solid #e8e8e8!important;padding:5px!important;border-radius:10px!important;background-color:#fff}.module.inputForm .boxInputUploadFile{display:flex}.module.inputForm .boxInputUploadFile .inputBox{flex:1}.module.inputForm .boxInputUploadFile .actionBox{flex:0 0 auto}.module.inputForm .boxInputUploadFile .actionBox button{height:100%;margin-right:0;margin-left:.5rem}.module.popupUser .userContent{display:flex;widows:200px}.module.popupUser .userContent .contentImage{flex:0 0 auto;width:70px;height:70px;border-radius:50%;overflow:hidden}.module.popupUser .userContent .contentImage img{width:100%;height:100%}.module.popupUser .userContent .contentDetail{padding-left:1rem;flex:1}.module.popupUser .userContent .contentDetail .detailUser .name{font-weight:700}.module.popupUser .userAction{border-top:1px solid #ccc;display:flex;justify-content:flex-end;margin-top:1rem;padding-top:1rem}.module.popupUser .userAction button{padding-top:.5rem;padding-bottom:.5rem}.holiday{background:#f1f1f1}.speciaoHliday{background:#e85e6c}.fc-time-area .fc-rows td>div{height:100px!important;width:100px!important}.fc-highlightSelect{background-color:#4183c4;height:99px!important;margin-top:1px!important;margin-left:1px!important}.fc-eventCustom{background-color:red;border:1px solid #fff}.fc-holiday{background-color:#ccc}.module.customTable{padding-bottom:0;height:100%;width:100%;overflow:hidden}.module.customTable .boxNoData{padding:3rem 0}.module.customTable .boxNoData p{font-weight:700}.module.customTable .ui.icon.button{padding:0;width:50px;height:30px;font-size:13px}.module.customTable .ui.icon.button .i.icon,.module.customTable .ui.icon.button i.icons{padding-right:2px!important;color:#e0e0e0}.module.customTable .ui.icon.button.btnUndo{background-color:#279b54;margin-right:5px;color:#fff}.module.customTable .ui.icon.button.btnDelete{background-color:#d1052c;margin-right:5px;color:#fff}.module.customTable .rdt_TableCol :hover{color:#ddd!important}.eXjryM{overflow:hidden;text-overflow:ellipsis}.userListComponent p{font-size:1.2rem}.userListComponent .backCaret{cursor:pointer;height:15px}.userListComponent .row.item,.userListComponent .row.item p{cursor:pointer}.module.layoutWithSidebar .sidebarBox{position:fixed;display:flex;flex-direction:column;top:0;bottom:0;left:0;width:250px;background-color:#419bc4;overflow-x:hidden;flex:1}.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center;flex-direction:column}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox{max-width:230px;height:60px}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox img{height:100%;display:block}.module.layoutWithSidebar .sidebarBox .headerBox .text p{color:#419bc4;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox{border-top:1px solid #e6e7e8}.module.layoutWithSidebar .sidebarBox .actionBox .userBox p{color:#419bc4;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox{margin-top:10px}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox button{padding-top:5px;padding-bottom:5px;width:100%}.module.layoutWithSidebar .sidebarBox .headerBox{border-bottom:1px solid #419bc4}.module.layoutWithSidebar .sidebarBox .actionBox,.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px}.module.layoutWithSidebar .sidebarBox .menuBox{flex:1;overflow-y:auto}.module.layoutWithSidebar .bodyBox{margin-left:250px;min-width:550px;padding:2rem}.module.layoutWithSidebar .menuSidebar{width:100%;margin:0!important;min-height:unset;border:none;border-radius:unset}.module.layoutWithSidebar .menuSidebar .item{margin:0!important;color:#419bc4;font-weight:700;background-color:#419bc4;border-radius:unset!important}.module.layoutWithSidebar .menuSidebar .active.item,.module.layoutWithSidebar .menuSidebar .item:hover{border-radius:unset!important;color:#419bc4!important;background-color:#419bc4}.module.layoutWithSidebar .menuSidebar .active.item{margin:0!important;font-weight:700;cursor:unset!important}.module.layoutWithSidebar .menuSidebar .active.item:hover{border-radius:unset!important;color:#419bc4!important;background-color:#419bc4}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#419bc4}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar{width:10px;background-color:#419bc4}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-thumb{border-radius:0;background-color:#419bc4;border:2px solid #419bc4}.module.layoutBlank{height:100vh;height:calc(var(--vh, 1vh) * 100);overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center}.module.layoutMaster,.module.layoutMaster .boxBody{background-color:#fff;height:100vh}.module.layoutMaster .boxBody{display:flex;flex:1;flex-direction:column}.module.layoutMaster .boxBody .boxHeader.expand{width:250px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage{width:100%;padding:5px;display:inline-flex;height:50px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem{width:30%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem img.ui.image,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem img.ui.image{margin-top:10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem{width:70%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName{margin-top:-5px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName p{padding-top:5px;font-size:14px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .logout,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .logout{margin-top:-10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText{margin-top:10px;font-weight:400;text-align:left}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText p{font-size:13px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom{left:140px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom p{padding-left:15px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom .language{padding-left:8px}.module.layoutMaster .boxBody .boxHeader.expand .item.logo img.ui.image{width:180px;height:40px}.module.layoutMaster .boxBody .boxHeader{position:fixed;left:0;z-index:200;height:100vh;width:85px;background-color:#fff;border-right:1px solid #ccc;box-shadow:3px 0 7px #ccc;border-top-right-radius:10px}.module.layoutMaster .boxBody .boxHeader .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:10px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader .item.logo img.ui.image{width:40px;height:40px}.module.layoutMaster .boxBody .boxHeader .item{height:50px;overflow:hidden;cursor:pointer;width:100%}.module.layoutMaster .boxBody .boxHeader .item .itemIcon,.module.layoutMaster .boxBody .boxHeader .item .userImage{width:100%;text-align:center;height:40px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon img.ui.image,.module.layoutMaster .boxBody .boxHeader .item .userImage img.ui.image{left:45%;transform:translate(-45%);width:30px;height:30px;border-radius:5px;margin-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .itemIcon .logout,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .logout{text-align:left}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName{font-weight:700;padding-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName p,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName p{text-overflow:ellipsis;white-space:nowrap;height:30px;overflow:hidden;width:20ch}.module.layoutMaster .boxBody .boxHeader .item i.icon{padding-top:5px;text-align:center;font-size:30px;margin:0}.module.layoutMaster .boxBody .boxHeader .item .logout{cursor:pointer}.module.layoutMaster .boxBody .boxHeader .item .logout p{font-size:12px}.module.layoutMaster .boxBody .boxHeader .item.active{background-color:#e8e8e8}.module.layoutMaster .boxBody .boxHeader .item.line{border-top:1px solid #ccc;width:100%;height:1px;padding:0}.module.layoutMaster .boxBody .boxHeader .item.bottom{position:fixed;left:0;bottom:0;display:inline-table;padding:0;padding-bottom:10px;width:250px}.module.layoutMaster .boxBody .boxHeader .item.bottom p{font-size:12px;padding-left:8px}.module.layoutMaster .boxBody .boxHeader .item.bottom .language img.ui.image{display:inline;width:25px}.module.layoutMaster .boxBody .boxContent{padding-bottom:50px;height:100vh}.module.layoutMaster .boxBody .boxContent .contentBox{background-color:#fff;padding-top:2rem;width:100%;padding-bottom:100px}.module.layoutMaster .boxBody .boxHeader.mobile{width:100vw;z-index:200;position:fixed;left:0;height:45px;background-color:#f9f9f9}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo img.ui.image{width:30px;height:30px}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:3px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader.mobile.expand{height:100%;width:80vw}.module.layoutMaster .boxBody .boxHeader.mobile.expand .item.bottom{height:100vh;top:80%;left:50vw}.module.layoutMaster .logoImageHeader img{width:8rem;margin:0;display:inline-flex}.module.LayoutTracker{background-color:#f5f5f5!important;height:100vh}.module.LayoutTracker .stBody{display:flex;flex:1;height:100vh;flex-direction:column;background-color:#fff}.module.LayoutTracker .stBody .stHeader{position:fixed;left:0;z-index:200;padding:12px 15px;padding:14px 10px;background-color:#fff}.module.LayoutTracker .stBody .stHeader .layoutSection{width:100%}.module.LayoutTracker .stBody .stHeader .layoutSection .layoutLeft{float:left;width:30%}.module.LayoutTracker .stBody .stHeader .layoutSection .layoutCenter{display:inline-block;width:40%;text-align:center}.module.LayoutTracker .stBody .stHeader .layoutSection .layoutRight{margin-top:-32px!important;float:right;width:30%}.module.LayoutTracker .stBody .stHeader .layoutSection .layoutRight .carActionHeader{text-align:right;font-size:9.5pt;cursor:pointer}.module.LayoutTracker .stBody .stHeader .taskListSelect{display:inline-flex}.module.LayoutTracker .stBody .stHeader .taskListSelect img.ui.image.selectListMode{width:10px;height:10px;margin-top:7px;margin-left:10px}.module.LayoutTracker .stBody .stHeader.test{position:fixed;background-color:unset}.module.LayoutTracker .stBody .stHeader .selectMenuItem{cursor:pointer;display:inline-flex}.module.LayoutTracker .stBody .stHeader .selectMenuItem .selectListMode{margin-top:6px;margin-left:3px;width:10px;height:10px}.module.LayoutTracker .stBody .stHeader.action{margin-top:40px}.module.LayoutTracker .stBody .stHeader.expand{z-index:202;width:300px;height:100vh;background-color:#fff;border-top-right-radius:20px;border-bottom-right-radius:20px;-webkit-box-shadow:3px 0 8px -5px rgba(0,0,0,.58);box-shadow:3px 0 8px -5px rgba(0,0,0,.58)}.module.LayoutTracker .stBody .stHeader.expand .menu .containControl{padding:10px;float:right}.module.LayoutTracker .stBody .stHeader.expand .menu .containControl img.ui.image.backAction{cursor:pointer;width:17px;height:17px}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user{display:inline-flex}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user .detailUser{margin-top:10px;margin-right:10px;margin-left:10px}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user .detailUser p{font-size:1.2rem;line-height:20px;width:17ch;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;cursor:default}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user .detailUser p.bold{font-size:1.3rem;font-weight:700}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user img.ui.image{width:14px;height:14px;margin-top:1rem;margin-right:1rem;margin-left:1rem}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user img.ui.image.userDisplay{width:40px;height:40px;border-radius:100%;background-color:hsla(0,0%,65%,.231);padding:10px}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user img.ui.image.refresh{cursor:pointer;position:fixed;margin-left:38px;margin-top:38px;width:15px;height:15px}.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user img.ui.image.addUser,.module.LayoutTracker .stBody .stHeader.expand .menu .containUser .item.user img.ui.image.settings{cursor:pointer;margin-top:20px}.module.LayoutTracker .stBody .stHeader.expand .menu .footerMenu{bottom:0;position:absolute;padding-bottom:10px;text-align:center;width:85%}.module.LayoutTracker .stBody .stHeader.expand .menu .footerMenu p{font-size:1rem}.module.LayoutTracker .stBody .filterUI{position:fixed;width:100%;height:100%;background:#00000040;z-index:201}.module.LayoutTracker .stBody .stContent{height:100vh;overflow-y:auto}.module.LayoutTracker .stBody .stContent::-webkit-scrollbar{display:none}.module.LayoutTracker .stBody .stContent .contentSt{width:100%}.module.menuData .boxMenu{display:flex;flex-direction:row}.module.menuData .boxMenu .itemMenu{border:1px solid #419bc4;text-align:center;min-width:140px;padding:5px 0;cursor:pointer;background-color:#419bc4;transition:color .5s,background-color .5s}.module.menuData .boxMenu .itemMenu p{font-weight:700;color:#419bc4!important}.module.menuData .boxMenu .itemMenu.active{background-color:#419bc4}.module.menuData .boxMenu .itemMenu.active p{color:#419bc4!important}.module.menuData .boxMenu .itemMenu:hover{background-color:#419bc4}.module.menuData .boxMenu .itemMenu:hover p{color:#419bc4!important}.module.menuData .boxMenu .itemMenu:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.module.menuData .boxMenu .itemMenu:last-child{border-top-right-radius:5px;border-bottom-right-radius:5px}.overflowWrap{overflow-wrap:anywhere;align-self:center}.menuRightData{float:right}.module.login{text-align:center;margin:20px;margin-top:-50px;padding:38px 38px 24px;border:1px solid #4299e1;border-radius:8px;background:#fff}.module.login .logoImage img{width:45rem;margin:0;display:inline-flex}.module.login .loginButton{padding-top:30px}.module.login input{border-radius:8px}.module.login input:focus .module.login input:active .module.login input:hover{border-color:#4299e1}.module.login .headerText{font-size:2.5rem;font-weight:bolder;padding-bottom:4vh}.module.login .wrapperReset{display:flex;justify-content:end}.module.login .wrapperReset .resetText{text-align:right;opacity:.5!important;font-size:1rem;cursor:pointer}.module.login .signInText{font-size:1.2rem;font-weight:700;padding-bottom:1vh}.module.loginForm .image-box{display:flex;justify-content:center;align-items:center}.module.loginForm .image-box .image{max-width:100%}.module.loginForm .image-box .image img{width:100%;display:block}.module.loginForm .text-box{text-align:left}.module.loginForm .text-box p{margin:0;font-weight:700}.module.loginByPass p{font-weight:700;text-align:center;margin:20px 0}.module.loginByPass .empVerify{display:inline-flex}.module.loginByPass .empVerify input{text-align:center}.module.loginByPass .empVerify .ui.button.btnUnlock{margin-left:20px;background-color:unset;border:1px solid #d6d6d6;border-radius:100%}.module.loginByPass .empVerify .ui.button.btnUnlock i.icon{color:#d6d6d6}.module.loginByPass .empVerify .ui.button.btnUnlock:hover{border:1px solid gray}.module.loginByPass .empVerify .ui.button.btnUnlock:hover i.icon{color:#707070}.module.loginByPass .errorVerify{font-weight:unset;margin:unset;font-size:1rem;color:red}.module.itemSettingBox{width:100%}.module.itemSettingBox .boxTextValueSetting{height:70px;display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextValueSetting p{font-weight:700}.module.itemSettingBox .boxTextValueSetting img{width:100%;max-height:100%;display:block}.module.itemSettingBox .boxTextValueSetting .btnAction{position:absolute;right:0;top:0}.module.itemSettingBox .boxTextHeaderSetting{display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextHeaderSetting p{font-weight:700}.module.itemMailContentBox{width:100%}.module.itemMailContentBox .boxEnabled{display:flex}.module.itemMailContentBox .boxEnabled p{font-weight:700;margin-right:1rem}.module.itemMailContentBox .boxMailContent .boxContent .subject,.module.itemMailContentBox .boxMailContent .boxSubject .subject{font-weight:700;margin:0}.module.itemMailContentBox .boxMailContent .boxContent .detail,.module.itemMailContentBox .boxMailContent .boxSubject .detail{margin-left:1rem}.reportForm .stepHeader h1{color:#419bc4}.reportForm .contentReportInfomation{display:inline-flex;height:220px;overflow-y:scroll}.reportForm .accordionItem{display:inline-flex}.reportForm .accordionItem h1{margin:0;color:#419bc4}.reportForm .accordionItem i.icon{margin:7px 0 0!important}.reportForm .subItem2{padding:15px 40px;border:2px solid rgba(34,36,38,.15);border-radius:5px;margin:0 10px;margin-bottom:20px}.reportForm .subItem2 :last-child{margin-bottom:0}.reportForm .subItemError{background-color:#fba7a773;color:#4e4e4e}.reportForm .noMargin{margin:0!important}.reportForm .dataLabelItem{height:20px;display:inline-flex;position:absolute;padding-left:1rem}.reportForm .viewSummaryItem{padding:10px 30px}.reportForm .viewSummaryItem .generateCode{padding:10px;border:1px dotted #b8b8b8;border-radius:5px;background-color:#d5eafd69}.reportForm .viewSummaryItem .generateCode h2{padding:10px 0}.reportForm .error{color:red}.reportForm .viewSummaryHeader{display:contents;font-size:20px}.reportForm .viewSummarySubHeader{font-size:17px}.reportForm .checkBoxAssambly,.reportForm .radioSpecial{font-size:14px!important;padding-bottom:14px}.reportForm .btnRightConfirm{float:right;vertical-align:middle}.reportForm .tubeItem{padding:15px 20px;border:1px dotted #ccc;border-radius:10px;margin-bottom:5px}.reportForm .finItem,.reportForm .plateItem{padding:10px 25px!important;border:1px dotted #ccc;border-radius:10px;background-color:#f3f3f3;margin-bottom:5px}.reportForm .finItem.validateError,.reportForm .plateItem.validateError{background-color:#fde5e5}.reportForm .accordionError,.reportForm .ui.styled.accordion .title.accordionError{background-color:#ffc2c2}.reportForm .accordionSuccess,.reportForm .ui.styled.accordion .title.accordionSuccess{background-color:#d0ffc2}.actionLog{margin-top:50px}.actionLog .viewCommentHeader{font-size:small}.module.home .topUserSubject{font-size:15px;font-weight:500;color:#4183c4}.module.home .topUserContent{font-size:13px}.module.home .topUserTitle{color:#4183c4;font-size:20px;font-weight:900}.module.home .card{padding:10px;margin:10px}.module.home .description{margin-top:15px!important}.module.home input,.module.home input[type=text]{border:1px solid #ccc;padding:10px;border-radius:5px;font-size:14px;color:#5d5d5d}.module.home .react-datepicker,.module.home .react-datepicker-time__header,.module.home .react-datepicker-year-header,.module.home .react-datepicker__current-month{font-size:1.4rem}.module.home p{font-size:16px;color:#5d5d5d}.module.home .controlButton{padding-top:30px}.module.home .title{font-size:20px;font-weight:900}.home-page{height:calc(100vh - 105px)}.home-page .content{height:160px;overflow:hidden;font-size:35px;line-height:40px;color:#ecf0f1;width:300px}.home-page .content__container{font-weight:600;overflow:hidden;height:40px}.home-page .content__container:after,.home-page .content__container:before{position:absolute;top:0;color:#16a085;font-size:42px;line-height:40px;-webkit-animation-name:opacity;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-name:opacity;animation-duration:2s;animation-iteration-count:infinite}.home-page .content__container__text{display:inline;margin:0}.home-page .content__container__list{margin-top:0;text-align:left;list-style:none;-webkit-animation-name:change;-webkit-animation-duration:10s;-webkit-animation-iteration-count:infinite;animation-name:change;animation-duration:10s;animation-iteration-count:infinite}.home-page .content__container__list__item{line-height:40px;margin:0}@-webkit-keyframes opacity{0%,to{opacity:0}50%{opacity:1}}@-webkit-keyframes change{0%,12.66%,to{transform:translateZ(0)}16.66%,29.32%{transform:translate3d(0,-25%,0)}33.32%,45.98%{transform:translate3d(0,-50%,0)}49.98%,62.64%{transform:translate3d(0,-75%,0)}66.64%,79.3%{transform:translate3d(0,-50%,0)}83.3%,95.96%{transform:translate3d(0,-25%,0)}}@-o-keyframes opacity{0%,to{opacity:0}50%{opacity:1}}@-o-keyframes change{0%,12.66%,to{transform:translateZ(0)}16.66%,29.32%{transform:translate3d(0,-25%,0)}33.32%,45.98%{transform:translate3d(0,-50%,0)}49.98%,62.64%{transform:translate3d(0,-75%,0)}66.64%,79.3%{transform:translate3d(0,-50%,0)}83.3%,95.96%{transform:translate3d(0,-25%,0)}}@-moz-keyframes opacity{0%,to{opacity:0}50%{opacity:1}}@-moz-keyframes change{0%,12.66%,to{transform:translateZ(0)}16.66%,29.32%{transform:translate3d(0,-25%,0)}33.32%,45.98%{transform:translate3d(0,-50%,0)}49.98%,62.64%{transform:translate3d(0,-75%,0)}66.64%,79.3%{transform:translate3d(0,-50%,0)}83.3%,95.96%{transform:translate3d(0,-25%,0)}}@keyframes opacity{0%,to{opacity:0}50%{opacity:1}}@keyframes change{0%,12.66%,to{transform:translateZ(0)}16.66%,29.32%{transform:translate3d(0,-25%,0)}33.32%,45.98%{transform:translate3d(0,-50%,0)}49.98%,62.64%{transform:translate3d(0,-75%,0)}66.64%,79.3%{transform:translate3d(0,-50%,0)}83.3%,95.96%{transform:translate3d(0,-25%,0)}}.home-page .wrapper-candle{position:absolute;left:50%;bottom:0}.home-page .wrapper-candle .floor{position:absolute;left:50%;top:50%;width:350px;height:5px;background:#334155;transform:translate(-50%,-50%);box-shadow:0 2px 5px #111;z-index:2}.home-page .wrapper-candle .candles{position:absolute;left:50%;top:50%;width:250px;height:150px;transform:translate(-50%,-100%);z-index:1}.home-page .wrapper-candle .candle1{position:absolute;left:50%;top:50%;width:35px;height:100px;background:#fff;border:3px solid #334155;border-bottom:0;border-radius:3px;transform-origin:center right;transform:translate(60%,-25%);box-shadow:inset -2px 0 0 #95c6f2;animation:expand-body 3s infinite linear}.home-page .wrapper-candle .candle1__stick,.home-page .wrapper-candle .candle2__stick{position:absolute;left:50%;top:0;width:3px;height:15px;background:#334155;border-radius:8px;transform:translate(-50%,-100%)}.home-page .wrapper-candle .candle2__stick{height:12px;transform-origin:bottom center;animation:stick-animation 3s infinite linear}.home-page .wrapper-candle .candle1__eyes,.home-page .wrapper-candle .candle2__eyes{position:absolute;left:50%;top:0;width:35px;height:30px;transform:translate(-50%)}.home-page .wrapper-candle .candle1__eyes-one{left:30%}.home-page .wrapper-candle .candle1__eyes-one,.home-page .wrapper-candle .candle1__eyes-two{position:absolute;top:20%;width:5px;height:5px;border-radius:100%;background:#334155;transform:translate(-70%);animation:blink-eyes 3s infinite linear}.home-page .wrapper-candle .candle1__eyes-two{left:70%}.home-page .wrapper-candle .candle1__mouth{position:absolute;left:40%;top:20%;width:0;height:0;border-radius:20px;background:#334155;transform:translate(-50%,-50%);animation:uff 3s infinite linear}.home-page .wrapper-candle .candle__smoke-one{position:absolute;left:30%;top:50%;width:30px;height:3px;background:grey;transform:translate(-50%,-50%);animation:move-left 3s infinite linear}.home-page .wrapper-candle .candle__smoke-two{position:absolute;left:30%;top:40%;width:10px;height:10px;border-radius:10px;background:grey;transform:translate(-50%,-50%);animation:move-top 3s infinite linear}.home-page .wrapper-candle .candle2{position:absolute;left:20%;top:65%;width:42px;height:60px;background:#fff;border:3px solid #334155;border-bottom:0;border-radius:3px;transform:translate(60%,-15%);transform-origin:center right;box-shadow:inset -2px 0 0 #95c6f2;animation:shake-left 3s infinite linear}.home-page .wrapper-candle .candle2__eyes-one{left:30%;animation:changeto-lower 3s infinite linear}.home-page .wrapper-candle .candle2__eyes-one,.home-page .wrapper-candle .candle2__eyes-two{position:absolute;top:50%;width:5px;height:5px;display:inline-block;border:0 solid #334155;border-radius:100%;float:left;background:#334155;transform:translate(-80%)}.home-page .wrapper-candle .candle2__eyes-two{left:70%;animation:changeto-greater 3s infinite linear}.home-page .wrapper-candle .light__wave{position:absolute;top:35%;left:35%;width:75px;height:75px;border-radius:100%;z-index:0;transform:translate(-25%,-50%) scale(2.5);border:2px solid hsla(0,0%,100%,.2);animation:expand-light 3s infinite linear}.home-page .wrapper-candle .candle2__fire{position:absolute;top:50%;left:40%;display:block;width:16px;height:20px;background-color:red;border-radius:50% 50% 50% 50%/60% 60% 40% 40%;background:#ff9800;transform:translate(-90%,-50%);animation:dance-fire 3s infinite linear}@keyframes blink-eyes{0%,35%{opacity:1;transform:translate(-70%)}36%,39%{opacity:0;transform:translate(-70%)}40%{opacity:1;transform:translate(-70%)}50%,65%{transform:translate(-140%)}66%{transform:translate(-70%)}}@keyframes expand-body{0%,40%{transform:scale(1) translate(60%,-25%)}45%,55%{transform:scale(1.1) translate(60%,-28%)}60%{transform:scale(.89) translate(60%,-25%)}65%{transform:scale(1) translate(60%,-25%)}70%{transform:scale(.95) translate(60%,-25%)}75%{transform:scale(1) translate(60%,-25%)}}@keyframes uff{0%,40%{width:0;height:0}50%,54%{width:15px;height:15px;left:30%}59%{width:5px;height:5px;left:20%}62%{width:2px;height:2px;left:20%}67%{width:0;height:0;left:30%}}@keyframes change-background{0%,59%,98%,to{background:#fef4ad}61%,97%{background:#f8ae39}}@keyframes move-left{0%,59%,to{width:0;left:40%}60%{width:30px;left:30%}68%{width:0;left:20%}}@keyframes move-top{0%,64%,to{width:0;height:0;top:0}65%{width:10px;height:10px;top:40%;left:40%}80%{width:0;height:0;top:20%}}@keyframes shake-left{0%,40%{left:20%;transform:translate(60%,-15%)}50%,54%{left:20%;transform:translate(60%,-15%)}59%{left:20%;transform:translate(60%,-15%)}62%{left:18%;transform:translate(60%,-15%)}65%{left:21%;transform:translate(60%,-15%)}67%{left:20%;transform:translate(60%,-15%)}75%{left:20%;transform:scale(1.15,.85) translate(60%,-15%);background:#fff;border-color:#334155}91%{left:20%;transform:scale(1.18,.82) translate(60%,-10%);background:#f44336;border-color:#f44336;box-shadow:inset -2px 0 0 #f44336}92%{left:20%;transform:scale(.85,1.15) translate(60%,-15%)}95%{left:20%;transform:scale(1.05,.95) translate(60%,-15%)}97%{left:20%;transform:scale(1) translate(60%,-15%)}}@keyframes stick-animation{0%,40%{left:50%;top:0;transform:translate(-50%,-100%)}50%,54%{left:50%;top:0;transform:translate(-50%,-100%)}59%{left:50%;top:0;transform:translate(-50%,-100%)}62%{left:50%;top:0;transform:rotate(-15deg) translate(-50%,-100%)}65%{left:50%;top:0;transform:rotate(15deg) translate(-50%,-100%)}70%{left:50%;top:0;transform:rotate(-5deg) translate(-50%,-100%)}72%{left:50%;top:0;transform:rotate(5deg) translate(-50%,-100%)}74%,84%{left:50%;top:0;transform:rotate(0deg) translate(-50%,-100%)}85%{transform:rotate(180deg) translateY(120%)}92%{left:50%;top:0;transform:translate(-50%,-100%)}}@keyframes expand-light{10%,29%,59%,89%{transform:translate(-25%,-50%) scale(0);border:2px solid hsla(0,0%,100%,0)}20%,50%,90%{transform:translate(-25%,-50%) scale(1)}26%,27%,56%,57%,95%,96%{transform:translate(-25%,-50%) scale(2);border:2px solid hsla(0,0%,100%,.5)}0%,28%,58%,to{transform:translate(-25%,-50%) scale(2.5);border:2px solid hsla(0,0%,100%,.2)}}@keyframes dance-fire{59%,89%{left:40%;width:0;height:0}0%,7%,15%,23%,31%,39%,47%,55%,90%{left:40.8%;width:16px;height:20px;background:#ffc107}3%,11%,19%,27%,35%,43%,51%,58%,94%{left:41.2%;width:16px;height:20px;background:#ff9800}}@keyframes changeto-lower{0%,70%,90%{padding:0;display:inline-block;border-radius:100%;background:#334155;border-width:0;border:0 solid #334155;transform:translate(-90%)}71%,89%{background:none;border:solid #334155;border-radius:0;border-width:0 2px 2px 0;display:inline-block;padding:1px;float:left;transform-origin:bottom left;transform:rotate(-45deg) translate(-50%,-65%);-webkit-transform:rotate(-45deg) translate(-50%,-65%)}}@keyframes changeto-greater{0%,70%,90%{top:50%;padding:0;display:inline-block;border-radius:100%;background:#334155;border-width:0;border:0 solid #334155;transform:translate(-80%)}71%,89%{top:30%;background:none;border:solid #334155;border-radius:0;border-width:0 2px 2px 0;display:inline-block;padding:1px;float:left;transform-origin:bottom left;transform:rotate(135deg) translate(-80%,20%);-webkit-transform:rotate(135deg) translate(-80%,20%)}}.module.hrHome{text-align:center}.module.hrHome .title{font-weight:700;font-size:2rem;color:#fff}.module.hrHome .btnControl{margin-top:15px}.module.hrHome .switchLang{margin-top:15px;display:inline-flex}.module.hrHome .switchLang .flagMenu.active{opacity:1}.btnLogout{font-weight:400;margin-top:4px;color:blue;text-decoration:underline}.btnLogout:hover{cursor:pointer}.module.info{padding:3rem}.module.info .subject{font-size:16px;text-decoration:underline}.module.info .content{line-height:26px;padding:20px 0}.module.info .content ol.ui.list li{padding-bottom:10px;font-size:15px}.module.info .marginBottom20{margin-bottom:20px}.systemInfo{background-color:#fff;padding:10px 15px}.systemInfo .updateLog{border:1px solid #bcbcbc;border-radius:10px;padding:20px;margin:0 15px;height:65vh;overflow-y:auto}.systemInfo .updateLog .listLogs{display:inline-flex}.systemInfo .updateLog .listLogs .versionUpdate{font-weight:700;font-size:1em;padding-right:4px;color:#a4a4a4}.systemInfo .updateLog .listLogs .createDate{font-size:1em;color:#b7b7b7}.customMasterHome .ui.card{margin:10px}.customMasterHome .ui.card .header{text-overflow:ellipsis;overflow:hidden;height:1.2em;white-space:nowrap}.module.masterData .customMasterFormBorder{padding:40px 0}.module.masterData .ui.button{padding:10px;font-size:1.4rem;line-height:1.4rem}.module.masterData .addItem{margin-top:20px}.masterData{padding:20px 0}.masterData .tableMasterDataHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.user .ui.button{font-size:1.2rem;line-height:16px}.module.user .userProfile{display:unset;width:80px;height:80px;border-radius:100%;background-color:hsla(0,0%,65%,.231);padding:8px}.module.user .title{font-size:1.2rem}.module.user .subTitle{font-size:1.3rem;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.module.user .subTitle i.icon{margin-right:-1px;margin-left:5px}.module.user .Backback{justify-content:center!important;display:flex!important;margin-top:58rem!important}p{cursor:default}p.pointerCursor{cursor:pointer}.leftAction,.rightAction{margin-top:4px;width:12px;height:12px;cursor:pointer}.rightAction{float:right}.rightActionn{margin-top:-32px!important;float:right;margin-top:4px;width:12px;height:12px;cursor:pointer}.titleMenuPage{font-weight:700;color:#000}.textWrap{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.generateMenu{padding:10px}.generateMenu .title{padding:10px 0;font-size:1.2rem;cursor:default}.generateMenu .menuItem{margin:10px 0;cursor:pointer}.generateMenu .menuItem .inline{display:inline-flex}.generateMenu .menuItem .inline .menuImg{width:20px;height:20px;margin:0 10px;margin-top:2px}.generateMenu .menuItem .inline .menuTitle{cursor:pointer;font-weight:400;color:#000;margin-left:15px;font-size:1.4rem}.btnAddFooter{margin-right:10px;width:40px;height:40px;float:right;cursor:pointer}.userDisplay{width:40px;height:40px;border-radius:100%;background-color:hsla(0,0%,65%,.231);padding:10px}.actionFooterMenu.footerAction{margin-top:20px}.ui.input input:hover,.ui.selection.dropdown:hover{border:1px solid #1b2c57}.ui.radio.checkbox label{color:#e0e0e0!important}.ui.checked.radio.checkbox label,.ui.radio.checkbox label:hover{color:#1b2c57!important}.ui.checkbox.checkBoxSample:hover{font-weight:700}.module.ViewTaskList p{font-size:1.2rem}.module.ViewTaskList .itemTaskList{width:100%;height:calc(100vh - 235px);overflow-x:auto}.module.ViewTaskList .itemTaskList .row.item{padding-top:0;padding-bottom:0}.module.ViewTaskList .itemTaskList .item{cursor:pointer}.module.ViewTaskList .itemTaskList .item .status{float:right;cursor:pointer}.module.ViewTaskList .itemTaskList .item .detail{cursor:pointer}.module.ViewTaskList .itemTaskList .item .detail .documentName{font-weight:700;cursor:pointer}.module.ViewTaskList .itemTaskList .item .detail .createBy{cursor:pointer}.module.ViewTaskList .itemTaskList .item .userDisplay{width:40px;height:40px;padding:6px;margin-top:5px;margin-right:5px;cursor:pointer}.module.ViewTaskList .itemTaskList .item .createDate{cursor:pointer}.module.ViewTaskList .searchSection{position:fixed;z-index:1;background-color:#fff}.filterDataSearch .searchDateFormTo{display:inline-flex;height:40px}.filterDataSearch .searchDateFormTo .dashMargin{margin:0 5px;margin-top:9px}.filterDataSearch .searchDateFormTo input{cursor:pointer}.filterDataSearch .centerContent{justify-content:center}.filterDataSearch .ui.selection.dropdown,.filterDataSearch .ui.selection.dropdown .menu>.item{text-align:center;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important}.ui.selection.dropdown .menu>.item{white-space:nowrap;word-wrap:normal;overflow:hidden;text-overflow:ellipsis}.headerCreate{display:inline-flex;text-align:center}.headerCreate .titleLabel{font-weight:700;font-size:1rem;line-height:1.5rem}.headerCreate .subTitleLabel{width:25ch;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-size:1rem;line-height:1rem}.headerCreate .iconClickSelect{height:10px;width:10px;margin-top:8px}.module.ViewTask .openMenu{pointer-events:none;opacity:.3;margin-top:20px}.module.TaskMenu .itemMenu{text-align:center;margin:10px 0;cursor:pointer;font-size:1.5rem;font-weight:700}.module.TaskMenu .itemMenu.disable{color:#c7c7c7}.titleLabel{font-size:1.2rem}.formTask .rowLineStyles{cursor:pointer;border-bottom-width:1px;border-bottom-color:#e2e2e2;border-bottom-style:solid}.formTask .titleLabel{font-size:1.2rem}.formTask .titleLabel.to{padding-top:7px}.formTask .subTitleLabel{font-size:1.3rem;color:#000}.formTask img.ui.image.footerBtnAction{cursor:pointer;width:16px;height:16px;margin:0 10px}.formTask .toGroup .ui.selection.dropdown{border:unset}.formTask .toGroup .ui.selection.dropdown .ui.label{border:1.5px solid #ff002f}.formTask .toUser .ui.selection.dropdown{border:unset}.formTask .ui.multiple.dropdown>.label{font-size:.7em}.formTask .field.dueDate{cursor:pointer}.formTask .dueDate .ui.transparent.input,.formTask .dueDate .ui.transparent.input>input{font-weight:700;font-size:1.3rem;margin-top:1.5px;cursor:pointer;text-align:right}.formTask .dueDate.error .ui.transparent.input,.formTask .dueDate.error .ui.transparent.input>input{color:red!important}.formTask .dueDate .ui.transparent.input input[type=date]::-webkit-calendar-picker-indicator{width:15px;padding:0;margin:0;margin-top:-1px;margin-right:-3px;margin-left:3px;cursor:pointer}.formTask .footerActionInline{display:inline-flex}.formTask .footerActionInline.padding7{margin-top:7px}.formTask .footerActionInline .statusText{margin-top:2px;margin-right:25px;font-size:1.3rem}.formTask .prioritySelect .action{display:inline-flex;cursor:pointer}.formTask .prioritySelect .action .titleLabel{font-weight:700}.formTask .prioritySelect .action .arrowPriority{width:10px;height:10px;margin-top:6px;margin-left:10px}.formTask .prioritySelect .selectData{padding:5px 20px}.formTask .prioritySelect .selectData .item{padding:3px 0;cursor:pointer}.formTask .prioritySelect .selectData .item.disable{cursor:default;color:#c7c7c7}.formTask .module.inputForm .labelInput .subject{font-weight:unset;font-size:1.2rem}.formTask .statusText{cursor:pointer}.formTask .textInputRight{width:95%}.formTask .textInputRight .input>input{text-align:right}.formTask .issueTitle{width:100%}.formTask .issueTitle .input>input{font-size:.8em}.formTask .detail{width:100%;height:80px;background:transparent;border:unset}.formTask .detail .input>input{font-size:.8em}.formTask .detailToUser{width:100%;background:transparent;border:unset}.formTask .detailToUser .input>input{font-size:.8em}.formTask .detailToUser .username{padding-right:20px;padding-top:4px;font-size:1.3rem;padding-left:10px;white-space:nowrap}.formTask .issueTitle::placeholder{color:#c7c7c7;opacity:1}.formTask .detail::placeholder{color:#c7c7c7;opacity:1}.formTask .issueTitle:-ms-input-placeholder{color:#c7c7c7}.formTask .remainAlert{width:100%;display:inline-flex;cursor:default}.formTask .remainAlert .remainBeforeDay{width:95%}.formTask .remainAlert .remainBeforeDay .input>input{text-align:right}.formTask .remainAlert .remainBeforeDay.error .input>input,.formTask .remainAlert .remainBeforeDay.error b{color:red!important}.formTask .remainAlert b{margin-top:2.5px;margin-left:2px;font-size:1.2em}.formTask .remainAlert b.error{color:red}.formTask .ui.multiple.dropdown>.text{padding:unset;margin:unset;padding-top:13px}.formTask .ui.multiple.dropdown .dropdown.icon{padding:unset;padding-top:12px}.formTask .requireItem{display:inline-flex;font-size:18px;width:100%}.formTask .requireItem .req{color:red}.formTask .requireItem .reqtitle{color:red;padding-left:26px;margin-top:-8px;position:fixed;font-size:1.2rem}.formTask .requireItem .reqDetail{cursor:text;color:red;padding-left:34px;margin-top:-8px;position:fixed;font-size:1.2rem}.formTask .test{color:red;display:inline-flex}.formTask .userSection .userAccount{display:inline-flex;background-color:#f9f9f9;border-radius:20px}.formTask .userSection .userAccount .userDisplay{width:35px;height:35px;border-radius:100%;background-color:hsla(0,0%,65%,.231);padding:10px}.formTask .userSection .userAccount .detail .username{padding-right:35px;padding-top:4px;font-size:1.3rem;padding-left:6px}.formTask .userSection{display:flex;max-width:100%;-ms-overflow-style:none;scrollbar-width:none}.formTask .userSection .userAccountt{display:inline-flex;background-color:#f9f9f9;border-radius:20px;padding-right:20px!important}.formTask .userSection .userAccountt .userDisplay{width:35px;height:35px;border-radius:100%;background-color:hsla(0,0%,65%,.231);padding:10px}.formTask .userSection .userAccountt .detail .username{padding-right:35px;padding-top:4px;font-size:1.3rem;padding-left:6px}.formTask .userSection .userAccount.marginLeft{margin-left:10px}.formTask .userSection::-webkit-scrollbar{display:none}.formTask .detail{color:#7c7c7c;border:none;overflow:auto;outline:none;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.taskDetail .taskName{font-weight:700}.taskDetail .userAccount{display:inline-flex}.taskDetail .userAccount .detail{padding-top:5px;padding-left:10px}.taskDetail .userAccount .detail .username{font-size:1.2rem;line-height:1.2rem;color:#7c7c7c}.taskDetail .description,.taskDetail .userAccount .detail .department{font-size:1.2rem;color:#7c7c7c}.taskDetail .description{line-height:2rem}.attachmentComment .caretAttach,.attachmentComment .clipAttach{width:12px;height:12px;margin-left:5px;margin-right:5px;margin-top:7px}.attachmentComment .btnAttachText{display:inline-flex}.attachmentComment .clipAttach{cursor:pointer}.attachmentComment .commentAndAttachFile{width:100%;display:inline-flex}.attachmentComment .commentAndAttachFile.marginTop7{margin-top:7px}.attachmentComment .commentAndAttachFile .caretAttach,.attachmentComment .commentAndAttachFile .clipAttach{width:15px;height:15px;margin-left:10px;margin-right:10px;margin-top:7px}.attachmentComment .commentDetail{width:80vw;border:1px solid #e2e2e2;border-radius:30px;width:100%;height:42px;display:inline-flex}.attachmentComment .commentDetail input{border-radius:30px;border:unset!important;border-color:unset;background-color:unset;font-size:1.3rem}.attachmentComment .commentDetail .clearAction{padding:5px;cursor:pointer}.attachmentComment .commentDetail .clearAction.dis{opacity:.3}.attachmentComment .fileItem{-ms-overflow-style:none;scrollbar-width:none;overflow-x:auto;display:inline-flex;width:80vw}.attachmentComment .fileItem .item{border-radius:10px;background-color:#f9f9f9;padding-right:20px;padding-left:10px;padding-top:2px;margin:0 5px}.attachmentComment .fileItem .item .fileName{font-size:1rem;display:inline-flex}.attachmentComment .fileItem .item .buttonDelete{margin-top:8px;margin-left:10px;width:10px;height:10px}.attachmentComment .btnAttachComment{margin-top:1.3px;font-size:1.2rem;cursor:pointer}.fileNameTitle{font-weight:700}.fileItemCreate .file{margin:5px 0;padding:8px;background:#f9f9f9}.fileItemCreate .file .item{display:inline-flex}.fileItemCreate .file .item .fileName{font-size:1em}.fileItemCreate .file .item .fileImg{margin-top:2px;width:20px;height:20px}.fileItemCreate .file .item .fileName{margin-left:10px}.fileItemCreate .file .item .downloadImg{margin-top:2px;width:20px;height:20px;float:right;cursor:pointer}.fileItemCreate .file .item i.trash.bin.icon.deleteRowFile{margin-top:4px;font-size:1em;right:0;position:absolute;margin-right:30px;color:#e10000;cursor:pointer}.fileItemCreate .file .item i.download.icon.deleteRowFile{margin-top:4px;font-size:1em;right:0;position:absolute;margin-right:30px;color:#0076a9;cursor:pointer}.fileAndComment .commentSectionn{max-height:575px;overflow:hidden}.fileAndComment .commentSectionn .dataa{margin:10px 0;width:100%;height:calc(75vh - 250px);overflow-x:hidden}.fileAndComment .commentSection{max-height:271px;overflow:hidden}.fileAndComment .commentSection.commentUI{max-height:unset}.fileAndComment .commentSection .clickLinkLabel{color:#106fb6;font-weight:700;font-size:1rem;text-decoration:underline;cursor:pointer}.fileAndComment .commentSection .data{margin:10px 0;width:100%;height:calc(100vh - 205px);overflow-x:hidden}.fileAndComment .fileSection .dataScrolling{margin:10px 0;max-height:250px;overflow-y:auto}.fileAndComment .item-card{margin-bottom:10px;border:.25px solid #e2e2e2;padding:10px}.fileAndComment .item-card .item{width:100%}.fileAndComment .item-card .item p{font-size:1rem;color:#7c7c7c}.fileAndComment .item-card .item .uploadBy{width:50%}.fileAndComment .item-card .item .createDate{width:50%;text-align:right}.fileAndComment .item-card .item .comment,.fileAndComment .item-card .item .comment p{font-size:1.2rem}.fileAndComment .item-card .item.inline{display:inline-flex}.fileAndComment .item-card .file{padding:8px;background:#f9f9f9}.fileAndComment .item-card .file .item{display:inline-flex}.fileAndComment .item-card .file .item .fileImg{margin-top:2px;width:20px;height:20px}.fileAndComment .item-card .file .item .fileName{margin-left:10px;width:85%}.fileAndComment .item-card .file .item .downloadImg{margin-top:2px;width:20px;height:20px;float:right;cursor:pointer}.fileAndComment .divi{border-bottom-width:1px;border-bottom-color:#e2e2e2;border-bottom-style:solid;margin-top:20px;margin-bottom:10px}.fileAndComment .noData p{font-size:1.2rem;color:#a6a6a6}.moduleSettings .headerTitle p{font-weight:700;font-size:2rem}.moduleSettings .headerTitle .createButton{padding:0 15px;margin:0;height:40px;color:#fff;background-color:#0b6ddd;font-size:13px;margin-left:5px;min-width:100px}.moduleSettings .searchData{padding:10px 20px;background-color:#eee}.moduleSettings .searchData p{font-size:1.6rem}.moduleSettings .searchData .ui.button.btnSearch{padding:0 15px;margin:0;height:40px;color:#fff;background-color:#0b6ddd;font-size:13px;margin-left:5px;min-width:100px;margin-top:23px}.moduleSettings.list .bgCourse.info{background-color:#f5f5f5;padding:15px 10px}.moduleSettings.create .active.item{font-weight:700}.moduleSettings.create .dataTableForm{border-radius:10px;border-style:solid;border-width:.6px;margin-bottom:1vh}.moduleSettings.create .dataTableForm .header{padding:2vh;border-radius:10px;border-bottom-style:solid;border-width:.6px}.moduleSettings.create .dataTableForm .bodyTable{padding:2vh}.moduleSettings.create .ui.button.addButton{padding:0 15px;margin:0;height:30px;color:#fff;background-color:#0b6ddd;font-size:13px;margin-left:5px;min-width:100px}.moduleSettings.create .inlineRow{display:inline-flex}.moduleSettings.create .inlineRow .checkBoxCenter{margin-left:10px;margin-top:4px}.moduleSettings.create .actionCourseSection{text-align:center}.moduleSettings.create .btnActionCourse{padding-top:6px;width:30px;border:1px solid gray;border-radius:inherit;height:30px}.moduleSettings.create .htmlRender{border:1px solid #d2d2d2;padding:15px;background-color:#e5e5e5}.moduleSettings.create .bgCourse.info{background-color:#f5f5f5;padding:15px 10px}.moduleSettings.create .bgCourse.attach{background-color:#e9e9e9;padding:15px 10px}.moduleSettings.create .radioTraining{border-radius:5px;border:1px solid #dededf;background-color:#fff;padding:10px}.moduleSettings.create .radioTraining.marginUser{padding:20px}.moduleSettings.create .radioTraining.marginUser .noData{font-size:1.4rem}.moduleSettings.create .radioTraining .radioTrainingSelect{margin:10px 0}.moduleSettings.create .column.displayInline{display:inline-flex}.moduleSettings.create .column.displayInline .colorLayout{width:20px;height:20px;margin-left:10px;margin-top:2px}.moduleSettings .userLists{border:1px solid rgba(34,36,38,.15);max-height:50vh}.moduleSettings .userLists .noData{height:100px}.moduleSettings .approveSection .approve-level{border-radius:10px;border:1px solid #d1d1d1;margin:5px 0;padding:20px 10px}.moduleSettings .approveSection .approve-level p{font-size:1.4rem}.moduleSettings .approveSection .approve-level .bg{background-color:#f8f8f8}.moduleSettings .approveSection .approve-level .listHeader{background-color:#e6f4f4;border-bottom-color:#fff;outline:1px solid #fff}.moduleSettings .approveSection .approve-level .listHeader p{font-size:1.6rem;font-weight:700}.moduleSettings .approveSection .approve-level .approve-control{display:inline-flex}.moduleSettings .approveSection .approve-level .approve-control .level{margin-top:5px}.moduleSettings .approveSection .approve-level .approve-control .ui.button.btnOrderUp{padding:0;width:30px;height:30px;color:#fff;background-color:#1c2c57;font-size:13px;position:relative;margin:0 10px}.moduleSettings .approveSection .approve-level .approve-control .ui.button.btnOrderUp .i.icon,.moduleSettings .approveSection .approve-level .approve-control .ui.button.btnOrderUp i.icons{padding-right:2px!important}.moduleSettings .approveSection .approve-level .approve-control .ui.button.btnOrderDown{padding:0;width:30px;height:30px;color:#fff;background-color:#1c2c57;font-size:13px;position:relative;margin:0 10px}.moduleSettings .approveSection .approve-level .approve-control .ui.button.btnOrderDown .i.icon,.moduleSettings .approveSection .approve-level .approve-control .ui.button.btnOrderDown i.icons{padding-right:2px!important}.moduleSettings .approveSection .approve-level .level{font-weight:700;font-size:1.6rem}.modalConfirmDelete .ui.button.confirmButton{color:#fff;background-color:#1b2c57}.modalConfirmDelete .ui.button.cancelButton,.modalConfirmDelete .ui.button.confirmButton{padding:0 15px;margin:0;height:30px;font-size:13px;margin-left:5px;min-width:100px;border-radius:30px}.modalConfirmDelete .ui.button.cancelButton{color:#2b2b2b;background-color:#d5d5d5}.masterMenu p{font-size:1.4rem}.masterMenu .titleMenu{font-weight:700;font-size:2rem;margin-bottom:15px}.masterMenu .widthLayout{margin-top:10px;width:70vw;height:50vh;overflow:auto}.masterMenu .box-menu-item{margin:20px 0;text-align:-webkit-center}.masterMenu .box-menu-item .logo-icon{text-align:center;height:10vh;width:10vh;border-radius:100%;background-size:cover;background-repeat:no-repeat;cursor:pointer}.masterMenu .box-menu-item .logo-icon:hover{opacity:.7}.masterMenu .box-menu-item .text-description .title{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.module.inputForm .editorInputHtml.drawingOrder{background-color:#e2e2e2;border:1px solid #cfcfd0!important}.module.listCourse .test{margin:10px 5px;height:1px;background-color:#dbdbdb}.module.listCourse .titleList{margin-left:5px;font-weight:700;font-size:1.6rem;color:#969696}.module.listCourse .list{max-height:70vh;padding:5px;overflow:auto}.module.listCourse .list.cert{max-height:90vh}.module.listCourse .list::-webkit-scrollbar{display:none}.module.listCourse .course-items{padding:10px}.module.listCourse .course-items p{cursor:pointer}.module.listCourse .course-items .noData{font-size:1.5rem}.module.listCourse .course-items .item{margin-bottom:30px;cursor:pointer;border-radius:5px;height:95px;-webkit-box-shadow:5px 5px 11px 1px #bdbdbd;box-shadow:5px 5px 10px 1px #bdbdbd;background-color:#fff;background-image:linear-gradient(90deg,#e3e3e3,#fafafa,#fff)}.module.listCourse .course-items .name{overflow-wrap:break-word;font-weight:700;font-size:1.8rem}.module.listCourse .course-items .description{overflow-wrap:break-word;font-weight:700;font-size:1.5rem}.module.listCourse .course-items .speaker{overflow-wrap:break-word;font-size:1.5rem}.module.listCourse .course-items .dateTime{font-size:1.3rem}.module.listCourse .course-items .showStatus{text-align:center;width:75px;position:absolute;right:0;bottom:0;padding-bottom:13px}.module.listCourse .course-items .showStatus p{color:#00b4cc;font-size:1.3rem}.module.listCourse .myCert .imageSize{height:220px}.module.listCourse .ui.secondary.menu p{font-size:1.4rem}.module.listCourse .ui.secondary.menu .active.item{background:#2fc2d5}.module.listCourse .ui.secondary.menu .active.item p{color:#fff}.searcSection{padding:10px;background-color:hsla(0,0%,93%,.47)}.searcSection .textLabel{font-size:1rem}.searcSection .searchInputCourse input{font-size:1.2rem;height:30px;border-radius:10px}.headerWithAction .title{font-weight:700}.headerWithAction .iconBackHome{cursor:pointer;font-size:1.5rem}.module.detailTraining{background-color:#fff;border-radius:10px;padding:20px 0}.module.detailTraining .trainingHeader{padding:10px;display:inline-flex}.module.detailTraining .trainingHeader .img{width:100px}.module.detailTraining .trainingHeader .img .imageSize{width:100%;border-radius:10px}.module.detailTraining .trainingHeader .detail{margin-left:10px}.module.detailTraining .trainingHeader .detail .title{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-weight:700;font-size:1.6rem}.module.detailTraining .trainingHeader .detail .smmaryDays,.module.detailTraining .trainingHeader .detail .trainingId{font-size:1.3rem}.module.detailTraining .trainingHeader .trainingContent .description{font-size:1.5rem}.module.detailTraining .trainingContent{padding:10px}.module.detailTraining .trainingContent .description{max-height:100px;word-break:break-all;overflow-y:auto;font-size:1.5rem}.module.detailTraining .trainingContent .cert{display:inline-flex;margin-top:10px}.module.detailTraining .trainingContent .cert p{font-size:1.4rem}.module.detailTraining .trainingContent .cert .icon{padding-top:5px;padding-left:7px}.module.detailTraining .trainingContent .speakerList{margin-top:10px}.module.detailTraining .trainingContent .speakerList p{font-size:1.4rem;font-weight:700}.module.detailTraining .trainingAction{text-align:center}.modalStepScoreCert .addPointSection{border:1px solid #b4b4b4;border-radius:10px;padding:10px;padding-top:5px}.modalStepScoreCert .addPointSection .rowDetail{margin:10px 0}.modalStepScoreCert .addPointSection .point{display:inline-flex}.modalStepScoreCert .addPointSection .point .textPoint{margin-top:9px;margin-right:10px}.module.carReserveHeader p{font-size:9pt}.module.carReserveHeader .headerSection .titleBoldHeader{font-size:10pt;font-weight:700}.module.carReserveHeader .btnCaretManagePage{display:inline-flex}.module.carReserveHeader .btnCaretManagePage .arrowPage{height:12px}.module.carReserveHeader p.titleBoldHeader{cursor:pointer;font-size:10pt}.module.carReserveHeader p.titleBoldHeader.active{border-bottom:2px solid #0066b2;font-weight:700}.module.carReserveHeader .tableTimeCalendar{display:inline-flex}.module.carReserveHeader .tableTimeCalendar .selectInCalendar{margin-top:2.4px}.inProcessBox,.module.carReserveHeader .tableTimeCalendar,.module.carReserveHeader p{cursor:pointer}.inProcessBox{border:1px solid #d5d5d5;border-radius:10px;padding:10px}.inProcessBox p{cursor:pointer}.module.ViewReserveList .openMenu{pointer-events:none;opacity:.3;margin-top:20px}.module.ViewReserveList .rowLineStyles,.module.ViewReserveList .rowLineStyles p{cursor:pointer}.module.ViewDriverList .openMenu{pointer-events:none;opacity:.3;margin-top:20px}.module.ViewDriverList .rowLineStyles,.module.ViewDriverList .rowLineStyles p{cursor:pointer}.reserveDetail{overflow:hidden}.reserveDetail p{font-size:8pt}.reserveDetail p.bookingNo{font-size:9pt;font-weight:700}.reserveDetail p.statusDrive{font-size:11pt;font-weight:700}.reserveDetail .locationDetail{display:inline-flex;width:50vw}.reserveDetail .locationDetail.long{width:100%}.reserveDetail .locationDetail.long .titleNormalHeader{color:#000}.reserveDetail .locationDetail.long .titleNormalHeader.hid{max-height:50px;overflow:hidden}.reserveDetail .locationDetail .ic{margin-top:4px}.reserveDetail p.status{text-align:right}.reserveDetail p.status.success{color:#2575b9;font-weight:700}.reserveDetail p.status.reject{color:#b92525;font-weight:700}.reserveDetail .titleLocationr{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100ch}.reserveDetail .reserveDetail{color:#b1b1b1}.module.ViewReserveCreate .openMenu{pointer-events:none;opacity:.3;margin-top:20px}.module.ViewReserveCreate .carHeaderTitle p{font-size:1.1rem}.module.ViewReserveCreate .carHeaderTitle p.titleBoldHeader{font-weight:700;font-size:1.3rem}.module.ViewReserveCreate .carHeaderTitle p.titleBoldHeader.action{color:#0066b2}.module.ViewReserveCreate .carHeaderTitle p.titleReserveHeader{font-weight:700;color:#0066b2;text-align:right;font-size:13pt}.module.ViewReserveCreate .carForm p{font-size:16px}.module.ViewReserveCreate .carForm .userDetailWitSelect{cursor:pointer;display:inline-flex}.module.ViewReserveCreate .carForm .userDetailWitSelect .pinLocation,.module.ViewReserveCreate .carForm .userDetailWitSelect .rightCaret{height:15px;margin-top:5px;margin-left:5px}.module.ViewReserveCreate .carForm .titleBoldHeader{font-weight:700}.module.ViewReserveCreate .carForm .locationAddress{cursor:pointer;display:inline-flex}.module.ViewReserveCreate .carForm .locationAddress p{cursor:pointer}.module.ViewReserveCreate .carForm .locationAddress .pinLocation{margin-top:5px;margin-left:5px;height:15px}.module.ViewReserveCreate .carForm .datetimeCar{cursor:pointer}.module.ViewReserveCreate .carForm .datetimeCar input{text-align:right;margin-top:1px;font-size:1.2rem}.module.ViewReserveCreate .carForm .datetimeCar.error input{color:red!important}.module.ViewReserveCreate .carForm .inputRight input{text-align:right}.module.ViewReserveCreate .ui.checkbox{width:unset}.modal.confirmDataRecheck{padding:0 10px}.modal.confirmDataRecheck p{font-size:9pt}.modal.confirmDataRecheck p.titleBoldHeader{font-weight:700}.modal.confirmDataRecheck p.titleReserveHeader{font-weight:700;color:#0066b2;text-align:right;font-size:9pt}.modal.confirmDataRecheck .detailConfirm .bold{font-weight:700}.modal.confirmDataRecheck .detailConfirm .normal{border:1px solid #efefef;border-radius:10px;padding:3px 7px}.modal.confirmDataRecheck .detailConfirm i.icon{margin-left:5px}.eventNameClass{padding:10px;background-color:#ebebeb;border:1px solid #f5f5f5}.eventNameClass input{font-size:10pt}.eventNameClass .ui.selection.dropdown .text{font-size:9pt!important}.eventNameClass.no-padding{padding:unset}.sectionNavigator{display:inline-flex;float:right}.sectionNavigator .placeIc{margin-top:3px}.sectionNavigator .locationName{font-size:8.5pt;margin:0 5px}.module.mapSelect{margin-top:-30px}.module.mapSelect .inlinePlace{display:inline-flex;width:100%}.module.mapSelect .inlinePlace p{font-size:1.4rem}.module.mapSelect .inlinePlace .textAddress{word-wrap:break-word;width:75%}.module.mapSelect .inlinePlace .pin{height:15px;margin-top:5px;margin-right:10px}.module.mapSelect .inlinePlace .btnClearLocation{margin-top:4px;margin-right:10px;height:15px;right:0;position:absolute;cursor:pointer}.module.mapSelect .switchLocation{height:15px;margin:10px 0;text-align:center}.module.mapSelect .switchLocation .btnClearLocation{font-size:15px}.module.mapSelect .map{margin-top:10px}.module.mapSelect .backAction.marginBottom{margin-left:-3px;margin-bottom:15px}.module.mapSelect .backAction.marginBottom .backCaret{cursor:pointer;height:15px}.detailInlineGoto{cursor:pointer;display:inline-flex;float:right}.detailInlineGoto p{font-size:9pt}.detailInlineGoto .textAddress{cursor:pointer;word-wrap:break-word}.detailInlineGoto .pin{height:15px;margin-top:4px;margin-right:5px}.modalCalendar.action .eventCalendar.boxImageClose{right:unset}.eventItem{display:inline-flex}.eventItem .indigator,.eventItem .indigator2:hover+.indigator3{width:10px;border-radius:10px;margin-right:10px}.eventItem .indigator2:hover+.indigator3{display:block}.eventItem .indigator3{display:none}.eventItem p.displayInflex{font-size:10pt;margin:10px 0}.eventItem p.displayInflex.detail{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}.eventItem.iconItem{margin:0 5px;font-size:1.5em;cursor:pointer}.eventItem .detail{width:100%}.ui.dimmer{background-color:rgba(0,0,0,.267)!important}.eventCalendar.detail{max-height:40vh;overflow-y:auto;height:30vh}.eventCalendar.detail .item{height:175px}.eventCalendar .confirmDeleteMessage{color:rgba(212,1,1,.761)}.eventCalendar.item.dayText{font-weight:700;font-size:12pt}.eventCalendar.item.dateMonth{font-weight:700;font-size:14pt}.eventCalendar.itemRow{height:165px}.eventCalendar.boxImageClose{width:16px;height:16px;display:inline-block;right:15px;top:5px;opacity:.3;cursor:pointer}.eventCalendar.boxImageClose img{display:block!important;width:100%;height:100%}.eventCalendar.boxImageClose:hover{opacity:unset}.fc .fc-button{line-height:.5!important}.fc .fc-button .fc-icon{margin-top:-1.5px}@media only screen and (max-width:767px){.fc{margin:0 auto}.fc .fc-media-screen.fc-direction-ltr.fc-theme-standard.fc-liquid-hack{width:100%}.fc .fc-view-harness .fc-view-harness-active{width:330px}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body,.fc .fc-scrollgrid-section.fc-scrollgrid-section-body .fc-scrollgrid-sync-table{height:100%!important}.fc .fc-scrollgrid-section .fc-event-title-container{cursor:pointer}.fc .fc-h-event .fc-event-main{color:#c3c3c3!important}.fc .fc-view-harness.fc-view-harness-active{height:62vh!important}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:3em;max-height:5em;overflow-y:auto}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events::-webkit-scrollbar{display:none}}@media only screen and (min-width:768px) and (max-width:991px){.fc{margin:0 auto}.fc .fc-media-screen.fc-direction-ltr.fc-theme-standard.fc-liquid-hack{width:100%}.fc .fc-view-harness .fc-view-harness-active{width:330px}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header{height:100%;width:101.2%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header::-webkit-scrollbar{display:none}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body{height:90%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body .fc-scrollgrid-sync-table{height:100%!important}.fc .fc-scrollgrid-section .fc-event-title-container{cursor:pointer}.fc .fc-h-event .fc-event-main{color:#c3c3c3!important}.fc .fc-view-harness.fc-view-harness-active{height:62vh!important}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:3em;max-height:5em;overflow-y:auto}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events::-webkit-scrollbar{display:none}}@media only screen and (min-width:992px) and (max-width:1199px){.fc{margin:0 auto}.fc .fc-media-screen.fc-direction-ltr.fc-theme-standard.fc-liquid-hack{width:100%}.fc .fc-view-harness .fc-view-harness-active{width:330px}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header{height:100%;width:100%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header::-webkit-scrollbar{display:none}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body{height:90%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body .fc-scrollgrid-sync-table{height:100%!important}.fc .fc-scrollgrid-section .fc-event-title-container{cursor:pointer}.fc .fc-h-event .fc-event-main{color:#c3c3c3!important}.fc .fc-view-harness.fc-view-harness-active{height:auto!important}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:3em;max-height:5em;overflow-y:auto}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events::-webkit-scrollbar{display:none}}@media only screen and (min-width:1200px) and (max-width:1919px){.fc{margin:0 auto}.fc .fc-media-screen.fc-direction-ltr.fc-theme-standard.fc-liquid-hack{width:100%}.fc .fc-view-harness .fc-view-harness-active{width:330px}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header{height:100%;width:103%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header::-webkit-scrollbar{display:none}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body{height:90%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body .fc-scrollgrid-sync-table{height:100%!important}.fc .fc-scrollgrid-section .fc-event-title-container{cursor:pointer}.fc .fc-h-event .fc-event-main{color:#c3c3c3!important}.fc .fc-view-harness.fc-view-harness-active{height:auto!important}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:3em;max-height:5em;overflow-y:auto}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events::-webkit-scrollbar{display:none}}@media only screen and (min-width:1920px){.fc{margin:0 auto}.fc .fc-media-screen.fc-direction-ltr.fc-theme-standard.fc-liquid-hack{width:100%}.fc .fc-view-harness .fc-view-harness-active{width:330px}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header{height:100%;width:103%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-header .fc-col-header::-webkit-scrollbar{display:none}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body{height:90%!important}.fc .fc-scrollgrid-section.fc-scrollgrid-section-body .fc-scrollgrid-sync-table{height:100%!important}.fc .fc-scrollgrid-section .fc-event-title-container{cursor:pointer}.fc .fc-h-event .fc-event-main{color:#c3c3c3!important}.fc .fc-view-harness.fc-view-harness-active{height:calc(80vh - 120px)!important}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:3em;max-height:5em;overflow-y:auto}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events::-webkit-scrollbar{display:none}}.fc .fc-scroller-liquid-absolute{position:inherit!important;overflow-y:auto!important;padding-right:80px!important;top:0;right:0;left:0;bottom:0;height:100%!important}.fc-list-event .fc-event .fc-event-start .fc-event-end{background-color:#fff!important}.fc-event,.fc-event:hover{color:#000!important}@media only screen and (max-width:768px){.fc-event,.fc-event-dot{background-color:#fff!important;border:#ffff!important}.fc .fc-toolbar-title{font-size:18px!important;margin:0}button{width:70px;height:31px!important}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:10px!important}.fc .fc-list-sticky .fc-list-day>*{background:#024!important;color:#fff!important}.fc-list-event-time{width:15%!important}.fc-direction-ltr .fc-list-table .fc-list-event-graphic{padding-right:10px!important}}.fc-list-event-title{width:100%!important}.module.searchDateTime p{font-size:10pt}.module.searchDateTime .startEndReserve .ui.input input{font-size:7pt}.searchLocation{width:100%}.searchLocation .locationField{font-weight:700}.searchLocation .locationSearch input{font-size:12px}.searchLocation .locationSearch i.icon{margin-top:7px!important;font-size:7px;vertical-align:middle;margin-right:5px!important}.searchLocation .locationSearch.active input{border:1px solid red}.searchLocation .rowSection{z-index:100;background-color:#fff}.searchLocation .rowSection .rowLocation{border-radius:10px;border:1px solid gray;max-height:30vh;overflow-y:auto}.searchLocation .rowSection .rowLocation .location-item{padding:10px;border-bottom-style:solid;border-bottom-color:#d8d8d8;cursor:pointer}.searchLocation .rowSection .rowLocation .location-item p{cursor:pointer}.containerWebList{background:hsla(0,0%,100%,.5);width:50%;border-radius:16px;padding:16px;height:100%}.containerWebList .listCourse{padding-top:10px;width:100%}.containerWebList .hrLineProject{border:1px solid #fff}.containerWebList .wapperListProject{height:80vh;overflow-y:scroll;width:100%}.containerWebList .wapperListProject .card{background-color:#42939a;padding:16px;border-radius:8px;color:#fff}.containerWebList .wapperListProject .card .wrapperHeader{display:flex;justify-content:space-between;margin-bottom:8px}.containerWebList .wapperListProject .card .wrapperHeader .titleProject{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.containerWebList .wapperListProject .card .wrapperTextSubtitle{margin-top:10px}.containerWebList .wapperListProject .card .progress .bar{display:flex;justify-content:center;align-items:center}.containerWebList .wrapperFooter{display:flex;justify-content:space-between}.containerWebList .wrapperFooter .wrapperDateTimeProject{width:150px;display:flex;align-items:center;justify-content:center}@media only screen and (min-width:426px) and (max-width:1024px){.containerWebList{width:80%}}@media only screen and (max-width:425px){.containerWebList{width:95%}}@media only screen and (max-width:425px){.wrapperFooter{flex-direction:column;align-items:flex-end}.wrapperFooter .wrapperDateTimeProject{margin-bottom:4px}}.containerViewProject{background:#42939aab;width:50%;height:100%;overflow-x:auto;border-radius:16px;padding:16px}.containerViewProject .btnBackPage{display:flex!important;justify-content:center}.containerViewProject .btnBackPage button{background:#f56565;color:#fff;width:100px;margin-top:48px}.containerViewProject .btnBackPage button:hover{background:#feb2b2;color:#fff}@media only screen and (min-width:426px) and (max-width:1024px){.containerViewProject{width:80%}}@media only screen and (max-width:425px){.containerViewProject{width:95%}}.containerCreateUpdateProject{background:#42939aab;width:50%;border-radius:16px;padding:16px;height:100%}.containerCreateUpdateProject .title{color:#fff}.containerCreateUpdateProject .wrapperProjectForm{margin-top:40px}.containerCreateUpdateProject .wrapperProjectForm p{color:#fff}.containerCreateUpdateProject .formProject{overflow:auto;overflow-x:hidden}.containerCreateUpdateProject .formTracker{overflow:auto;height:80vh;overflow-x:hidden}.formProject,.formViewProject{overflow:auto;overflow-x:hidden}.formViewProject{height:80vh}button{width:100px}.footerForm{display:flex;justify-content:center}.footerForm button{width:100px}.footerForm .footerForm{display:flex;justify-content:center}.footerForm .footerForm button{width:100px;background:#48bb78;color:#fff}.footerForm .footerForm button:hover{background:#68d391;color:#fff}.footerForm .footerForm .backPage{background:#f56565;color:#fff;width:100px}.footerForm .footerForm .backPage:hover{background:#feb2b2;color:#fff}.wrapperCardModal{background:#edf2f7;border-radius:4px;margin-bottom:4px!important}.wrapperCardModal button{padding:1px 2px!important;margin-top:4px!important}@media only screen and (min-width:426px) and (max-width:1024px){.containerCreateUpdateProject{width:80%}}@media only screen and (max-width:425px){.containerCreateUpdateProject{width:95%}}.wrapper-form-meta-data{height:calc(100vh - 172px);display:flex;justify-content:space-between;flex-direction:column;overflow-y:auto}.containerTimeSheetProject{background:#42939aab;width:50%;border-radius:16px;padding:16px;overflow-y:auto;height:100%;overflow-x:hidden}.containerTimeSheetProject .listCourse{padding-top:10px;width:100%}.containerTimeSheetProject .footerTimeSheet{display:flex;justify-content:center}.containerTimeSheetProject .footerTimeSheet button{width:100px;background:#48bb78;color:#fff}.containerTimeSheetProject .footerTimeSheet button:hover{background:#68d391;color:#fff}.containerTimeSheetProject .footerTimeSheet .backPage{background:#f56565;color:#fff;width:100px}.containerTimeSheetProject .footerTimeSheet .backPage:hover{background:#feb2b2;color:#fff}@media only screen and (min-width:426px) and (max-width:1024px){.containerTimeSheetProject{width:80%}}@media only screen and (max-width:425px){.containerTimeSheetProject{width:95%}}.container-card-projects{width:100%;height:calc(100vh - 185px);overflow-x:auto}.container-card-projects .wrapper-card{min-height:250px;background-color:#fff;width:32.8%;margin-bottom:.5%}.container-card-projects .wrapper-card .card{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.container-card-projects .wrapper-cardd{min-height:140px;background-color:#fff;width:32.8%;margin-bottom:.5%}.container-card-projects .wrapper-cardd .card{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.container-card-projects .border-gradient{position:relative;border-radius:var(12px)}.container-card-projects .border-gradient:before{content:\"\";position:absolute;top:0;right:0;width:100%;height:44px;background-image:linear-gradient(90deg,#334454,#1e293b)}.container-card-projects .status-alert{background:#047857;border-radius:50%;box-shadow:0 0 0 0 #000;margin:10px;height:18px;width:18px;transform:scale(1);animation:pulse 2s infinite}.container-card-projects .card-member{width:24px;height:24px;background:#334454;border-radius:50%;color:#fff;padding:4px;display:flex;justify-content:center;align-items:center}@media screen and (max-width:1640px){.container-card-projects .wrapper-card,.container-card-projects .wrapper-cardd{width:49%}}@media screen and (max-width:768px){.container-card-projects .wrapper-card,.container-card-projects .wrapper-cardd{width:100%}}@media screen and (max-width:758px){.container-view-projects{display:flex!important}}.btnBaseinit{border-radius:6px!important;min-width:96px!important;color:#fff!important;transition:all .2s ease-in-out 0s!important;font-weight:unset!important;margin:0 4px!important;border:1px solid #334454!important;background:#334454!important;height:36px!important}.divvv{width:100%;height:calc(100vh - 145px);overflow-x:hidden}.viewwww{overflow-x:scroll}.displayy{display:flex;justify-content:center}.container-card-Task{width:100%;height:calc(100vh - 220px);overflow-x:auto}.container-card-Task .wrapper-carder{min-height:250px;background-color:#fff;width:32.8%;margin-bottom:.5%}.container-card-Task .wrapper-cardd{min-height:160px;background-color:#fff;width:32.8%;margin-bottom:.5%}.container-card-Task .wrapper-cardd .card{border:1px solid #94a3b8}.container-card-Task .border-gradient{position:relative;border-radius:var(12px)}.container-card-Task .border-gradient:before{content:\"\";position:absolute;top:0;right:0;width:100%;height:44px;background-image:linear-gradient(90deg,#334454,#1e293b)}.container-card-Task .status-alert{background:#047857;border-radius:50%;box-shadow:0 0 0 0 #000;margin:10px;height:18px;width:18px;transform:scale(1);animation:pulse 2s infinite}.container-card-Task .overrrr{overflow-x:overlay!important}@keyframes pulse{0%{transform:scale(.95);box-shadow:0 0 0 0 #047857}70%{transform:scale(1);box-shadow:0 0 0 10px rgba(52,172,224,0)}to{transform:scale(.95);box-shadow:0 0 0 0 rgba(52,172,224,0)}}.container-card-Task .card-member{width:24px;height:24px;background:#334454;border-radius:50%;color:#fff;padding:4px;display:flex;justify-content:center;align-items:center}.formDetailProject{height:calc(100vh - 175px);overflow-x:auto}.project-detail .card-member{width:24px;height:24px;background:#334454;border-radius:50%;color:#fff;padding:4px;display:flex;justify-content:center;align-items:center}@media screen and (max-width:1439px){.container-card-Task .wrapper-card,.container-card-Task .wrapper-cardd{width:49%}}@media screen and (max-width:768px){.container-card-Task .wrapper-card,.container-card-Task .wrapper-cardd{width:100%}}.hr{margin-top:21px}.Bgg{margin-top:-65px;padding:80px;width:100%;height:calc(100vh - 105px);overflow-x:auto}.Bgg .imageuser,.Bgg .imageuser .ima{width:80px;height:80px;border-radius:100px}.userProfilenew{display:unset;width:80px;height:80px;border-radius:100%;background-color:hsla(0,0%,65%,.231);padding:8px}.titlenew{font-size:1.2rem}.subTitlenew{font-size:1.3rem;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.subTitlenew i.iconnew{margin-right:-1px;margin-left:5px}.Backback{justify-content:center!important;display:flex!important;margin-top:58rem!important}", ""]);

// exports


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"OK","cancel":"Cancel","back":"Back","welcome":"Welcome","hello":"Hello","somethingWrong":"Something Went Wrong, Please Try Again.","pleaseContactAdminAx":"Please Contact AX Admin","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","squareInch":"SQUARE INCH","version":"Version","logout":"Log out","npiSystem":"NPI System","pageNotFound":"Page not found","redirectPage":"redirect to home in","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","itemCode":"Item Code","itemStatus":"Item Status","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","close":"Close","closed":"Closed","confirm":"Confirm","save":"Save","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","delete":"Delete","deleteBy":"Delete By","print":"Print","printDate":"Print Date","sendToAx":"Send To Ax","from":"From","to":"To","approve":"Approve","send":"Send","date":"Date","deleteWithComment":"Delete With Comment","settings":"Settings","clear":"Clear","home":"Home","receivePrint":"Receive/Print","createDate":"Create Date","createBy":"Create By","updateDate":"Update Date","updateBy":"Update By","createTranferDate":"Create Transfer Date","noData":"No Data","selectUser":"Select User","user":"User","email":"Email","description":"Description","addLevel":"Add Level","addUser":"Add User","pleaseConfirmEmpId":"Enter EmpId","incorrect":"Incorrect you password!!!","next":"Next","manage":"Manage","export":"Export","removeLevel":"Remove Level","verifyFailed":"Verify Failed","pleaseEnterEmpId":"Please Enter EmpId","dateFrom":"Date From","dateTo":"Date To","addFile":"Add File","noUsers":"No Users","pleaseCheckTrainingCode":"Please Check Training Code","menu":"Menu","modules":"Modules","tracker":"Tracker","training":"Training","services":"Services","submitData":"Submit Data","updateSubmit":"Update Data","fillFullname":"Fill Full Name","bth":"thb","confirmDelete":"Confirm Delete","cancelDelete":"Cancel Delete","admin":"Admin","assignToRequire":"Please assign to user before done task.","pleaseProvideRating":"Satisfaction Rating","userTotal":"User Total","total":"Total","selectedCarType":"Selected CarType","reOpen":"Re Open","open":"OPEN","draft":"DRAFT","high":"HIGH","medium":"MEDUIM","low":"LOW","toDo":"To Do","notOpen":"Not Open","inprogress":"Inprogress","waitingTest":"Waiting Test","done":"Done","discuss":"Discuss","start":"Start","projects":"Projects","carApprove":"Car Approve","nodata":"No Data","updateTask":"Update","createTracker":"Create Tracker","jobDetail":"Job Detail","waitingconfirm":" Waiting Confirm","noMember":" No Member","all":"ALL","newuser":"New user","noAddedMember":"No Added Member","driver":"Driver","":""}}

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"Sign in with o365","title":"Login","logout":"Logout","loginFail":"Login Fail","loginLocalFail":"Login Fail","getUserInfoFail":"Get User Info Fail From Microsoft Graph"}}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"Search","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"Search","showLess":"Show Less","showAll":"Show All"}}

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"Start Date","endDate":"End Date","user":"User","action":"Action","count":"Count","topActionByUser":"Top action by user","version":"Version","Hi":"Hi","Welcome to systems management":"Welcome to systems management","Manage your Tracker":"Manage your Tracker","Manage your Car reserve":"Manage your Car reserve","Manage your Project":"Manage your Project","Manage your systems":"Manage your systems"}}

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

module.exports = {"menu":{"nowIncoming":"Now and Incoming","drawingSystem":"Drawing System","drawingSystem2":"Drawing System New","about":"About","master":"Master Data","sellOrder":"Request Drawing","user":"Users","settings":"Settings","systemSettings":"System","transferTitle":"Transfer","userTitle":"User","systemInfo":"System Info","userGroup":"User Group","flow":"Flow","courseType":"Course Type","course":"Course","courseHistory":"Course History","courseWaitingApprove":"Approve Course","courseWaitingApprovHistory":"Approve Course History","courseWaitingRequest":"Approve Request to Join","report":"Report","trainingCourse":"Training Course","myCourse":"My Course","myCert":"My Cert","manageCourse":"Manage Course","home":"Home","masterData":"Master Data","incoming":"Incoming","history":"History","courseHome":"Training Course","tracker":"Tracker","training":"Training","menuAll":" All","menuCarManageAll":"Manage Reserve","menuDriverAll":"Driver","menuAllAdmin":"Admin Manage","manageJobList":"Job List","manageReserveCar":"Admin","manageReserve":"Manage Reserve","carReserve":"Car Reserve","carType":"Car Type","car":"Car","carDriver":"Car Driver","masterDataCar":"Master Data Car Reservation","masterDataTraining":"Master Data Training","menuAdminAll":"Admin Manage","manageCar":"Manage Car","manageUserGroup":"Manage User Group","reportCarReserve":"Report Car Reserve","usergroupadmin":"User Group Admin","trackerHome":"Back to Tracker","usergroups":"User Group","projectManagement":"Project Management","projectManagementManage":"Setting Customer","projectManagementMain":"My Project","backToPm":"Back To PM","":""},"report":{"transaction":"Transaction","score":"Score","course":"Report Course","carReserve":"Car Reserve","":""}}

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data","lastUpdateOilPrice":"Last Update","oilPrice":"Oil price"}}

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"Name","empId":"Employee Id","isAdmin":"Is Admin","isNpiAdmin":"Is Npi","manage":"Manage Users","costCenterName":"Cost Center","viewList":"View Users","manageNpi":"Manage NPI admin","manageAdmin":"Manage Admin","edit":"Edit","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"Back to List","manageSubmit":"Manage Submit","manageApprove":"Manage Approve","isSubmit":"Is Submit","isApprove":"Is Approve","fullname":"Fullname","username":"Username","department":"Department","email":"Email","notification":"Notification","sendMention":"Mention","sendUpdateProgress":"Update Progress","sendDone":"Done Task","sendCancel":"Cancel Task","employee":"Employee","costCenterId":"Cost Center Id","approved":"Approved","employeeId":"Employee Id","position":"Position","profile":"Profile","nameId":"Name And ID"}}

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports = {"master":{"setings":"Settings"},"masterCustomer":{"listMasterDataCustomer":"List Customer","createMasterDataCustomer":"Create Customer","updateMasterDataCustomer":"Update Customer","viewMasterDataCustomer":"Detail Customer","name":"Name","address":"Address","contactNo":"Contact No","contactName":"Contact Name","createCustomer":"Create Customer","":""}}

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

module.exports = {"systemInfo":{"title":"System Info","name":"Name","description":"Description","updateLog":"Update Log","version":"Version","":""}}

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

module.exports = {"tracker":{"titleHome":"Tracker","myTask":"My Task","taskList":"Task List","draft":"Draft","comment":"Comment","menuRecent":"Recent","menuAll":"All","status":"Status","priority":"Priority","all":"All","todo":"To-Do","onProcess":"On Process","test":"Test","done":"Done","closed":"closed","reject":"Reject","hold":"Hold","cancel":"Cancel","low":"Low","medium":"Medium","high":"High","to":"To","open":"Open","due":"Due date","remaining":"Remaining","issueTitle":"Issue Title","detail":"Detail","send":"Send","d":"D","m":"M","attach":"Attach","uploadBy":"Upload By","createBy":"Create By","commentBy":"Comment By","user":"User","logout":"Logout","attachment":"Attachment","update":"Update","submit":"Submit","inprogress":"In Progress","waitingTest":"Waiting Test","discuss":"Discuss","reopen":"Re Open","remark":"Remark","title":"Title","showmore":"more","makeYourSelf":"Would you like to make yourself as recipient?","areYouSureTo":"Are you sure to","thisTask":"this task","toGroup":"To Group","toUser":"To User","assignTo":"Assign To","assignMe":"Assign Me","titleHomeHistory":"Tracker History","titleHomeInComing":"Tracker InComing","titleHomeList":"Tracker List","owner":"Owner","noDescription":"No Description","viewTracker":"Detail Tracker","updateTracker":"Update Tracker","description":"Description","createTracker":"Create Tracker","back":"Back","message":"Message","assignUser":"Assign User"}}

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

module.exports = {"userGroup":{"title":"User Group","code":"Code","name":"Name","isServiceSystem":"Service System","pleaseConfirmGroupToDelete":"Type group code to confirm","create":"Create","userLists":"User Lists","createUserGroup":"Create User Groups","updateUserGroup":"Update User Group","viewUserGroup":"View User Group","delete":"Delete","pleaseEnterCode":"Please Enter Code"},"flow":{"title":"Flow","code":"Code","name":"Name","pleaseConfirmGroupToDelete":"Type flow code to confirm","create":"Create","flowLists":"Flow Lists","createFlow":"Create Flow","updateFlow":"Update Flow","viewFlow":"View Flow","level":"Level","":""},"courseType":{"title":"Course Type","code":"Course ID","nameTh":"Name TH","nameEn":"Name EN","pleaseConfirmCourseTypeToDelete":"Type course type code to confirm","descriptionTh":"Description TH","descriptionEn":"Description EN","trainingId":"Categories","createCourseType":"Create Course Type","updateCourseType":"Update Course Type","viewCourseType":"View Course Type","":""},"course":{"title":"Course","titleHistory":"Course History","code":"Code","nameTh":"Name TH","nameEn":"Name EN","pleaseConfirmCourseToDelete":"Type course training id to confirm","pleaseCheckTrainingCode":"Please check training id","descriptionTh":"Description TH","descriptionEn":"Description EN","createCourse":"Create Course","createCourseHistory":"Create Course History","updateCourse":"Update Course","updateCourseHistory":"Update Course History","viewCourse":"View Course","viewCourseHistory":"View Course History","trainingId":"Categories","startDateTime":"Start Date Time","endDateTime":"End Date Time","status":"Status","isPrivate":"Private","speaker":"Speaker","institution":"Institution","typeId":"Course ID","isInternal":"Internal","isGetCert":"Get Certificate","minimumPassScore":"Minimum Pass Score","approveFlowId":"Approve Flow","image":"Image","imageCar":"Image Car","imageGreenBook":"Image Green Book","price":"Price","user":"User","users":"Users","updateCar":"Update Car","viewDetailCar":"View Detail Car","summaryDays":"Summary Days","isSuccessApproved":"Approved","userRequest":"User Request Manage","confirmPointCertModal":"Point and Certificate","addPoint":"Add Point","addCert":"Upload Cert","userPoint":"Point","uploadCert":"Upload Cert","selectNone":"Select None","selectAll":"Select All","fileList":"File Lists","downloadUrl":"Download Document","inHouseTraining":"In-House Training","publicTraining":"Public Training","":""},"courseWaitingApprove":{"title":"Approve Course","titleHistory":"Approve Course History","detailTitle":"Detail Approve Course","detailTitleHistory":"Detail Approve Course History","confirmMessage":"Are you sure to approve this course?","confirmDeleteMessage":"Are you sure to cancel this course?","":""},"courseWaitingRequest":{"title":"Approve Request to Join","confirmMessage":"Are you sure to approve this request?","selectYourUserRequest":"Select your user to approve to request","confirmListRequestModal":"Confirm List Request"}}

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

module.exports = {"training":{"myCourse":"My Course","myCert":"My Cert","requestToJoin":"Request To Join","showDetail":"Detail","trainingList":"Training List","confirmMessage":"Are you sure to join this course?","date":"Date","confirmToJoin":"Confirm To Join","showCert":"Certificate","cert":"Certificate","speaker":"Speaker","alreadyInCourse":"Already Join","courseAvailableToJoin":"Course Available","history":"History","information":"Information","attachment":"Attachment","downloadUrl":"File Download","isAlreadyInCourse":"Already In Course","isAlreadyRequestToJoin":"Waiting Confirm","":""}}

/***/ }),

/***/ 737:
/***/ (function(module, exports) {

module.exports = {"carType":{"title":"Car Type","name":"Name","description":"Description","site":"Site","titleCreate":"Create Car Type","titleUpdate":"Update Car Type","titleView":"View Car Type","createCartype":"Create Cartype","":""},"carSettings":{"title":"Car","titleCreate":"Create Car","titleUpdate":"Update Car","titleView":"View Car","name":"Name","description":"Description","gearboxType":"Gear Box Type","miles":"Miles","brand":"Brand","model":"Model","seatingCapacity":"Seating Capacity","modelYear":"Model Year","doors":"Doors","bodyColor":"Body Color","gearBoxType":"Gear Box Type","carTypeId":"Car Type","fuelTypeId":"Fuel Type","registrationDate":"Registration Date","licenseNo":"License No","engineNo":"Engine No","classicNo":"VIN No","powerUsage":"Power Usage","insuredCompany":"Insured Company","insuredStart":"Insured Start","insuredEnd":"Insured End","vatStart":"Vat Start","vatEnd":"Vat End","colorOnCalendar":"Color On Calendar","active":"Active","areYourSureToActive":"Are you sure to active this car","areYourSureToInactive":"Are you sure to inactive this car","areYourSureToDelete":"Are you sure to cancel?","Delete":"Delete","Milestart":"Mile Start","CreateCar":"Create Car"},"carDriver":{"title":"Car Driver","updateTitle":"Update Car Driver","description":"Description","driverSelect":"Select Driver","driverList":"Driver List","code":"Code","carType":"Car Type","":""}}

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

module.exports = {"car":{"carReserveList":"Car Reserve List","carReserveHistory":"Car Reserve History","carReserve":"Car Reserve","reserveList":"Reserve List","docShowList":"Document List","successReserve":"Success","failReserve":"Fail / Cancel","tableTimeLineCar":"Table Time Car","carUseDateTime":"Car Use Date","actionWaitingApprove":"Waiting Approve","actionOnGoing":"On Going","actionOnTheWay":"On The Way","actionSuccess":"Success","actionReject":"Reject","actionCancel":"Cancel","bookingCar":"Reserve Car","bookingDescription":"Description","userRequest":"User Request","department":"Department","isAllDay":"All Day","isUseDriver":"Use Driver","startDateTime":"Start Date Time","endDateTime":"End Date Time","startDate":"Start Date","endDate":"End Date","passenger":"Passenger","locationName":"Location Name","location":"Location","locationAddress":"Address","objective":"Objective","selectLocation":"Change Location","startlocationAddress":"Start Location Address","endlocationAddress":"End Location Address","startlocation":"Start Location","endlocation":"End Location","titleRecheckConfirmData":"Please Recheck and Confirmation","subTitleRecheckConfirmData":"I checked the information to make The car has been reserved","editDocument":"Edit Document","menuManageAll":"All Manage","manageReserveCar":"Manager Reserve Car","reserveRequest":"Reserve Request","bookingApproved":"Reserved has been approved","car":"Car","driver":"Driver","editReserveCar":"Edit Reserve Car","selectCar":"Select Car","selectDriver":"Select Driver","remarkForRejectReserve":"Specify the reason for canceling the booking","checkLocation":"Check Location","history":"History","historyReserveRequest":"History Reserve Request","chooseOrSearch":"Choose location on map or Search Name","locationFrom":"From Location","locationTo":"To Location","carType":"Car Type","driverList":"To Drive List","carBrand":"Car Brand","create":"Create","createCar":"Create","createCarType":"Create","reject":"Reject","approve":"Approve","PleaseSelectCar":"Please select a car","PleaseSelectDriver":"Please select a driver","SelectDriver":"Select Driver","SelectCar":"Select Car","areYourSure":"Are your sure?","whyReject":"Please provide a reason for refusal.","site":"Site","description":"Description","detailCartype":"Detail Cartype","updateCartype":"Update Cartype","Driver":"Driver","allDay":"AllDay","approveForm":"APPROVE","useDriver":"Use Driver","carReserveReport":"Car Reserve Report","reserveBy":"Reserve By","Request By:":"Request By:","Start":"Start","End":"End","CreateReserve":"Create Reserve","viewReserve":"Detail Reserve","updateReserve":"Update reserve","cancel":"Cancel","submit":"Submit","done":"Done","reserveNo":"Reserve No:","":""}}

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

module.exports = {"driverJob":{"title":"Job List","navigate":"Navigate","start":"Start","end":"End","startCarMile":"Start Mile","endCarMile":"End Mile","fillDistanceStart":"Fill in form mile start","fillDistanceEnd":"Fill in form mile end","pleaseCheckConfirm":"Please check and confirm before returning the vehicle","checkMiles":"Check both the start and end miles of the car","km":"Km","qDrive":"Drive's Queue","orderItem":"Sort Queue by date time.","preparingDrive":"In Process","totalMile":"Total Mile","totalCost":"Total Cost","":""}}

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

module.exports = {"project":{"name":"Name","description":"Description","customer":"Customer","projectOwner":"Project Owner","dueDate":"Due Date","startDate":"Start Date","workProgress":"Work Progress","member":"Member","addMember":"Add Member","add":"Add","back":"Back","selectMember":"Select Member","selected":"Selected","createProject":"Create Project","updateProject":"Update Project","viewProject":"Detail Project","cancel":"Cancel","inComing":"In Coming","onProcess":"On Process","done":"Done","reject":"Reject","onHold":"On Hold","timeSheet":"Time Sheet","user":"User","startDateTime":"Start Date Time","endDateTime":"End Date Time","total":"Total","detail":"Datail","dailyReports":"No Daily Reports","days":"Days","addTimesheet":"Add Timesheet","projecStatus":"Project Status","remark":"Remark","assignUser":"Assign User","":""}}

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"ตกลง","cancel":"ยกเลิก","back":"กลับ","welcome":"ยินดีต้อนรับ","hello":"สวัสดี","somethingWrong":"เกิดความผิดพลาด ลองใหม่อีกครั้ง","pleaseContactAdminAx":"กรุณาติดต่อผู้ดูแล AX","yourData":"ข้อมูลที่จะทำการบันทึก","validateError":"ไม่สามารถทำรายการต่อไปได้ กรุณากรอกข้อมูลให้ครบถ้วน","validateCommentError":"กรุณาแสดงความคิดเห็น","attachError":"ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากท่านยังไม่ได้ทำการเลือกไฟล์","squareInch":"SQUARE INCH","version":"เวอร์ชัน","logout":"ออกจากระบบ","npiSystem":"ระบบ NPI","pageNotFound":"ไม่พบหน้า","redirectPage":"กำลังกลับสู่หน้าหลักใน","unauthen":"ไม่มีสิทธิเข้าใช้งาน, กรุณาติดต่อเจ้าหน้าที่ เพื่อขอสิทธิใช้งาน","success":"สำเร็จ","fail":"ไม่สำเร็จ","itemCode":"รหัสรายการ","itemStatus":"สถานะ","code":"โค้ด","name":"ชื่อ","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","left":"Left","right":"Right","edit":"Edit","reject":"Reject","search":"ค้นหา","lastUpdateBy":"แก้ไขโดย","create":"เพิ่ม","view":"ดูรายละเอียด","update":"แก้ไข","value":"Value","createFail":"บันทึกไม่สำเร็จ","updateFail":"ปรับปรุงไม่สำเร็จ","upload":"อัพโหลด","comment":"ส่งข้อความ","close":"ปิด","closed":"ปิดเคส","confirm":"ยืนยัน","save":"บันทึก","chooseOptions":"Choose an option","add":"เพิ่ม","submit":"ยืนยัน","transfer":"Transfer","scan":"Scan","receive":"Receive","delete":"ลบ","deleteBy":"ลบโดย","print":"พิมพ์","printDate":"วันที่พิมพ์","sendToAx":"ส่งไปยัง Ax","from":"From","to":"To","approve":"Approve","send":"ส่ง","date":"วันที่","deleteWithComment":"Delete With Comment","settings":"การตั้งค่า","clear":"ล้างข้อมูล","home":"หน้าหลัก","receivePrint":"Receive/Print","createDate":"Create Date","createBy":"Create By","updateDate":"Update Date","updateBy":"Update By","createTranferDate":"Create Transfer Date","noData":"No Data","description":"Description","addLevel":"Add Level","addUser":"Add User","pleaseConfirmEmpId":"Enter EmpId","incorrect":"Incorrect you password!!!","next":"Next","manage":"Manage","export":"ส่งออก","removeLevel":"Remove Level","verifyFailed":"Verify Failed","pleaseEnterEmpId":"Please Enter EmpId","dateFrom":"Date From","dateTo":"Date To","addFile":"Add File","noUsers":"No Users","pleaseCheckTrainingCode":"Please Check Training Code","menu":"Menu","modules":"Modules","tracker":"Tracker","training":"Training","services":"Services","fillFullname":"ระบุชื่อ-นามสกุล","bth":"บาท","confirmDelete":"Confirm Delete","cancelDelete":"ยกเลิกการลบ","admin":"ผู้ดูแลระบบ","assignToRequire":"Please assign to user before done task.","pleaseProvideRating":"Satisfaction Rating","selectedCarType":"เลือกประเภทรถ","start":"เริ่มงาน","reOpen":"เปิดอีกครั้ง","open":"เปิด","draft":"แบบร่าง","high":"สูง","medium":"กลาง","low":"ต่ำ","toDo":"ต้องทำ","notOpen":"ยังไม่เปิด","inprogress":"ระหว่างดำเนินการ","waitingTest":"รอทดสอบ","done":"สำเร็จ","discuss":"พิจารณา","projects":"โปรเจ็ค","carApprove":"ยืนยันการจอง","nodata":"ไม่มีข้อมูล","updateTask":"อัพเดท","user":"ผู้ใช้","selectUser":"เลือกผู้ใช้","createTracker":"สร้างการติดตามงาน","jobDetail":"รายละเอียดงาน","waitingconfirm":"รอการยืนยัน","noMember":"ไม่มีสมาชิก","newuser":"สมาชิกใหม่","all":"ทั้งหมด","noAddedMember":"ไม่มีการเพิ่มสมาชิก"}}

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"ลงชื่อเข้าใช้ด้วย o365","title":"ลงชื่อเข้าใช้","logout":"ลงชื่อออก","loginFail":"ลงชื่อเข้าใช้งาน ไม่สำเร็จ","loginLocalFail":"ลงชื่อเข้าใช้งาน ไม่สำเร็จ","getUserInfoFail":"ดึงข้อมูลจาก Microsoft Graph ไม่สำเร็จ"}}

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"ค้นหา","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"ค้นหา","showLess":"แสดงแบบย่อ","showAll":"แสดงทั้งหมด"}}

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"วันที่เริ่มต้น","endDate":"วันที่สิ้นสุด","user":"ผู้ใช้งาน","action":"สถานะ","count":"จำนวน","topActionByUser":"ผู้ใช้งานที่ใช้งานสูงสุด ในแต่ละสถานะ","version":"เวอร์ชัน","Hi":"สวัสดี","Welcome to systems management":"ยินดีต้อนรับสู่การจัดการระบบ","Manage your Tracker":"การจัดการการติดตามงาน","Manage your Car reserve":"การจัดการระบบจองรถ","Manage your Project":"การจัดการโปรเจ็ค","Manage your systems":"การจัดการระบบ"}}

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

module.exports = {"menu":{"nowIncoming":"Now and Incoming","drawingSystem":"ระบบบันทึก Drawing","drawingSystem2":"ระบบบันทึก Drawing 2","about":"รายละเอียด","master":"ข้อมูล เริ่มต้น","sellOrder":"ระบบันทึกแบบ Sale","user":"ผู้ใช้งาน","settings":"ตั้งค่า","systemSettings":"ระบบ","transferTitle":"Transfer","userTitle":"User","systemInfo":"System Info","userGroup":"กลุ่มผู้ใช้งาน","flow":"Flow","menuAllAdmin":"Admin Manage","courseType":"Course Type","course":"Course","courseHistory":"Course History","courseWaitingApprove":"Approve Course","courseWaitingApprovHistory":"Approve Course History","courseWaitingRequest":"Approve Request to Join","report":"Report","trainingCourse":"คอร์สอบรม","myCourse":"My Course","myCert":"My Cert","manageCourse":"จัดการคอร์ส","home":"หน้าหลัก","masterData":"Master Data","incoming":"จะมาถึง","history":"รายการย้อนหลัง","courseHome":"Training Course","usergroups":"User Group","":"","projectManagement":"Project Management","projectManagementManage":"จัดการข้อมูลลูกค้า","projectManagementMain":"โปรเจค ของฉัน","backToPm":"Back To PM"},"report":{"transaction":"Transaction","score":"Score","course":"Report Course","carReserve":"Car Reserve"}}

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล","lastUpdateOilPrice":"อัพเดทล่าสุด","oilPrice":"ราคาน้ำมัน"}}

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"ชื่อ","empId":"รหัสพนักงาน","isAdmin":"สิทธิ Admin","isNpiAdmin":"สิทธิ Npi","manage":"รายละเอียด ผู้ใช้งาน","costCenterName":"หน่วยงาน","viewList":"รายละเอียดผู้ใช้งาน","manageNpi":"จัดการ สิทธิ NPI","manageAdmin":"จัดการ สิทธิ Admin","edit":"แก้ไข","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"กลับหน้า รายละเอียดผู้ใช้งาน","manageSubmit":"Manage Submit","manageApprove":"Manage Approve","isSubmit":"Is Submit","isApprove":"Is Approve","fullname":"ชื่อ-นามสกุล","username":"ชื่อผู้ใช้งาน","department":"แผนก","email":"อีเมล","notification":"Notification","sendMention":"Mention","sendUpdateProgress":"Update Progress","sendDone":"Done Task","sendCancel":"Cancel Task","employeeId":"รหัสพนักงาน","position":"ตำแหน่ง","profile":"โปรไฟล์","employee":"พนักงาน","costCenterId":"Cost Center Id","nameId":"ชื่อและรหัสพนักงาน"}}

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

module.exports = {"master":{"setings":"การตั้งค่า"},"masterCustomer":{"listMasterDataCustomer":"รายชื่อลูกค้า","createMasterDataCustomer":"เพื่มลูกค้า","updateMasterDataCustomer":"อัพเดตข้อมูลลูกค้า","viewMasterDataCustomer":"รายละเอียดลูกค้า","name":"ชื่อ","address":"ที่อยู่","contactNo":"เบอร์ติดต่อ","contactName":"ชื่อผู้ติดต่อ","createCustomer":"เพื่มลูกค้า","":""}}

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

module.exports = {"systemInfo":{"title":"ข้อมูลระบบ","name":"ชื่อ","description":"รายละเอียด","updateLog":"รายการปรับปรุง","version":"เวอร์ชั่น","":""}}

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports = {"tracker":{"titleHome":"Tracker","myTask":"My Task","taskList":"Task List","draft":"Draft","comment":"Comment","menuRecent":"Recent","menuAll":"All","status":"Status","priority":"ลำดับความสำคัญ","all":"All","todo":"To-Do","onProcess":"On Process","test":"Test","done":"Done","closed":"ปิดเคส","reject":"Reject","hold":"Hold","cancel":"Cancel","low":"Low","medium":"Medium","high":"High","to":"To","open":"Open","due":"ครบกำหนด","remaining":"Remaining","issueTitle":"Issue Title","detail":"รายละเอียด","send":"Send","d":"ว","m":"ด","attach":"Attach","uploadBy":"Upload By","createBy":"Create By","commentBy":"Comment By","user":"User","logout":"Logout","attachment":"Attachment","update":"Update","submit":"ยืนยัน","inprogress":"In Progress","waitingTest":"Waiting Test","discuss":"Discuss","reopen":"Re Open","remark":"Remark","title":"ชื่อ","showmore":"more","makeYourSelf":"Would you like to make yourself as recipient?","areYouSureTo":"Are you sure to","thisTask":"this task","toGroup":"ถึงกลุ่ม","toUser":"ถึงผู้ใช้","assignTo":"Assign To","assignMe":"Assign Me","titleHomeHistory":"ประวัติการติดตามงาน","titleHomeInComing":"ติดตามงานที่กำลังมาถึง","titleHomeList":"งานของฉัน","owner":"เจ้าของ","noDescription":"ไม่มีคำอธิบาย","viewTracker":"รายละเอียดงาน","updateTracker":"อัปเดตงาน","description":"คำอธิบาย","createTracker":"สร้างการติดตาม","back":"กลับ","message":"ข้อความ","assignUser":"กำหนดผู้ใช้"}}

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

module.exports = {"userGroup":{"title":"กลุ่มผู้ใช้งาน","code":"โค้ด","name":"ชื่อ","isServiceSystem":"ระบบบริการ","pleaseConfirmGroupToDelete":"Type group code to confirm","create":"Create","userLists":"User Lists","createUserGroup":"สร้างกลุ่มผู้ใช้","updateUserGroup":"อัปเดตกลุ่มผู้ใช้","viewUserGroup":"ดูกลุ่มผู้ใช้","delete":"ลบ","pleaseEnterCode":"ยืนยันโค้ด"},"flow":{"title":"Flow","code":"Code","name":"Name","pleaseConfirmGroupToDelete":"Type flow code to confirm","create":"Create","flowLists":"Flow Lists","createFlow":"Create Flow","updateFlow":"Update Flow","viewFlow":"View Flow","level":"Level","":""},"courseType":{"title":"Course Type","code":"Course ID","nameTh":"Name TH","nameEn":"Name EN","pleaseConfirmCourseTypeToDelete":"Type course type code to confirm","descriptionTh":"Description TH","descriptionEn":"Description EN","trainingId":"Categories","createCourseType":"Create Course Type","updateCourseType":"Update Course Type","viewCourseType":"View Course Type","":""},"course":{"title":"Course","titleHistory":"Course History","code":"Code","nameTh":"Name TH","nameEn":"Name EN","pleaseConfirmCourseToDelete":"Type course training id to confirm","pleaseCheckTrainingCode":"Please check training id","descriptionTh":"Description TH","descriptionEn":"Description EN","createCourse":"Create Course","createCourseHistory":"Create Course History","updateCourse":"Update Course","updateCourseHistory":"Update Course History","viewCourse":"View Course","viewCourseHistory":"View Course History","trainingId":"Categories","startDateTime":"Start Date Time","endDateTime":"End Date Time","status":"Status","isPrivate":"Private","speaker":"Speaker","institution":"Institution","typeId":"Course ID","isInternal":"Internal","isGetCert":"Get Certificate","minimumPassScore":"Minimum Pass Score","approveFlowId":"Approve Flow","image":"รูปภาพ","imageCar":"รูปภาพรถ","imageGreenBook":"รูปภาพเล่มเขียว","price":"Price","user":"User","users":"Users","updateCar":"อัพเดทรถ","viewDetailCar":"ดูรายละเอียดรถ","summaryDays":"Summary Days","isSuccessApproved":"Approved","userRequest":"User Request Manage","confirmPointCertModal":"Point and Certificate","addPoint":"Add Point","addCert":"Upload Cert","userPoint":"Point","uploadCert":"Upload Cert","selectNone":"Select None","selectAll":"Select All","fileList":"File Lists","downloadUrl":"Download Document","inHouseTraining":"In-House Training","publicTraining":"Public Training","":""},"courseWaitingApprove":{"title":"Approve Course","titleHistory":"Approve Course History","detailTitle":"Detail Approve Course","detailTitleHistory":"Detail Approve Course History","confirmMessage":"Are you sure to approve this course?","confirmDeleteMessage":"Are you sure to cancel this course?","":""},"courseWaitingRequest":{"title":"Approve Request to Join","confirmMessage":"Are you sure to approve this request?","selectYourUserRequest":"Select your user to approve to request","confirmListRequestModal":"Confirm List Request"}}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports = {"training":{"myCourse":"คอร์สของฉัน","myCert":"รายการย้อนหลัง","requestToJoin":"ขอเข้าร่วม","showDetail":"รายละเอียด","trainingList":"รายการคอร์ส","confirmMessage":"คุณแน่ใจใช่ไหมที่จะเข้าร่วมคอร์สนี้?","date":"วัน","confirmToJoin":"ยืนยันการเข้าร่วม","showCert":"ประกาศนียบัตร","cert":"ประกาศนียบัตร","speaker":"ผู้บรรยาย","alreadyInCourse":"เข้าร่วม","courseAvailableToJoin":"ที่เปิด","history":"History","information":"Information","attachment":"Attachment","downloadUrl":"เอกสารประกอบคอร์ส","isAlreadyInCourse":"Already In Course","isAlreadyRequestToJoin":"Waiting Confirm","":""}}

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports = {"car":{"carReserveList":"รายการการจองรถ","carReserveHistory":"ประวัติการจองรถ","carReserve":"การจองคิวรถ","reserveList":"รายการยืมรถยนต์","docShowList":"รายการแสดงเอกสาร","successReserve":"สำเร็จ","failReserve":"ล้มเหลว / ยกเลิก","tableTimeLineCar":"ตารางการเดินรถr","carUseDateTime":"วันที่เดินทาง","actionWaitingApprove":"Waiting Approve","actionOnGoing":"On Going","actionOnTheWay":"On The Way","actionSuccess":"Success","actionReject":"Reject","actionCancel":"Cancel","bookingCar":"Reserve Car","bookingDescription":"Description","department":"แผนก","isAllDay":"All Day","isUseDriver":"Use Driver","startDateTime":"วันและเวลาที่เริ่ม","endDateTime":"วันและเวลาที่สิ้นสุด","startDate":"วันที่เริ่ม","endDate":"วันที่สิ้นสุด","locationName":"Location Name","location":"Location","locationAddress":"Address","objective":"วัตถุประสงค์","selectLocation":"Change Location","startlocation":"ต้นทาง","endlocation":"ปลายทาง","titleRecheckConfirmData":"Please Recheck and Confirmation","subTitleRecheckConfirmData":"I checked the information to make The car has been reserved","editDocument":"Edit Document","menuManageAll":"All Manage","manageReserveCar":"Manager Reserve Car","reserveRequest":"Reserve Request","bookingApproved":"Reserved has been approved","car":"รถ","driver":"Driver","editReserveCar":"Edit Reserve Car","selectCar":"Select Car","selectDriver":"เลือกคนขับรถ","remarkForRejectReserve":"Specify the reason for canceling the booking","checkLocation":"ตรวจสอบพิกัด","historyReserveRequest":"History Reserve Request","chooseOrSearch":"Choose location on map or Search Name","locationFrom":"From Location","locationTo":"To Location","carType":"ประเภทรถ","driverList":"รายการขับรถ","carBrand":"รุ่นรถ","userRequest":"ผู้ที่ขอ","passenger":"จำนวนผู้โดยสาร","startlocationAddress":"ต้นทาง","endlocationAddress":"ปลายทาง","create":"เพิ่ม","createCar":"เพิ่มรถ","createCarType":"เพิ่มประเภทรถ","approve":"อนุมัติ","cancel":"ยกเลิก","reject":"ปฏิเสธ","submit":"ส่งคำขอ","done":"เสร็จสิ้น","PleaseSelectCar":"กรุณาเลือกรถ","PleaseSelectDriver":"กรุณาเลือกคนขับรถ","SelectDriver":"เลือกคนขับรถ","SelectCar":"เลือกรถ","areYourSure":"คุณแน่ใจไหม ?","whyReject":"โปรดระบุเหตุผลที่จะปฏิเสธ","site":"โรงงาน","description":"คำอธิบาย","detailCartype":"รายละเอียดประเภทรถ","updateCartype":"อัพเดทประเภทรถ","Driver":"พนักงานขับรถ","allDay":"ทั้งวัน","approveForm":"อนุมัติรถ","useDriver":"ต้องการคนขับรถ","carReserveReport":"รายงานการจองรถ","Request By:":"ผู้ที่ขอ:","Start":"เริ่ม","End":"จบงาน","CreateReserve":"สร้างการจองคิวรถ","viewReserve":"รายละเอียดการจอง","updateReserve":"อัปเดตการจอง","reserveNo":"เลขที่การจอง:","reserveBy":"จองโดย"}}

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports = {"driverJob":{"title":"Job List","navigate":"Navigate","start":"Start","end":"End","startCarMile":"ไมล์เริ่มต้น","endCarMile":"สิ้นสุดไมล์","fillDistanceStart":"กรอกแบบฟอร์มไมล์เริ่มต้น","fillDistanceEnd":"Fill in form mile end","pleaseCheckConfirm":"กรุณาตรวจสอบและยืนยันก่อนคืนรถ","checkMiles":"ตรวจสอบทั้งไมล์เริ่มต้นและสิ้นสุดของรถ","km":"Km","qDrive":"คิวของไดรฟ์","orderItem":"เรียงคิวตามวันที่และเวลา.","preparingDrive":"อยู่ในระหว่างการดำเนินการ","totalMile":"ไมล์สะสมทั้งหมด","totalCost":"ค่าใช้จ่ายทั้งหมด","":""}}

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

module.exports = {"carType":{"title":"ประเภทรถ","name":"ชื่อ","description":"คำอธิบาย","site":"โรงงาน","titleCreate":"สร้างประเภทรถ","titleUpdate":"อัพเดทประเภทรถ","titleView":"ดูประเภทรถ","createCartype":"เพิ่มประเภทรถ"},"carSettings":{"title":"รถ","titleCreate":"Create Car","titleUpdate":"Update Car","titleView":"View Car","name":"ชื่อ","description":"คำอธิบาย","gearBoxType":"ประเภทเกียร์","miles":"ไมล์","brand":"ยี่ห้อ","model":"รุ่น","seatingCapacity":"ที่นั่ง","modelYear":"รุ่นปี","doors":"ประตู","bodyColor":"สีรถ","carTypeId":"ประเภทรถ","fuelTypeId":"ประเภทน้ำมัน","registrationDate":"วันที่ลงทะเบียน","licenseNo":"ทะเบียนรถ","engineNo":"หมายเลขเครื่องยนต์","classicNo":"หมายเลขตัวถังรถ","powerUsage":"แรงม้า","insuredCompany":"บริษัทประกัน","insuredStart":"วันที่เริ่มระกัน","insuredEnd":"วันที่หมดประกัน","vatStart":"วันที่เริ่มภาษี","vatEnd":"วันที่หมดภาษี","colorOnCalendar":"สีบนปฏิทิน","active":"เปิดใช้งาน","areYourSureToActive":"คุณแน่ใจหรือไม่ที่จะเปิดใช้งาน","areYourSureToInactive":"คุณแน่ใจหรือไม่ที่จะปิดใช้งาน","areYourSureToDelete":"คุณแน่ใจหรือที่จะยกเลิก","Delete":"ลบ","Milestart":"ไมล์เริ่มต้น","CreateCar":"สร้างรายละเอียดรถ"},"carDriver":{"title":"Car Driver","updateTitle":"Update Car Driver","description":"Description","driverSelect":"เลือกคนขับรถ","driverList":"Driver List","code":"Code","carType":"Car Type","":""}}

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

module.exports = {"project":{"name":"ชื่อ","description":"รายละเอียด","customer":"ลูกค้า","projectOwner":"เจ้าของโครงการ","dueDate":"วันครบกำหนด","startDate":"วันที่เริ่มต้น","workProgress":"ความก้าวหน้าของงาน","member":"สมาชิก","addMember":"เพิ่มสมาชิก","add":"เพิ่ม","back":"ย้อนกลับ","selectMember":"เลือกสมาชิก","selected":"เลือก","createProject":"สร้างโครงการ","updateProject":"แก้ไขโครงการ","viewProject":"โครงการ","cancel":"ยกเลิก","inComing":"รอดำเนินการ","onProcess":"ระหว่างดำเนินการ","done":"สำเร็จ","reject":"ปฏิเสธ","onHold":"กำลังพิจารณา","timeSheet":"รายงานประจำวัน","user":"ผุ้ใช้","startDateTime":"วันและเวลาที่เริ่ม","endDateTime":"วันและเวลาที่สิ้นสุด","total":"รวม","detail":"รายละเอียด","dailyReports":"ไม่มีรายงานประจำวัน","days":"วัน","addTimesheet":"ลงเวลางาน","projecStatus":"สถานะโปรเจ็ค","remark":"ข้อสังเกต","assignUser":"กำหนดผู้ใช้"}}

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_GET_ALL_CAR_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_GET_ALL_CAR_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_GET_ALL_CAR_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_GET_CAR_TYPE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_GET_CAR_TYPE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_GET_CAR_TYPE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_GET_MASTER_CAR_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_GET_MASTER_CAR_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_GET_MASTER_CAR_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_CREATE_CAR_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_CREATE_CAR_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_CREATE_CAR_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_UPDATE_CAR_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_UPDATE_CAR_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_UPDATE_CAR_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_GET_ALL_CAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_GET_ALL_CAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_GET_ALL_CAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_GET_ALL_FUEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_GET_ALL_FUEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_GET_ALL_FUEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_GET_CAR_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_GET_CAR_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_GET_CAR_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_CREATE_CAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_CREATE_CAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_CREATE_CAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_UPDATE_CAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_UPDATE_CAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_UPDATE_CAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_GET_ALL_CAR_DRIVER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_GET_ALL_CAR_DRIVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_GET_ALL_CAR_DRIVER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_UPDATE_CAR_DRIVER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_UPDATE_CAR_DRIVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_UPDATE_CAR_DRIVER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_GET_ALL_MY_JOB_DRIVER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_GET_ALL_MY_JOB_DRIVER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_UPDATE_ACTIVE_CAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_UPDATE_ACTIVE_CAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_UPDATE_ACTIVE_CAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_GET_CAR_RESERVE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_GET_CAR_RESERVE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_GET_CAR_RESERVE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_DELETE_CAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_DELETE_CAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_DELETE_CAR_FAILURE; });
var CORE_GET_ALL_CAR_TYPE_REQUEST = 'CORE_GET_ALL_CAR_TYPE_REQUEST';
var CORE_GET_ALL_CAR_TYPE_SUCCESS = 'CORE_GET_ALL_CAR_TYPE_SUCCESS';
var CORE_GET_ALL_CAR_TYPE_FAILURE = 'CORE_GET_ALL_CAR_TYPE_FAILURE';

var CORE_GET_CAR_TYPE_BY_ID_REQUEST = 'CORE_GET_CAR_TYPE_BY_ID_REQUEST';
var CORE_GET_CAR_TYPE_BY_ID_SUCCESS = 'CORE_GET_CAR_TYPE_BY_ID_SUCCESS';
var CORE_GET_CAR_TYPE_BY_ID_FAILURE = 'CORE_GET_CAR_TYPE_BY_ID_FAILURE';

var CORE_GET_MASTER_CAR_TYPE_REQUEST = 'CORE_GET_MASTER_CAR_TYPE_REQUEST';
var CORE_GET_MASTER_CAR_TYPE_SUCCESS = 'CORE_GET_MASTER_CAR_TYPE_SUCCESS';
var CORE_GET_MASTER_CAR_TYPE_FAILURE = 'CORE_GET_MASTER_CAR_TYPE_FAILURE';

var CORE_CREATE_CAR_TYPE_REQUEST = 'CORE_CREATE_CAR_TYPE_REQUEST';
var CORE_CREATE_CAR_TYPE_SUCCESS = 'CORE_CREATE_CAR_TYPE_SUCCESS';
var CORE_CREATE_CAR_TYPE_FAILURE = 'CORE_CREATE_CAR_TYPE_FAILURE';

var CORE_UPDATE_CAR_TYPE_REQUEST = 'CORE_UPDATE_CAR_TYPE_REQUEST';
var CORE_UPDATE_CAR_TYPE_SUCCESS = 'CORE_UPDATE_CAR_TYPE_SUCCESS';
var CORE_UPDATE_CAR_TYPE_FAILURE = 'CORE_UPDATE_CAR_TYPE_FAILURE';

var CORE_GET_ALL_CAR_REQUEST = 'CORE_GET_ALL_CAR_REQUEST';
var CORE_GET_ALL_CAR_SUCCESS = 'CORE_GET_ALL_CAR_SUCCESS';
var CORE_GET_ALL_CAR_FAILURE = 'CORE_GET_ALL_CAR_FAILURE';

var CORE_GET_ALL_FUEL_REQUEST = 'CORE_GET_ALL_FUEL_REQUEST';
var CORE_GET_ALL_FUEL_SUCCESS = 'CORE_GET_ALL_FUEL_SUCCESS';
var CORE_GET_ALL_FUEL_FAILURE = 'CORE_GET_ALL_FUEL_FAILURE';

var CORE_GET_CAR_BY_ID_REQUEST = 'CORE_GET_CAR_BY_ID_REQUEST';
var CORE_GET_CAR_BY_ID_SUCCESS = 'CORE_GET_CAR_BY_ID_SUCCESS';
var CORE_GET_CAR_BY_ID_FAILURE = 'CORE_GET_CAR_BY_ID_FAILURE';

var CORE_CREATE_CAR_REQUEST = 'CORE_CREATE_CAR_REQUEST';
var CORE_CREATE_CAR_SUCCESS = 'CORE_CREATE_CAR_SUCCESS';
var CORE_CREATE_CAR_FAILURE = 'CORE_CREATE_CAR_FAILURE';

var CORE_UPDATE_CAR_REQUEST = 'CORE_UPDATE_CAR_REQUEST';
var CORE_UPDATE_CAR_SUCCESS = 'CORE_UPDATE_CAR_SUCCESS';
var CORE_UPDATE_CAR_FAILURE = 'CORE_UPDATE_CAR_FAILURE';

var CORE_GET_ALL_CAR_DRIVER_REQUEST = 'CORE_GET_ALL_CAR_DRIVER_REQUEST';
var CORE_GET_ALL_CAR_DRIVER_SUCCESS = 'CORE_GET_ALL_CAR_DRIVER_SUCCESS';
var CORE_GET_ALL_CAR_DRIVER_FAILURE = 'CORE_GET_ALL_CAR_DRIVER_FAILURE';

var CORE_UPDATE_CAR_DRIVER_REQUEST = 'CORE_UPDATE_CAR_DRIVER_REQUEST';
var CORE_UPDATE_CAR_DRIVER_SUCCESS = 'CORE_UPDATE_CAR_DRIVER_SUCCESS';
var CORE_UPDATE_CAR_DRIVER_FAILURE = 'CORE_UPDATE_CAR_DRIVER_FAILURE';

var CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST = 'CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST';
var CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS = 'CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS';
var CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE = 'CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE';

var CORE_GET_ALL_MY_JOB_DRIVER_REQUEST = 'CORE_GET_ALL_MY_JOB_DRIVER_REQUEST';
var CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS = 'CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS';
var CORE_GET_ALL_MY_JOB_DRIVER_FAILURE = 'CORE_GET_ALL_MY_JOB_DRIVER_FAILURE';

var CORE_UPDATE_ACTIVE_CAR_REQUEST = 'CORE_UPDATE_ACTIVE_CAR_REQUEST';
var CORE_UPDATE_ACTIVE_CAR_SUCCESS = 'CORE_UPDATE_ACTIVE_CAR_SUCCESS';
var CORE_UPDATE_ACTIVE_CAR_FAILURE = 'CORE_UPDATE_ACTIVE_CAR_FAILURE';

var CORE_GET_CAR_RESERVE_BY_ID_REQUEST = 'CORE_GET_CAR_RESERVE_BY_ID_REQUEST';
var CORE_GET_CAR_RESERVE_BY_ID_SUCCESS = 'CORE_GET_CAR_RESERVE_BY_ID_SUCCESS';
var CORE_GET_CAR_RESERVE_BY_ID_FAILURE = 'CORE_GET_CAR_RESERVE_BY_ID_FAILURE';

var CORE_DELETE_CAR_REQUEST = 'CORE_DELETE_CAR_REQUEST';
var CORE_DELETE_CAR_SUCCESS = 'CORE_DELETE_CAR_SUCCESS';
var CORE_DELETE_CAR_FAILURE = 'CORE_DELETE_CAR_FAILURE';

/***/ })

},[440]);


// WEBPACK FOOTER //
// app.5de99409a4f9de4473f3.js